import React, { CSSProperties } from 'react';
import AddDocumentIcon from '@/public/icons/document-add.svg';
import { Box } from '@mui/material';

type P = {
  name: string;
  width?: number;
  height?: number;
  color?: string;
  style?: CSSProperties;
};
const SvgImage = ({ name, width, height, style, color }: P) => {
  switch (name) {
    case 'x_myPage':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M14.6001 0.600098L0.600099 14.6001"
            stroke="black"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M0.600098 0.600098L14.6001 14.6001"
            stroke="black"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'slash':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="4"
          height="12"
          viewBox="0 0 4 12"
          fill="none"
        >
          <path d="M3 0H4L1 12H0L3 0Z" fill="black" />
        </svg>
      );
    case 'voice':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="13"
          viewBox="0 0 10 13"
          fill="none"
        >
          <path
            d="M4.58219 12.0002V10.2611C3.60704 10.1741 2.67981 9.78307 1.93408 9.13802C1.13606 8.44774 0.595596 7.50995 0.397624 6.4777L0.36263 6.27018L0.359375 6.18555C0.370476 5.99213 0.515848 5.82644 0.715006 5.79736C0.914436 5.76834 1.10184 5.88579 1.16748 6.06836L1.18783 6.14974L1.21631 6.32064C1.37906 7.16927 1.82326 7.94065 2.47933 8.50814C3.17912 9.11335 4.07366 9.44645 4.99886 9.44645L5.17139 9.44238C6.03475 9.40363 6.86223 9.07572 7.51839 8.50814C8.21819 7.9028 8.67663 7.06538 8.8099 6.14974C8.84309 5.92214 9.05428 5.76431 9.2819 5.79736C9.50962 5.83051 9.66742 6.04246 9.63428 6.27018C9.47213 7.38373 8.91465 8.40179 8.06364 9.13802C7.31803 9.78297 6.39051 10.174 5.41553 10.2611V12.0002C5.41553 12.2302 5.22887 12.4167 4.99886 12.4168C4.76874 12.4168 4.58219 12.2303 4.58219 12.0002Z"
            fill="#888D96"
          />
          <path
            d="M6.58708 7.18815C7.00812 6.76711 7.2446 6.19586 7.24463 5.60042V3.16227C7.24463 2.5668 7.00814 1.99561 6.58708 1.57454C6.21865 1.20619 5.73546 0.979398 5.22152 0.928385L4.99935 0.916992C4.4041 0.917089 3.83339 1.15369 3.41243 1.57454C2.99137 1.99561 2.75488 2.5668 2.75488 3.16227V5.60042C2.75491 6.19586 2.99139 6.76711 3.41243 7.18815C3.83339 7.60896 4.40414 7.84561 4.99935 7.8457C5.59471 7.8457 6.16603 7.60907 6.58708 7.18815Z"
            stroke="#888D96"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'export':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M8.75 5H5V15H15V11.25"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.25 5L15 5L15 8.75"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.7139 5L9.99982 9.71405"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'record_clip':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M8.12463 3.49793L3.79662 7.82594C3.24248 8.38008 2.9416 9.14207 2.96031 9.94449C2.97889 10.7467 3.31561 11.5237 3.89611 12.1042C4.47662 12.6847 5.25358 13.0214 6.05583 13.04C6.85823 13.0587 7.62024 12.7578 8.17437 12.2037L12.8755 7.50258C13.2515 7.12657 13.4556 6.60944 13.443 6.06505C13.4303 5.52051 13.2019 4.9934 12.808 4.59948C12.414 4.20555 11.8869 3.97718 11.3424 3.96443C10.798 3.95182 10.2809 4.15594 9.90487 4.53196L5.20375 9.23308C5.00585 9.43098 4.89833 9.70309 4.90513 9.98975C4.91176 10.2763 5.03194 10.5537 5.23929 10.761C5.44663 10.9684 5.72404 11.0886 6.01056 11.0952C6.29723 11.102 6.56934 10.9945 6.76724 10.7966L11.0952 6.46855"
            stroke="#888D96"
            strokeWidth="0.8"
            strokeLinecap="round"
          />
        </svg>
      );
    case 'video':
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            width="48"
            height="48"
            rx="4.8"
            fill="url(#pattern0_2565_14033)"
          />
          <g opacity="0.8">
            <circle opacity="0.8" cx="24" cy="24" r="14" fill="black" />
            <path
              d="M29.1489 23.2422C29.7323 23.579 29.7323 24.421 29.1489 24.7578L22.0816 28.8381C21.4983 29.1749 20.7691 28.7539 20.7691 28.0803L20.7691 19.9197C20.7691 19.2461 21.4983 18.8251 22.0816 19.1619L29.1489 23.2422Z"
              fill="white"
            />
          </g>
          <defs>
            <pattern
              id="pattern0_2565_14033"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image0_2565_14033"
                transform="scale(0.00102564)"
              />
            </pattern>
            <image
              id="image0_2565_14033"
              width="975"
              height="975"
              preserveAspectRatio="none"
              xlinkHref="data:image/png;base64,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"
            />
          </defs>
        </svg>
      );

    case 'stop':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
        >
          <rect
            width="12"
            height="12"
            rx="3"
            transform="matrix(1 0 0 -1 0 12)"
            fill="#C77AC4"
          />
        </svg>
      );
    case 'pause':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="14"
          viewBox="0 0 12 14"
          fill="none"
        >
          <path
            d="M1.83398 12.6601V1.33008M10.1673 12.6601V1.33008"
            stroke="#C77AC4"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'play':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="14"
          viewBox="0 0 12 14"
          fill="none"
        >
          <path
            d="M10.5903 6.17349C11.6531 6.76576 11.657 7.51082 10.5903 8.18042L2.34821 13.7391C1.3126 14.2918 0.609247 13.9654 0.535414 12.7696L0.50044 1.13542C0.477124 0.0338685 1.3845 -0.277357 2.24912 0.250783L10.5903 6.17349Z"
            fill="#C77AC4"
          />
        </svg>
      );
    case 'excel':
      return (
        <svg
          width="28"
          height="31"
          viewBox="0 0 28 31"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.75488 3.5C2.75488 2.80964 3.31453 2.25 4.00488 2.25H14.0049H19.0049L25.2549 9.4375V16.625V29.75C25.2549 30.4404 24.6952 31 24.0049 31H4.00488C3.31453 31 2.75488 30.4404 2.75488 29.75V3.5Z"
            fill="#E7E9EC"
          />
          <path
            d="M6.50488 0.6875H21.3633L27.4424 7.67871V27.875C27.4424 28.3928 27.0226 28.8125 26.5049 28.8125H6.50488C5.98712 28.8125 5.56738 28.3928 5.56738 27.875V1.625C5.56738 1.10723 5.98712 0.6875 6.50488 0.6875Z"
            fill="#F3F5F6"
            stroke="#888D96"
            strokeWidth="0.625"
          />
          <path
            d="M5.87988 18.5H24.3174V21.625C24.3174 22.3154 23.7577 22.875 23.0674 22.875H5.87988V18.5Z"
            fill="#B7BBC2"
          />
          <rect
            x="0.567383"
            y="10.375"
            width="23.75"
            height="11.25"
            rx="0.9375"
            fill="#21A366"
          />
          <path
            d="M18.2944 13.0947L19.459 15.043H19.5029L20.6821 13.0947H21.7661L20.1328 15.7461L21.7954 18.3975H20.6895L19.5029 16.4639H19.459L18.2725 18.3975H17.1738L18.8511 15.7461L17.1958 13.0947H18.2944Z"
            fill="white"
          />
          <path
            d="M15.7188 14.5522C15.6711 14.0945 15.2866 13.8308 14.7153 13.8345C14.1111 13.8308 13.7522 14.1238 13.7485 14.5229C13.7449 14.9697 14.2173 15.1528 14.6567 15.2554L15.1548 15.3872C15.9458 15.5703 16.7075 15.9878 16.7075 16.9106C16.7075 17.8408 15.9714 18.478 14.7007 18.478C13.4666 18.478 12.6829 17.8848 12.6426 16.8374H13.5801C13.624 17.3904 14.0891 17.6614 14.6934 17.665C15.3196 17.6614 15.7517 17.3574 15.7554 16.9033C15.7517 16.4858 15.3708 16.3101 14.7959 16.1636L14.1953 16.0098C13.3237 15.7827 12.7817 15.3433 12.7817 14.5815C12.7817 13.644 13.613 13.0215 14.73 13.0215C15.8542 13.0215 16.6196 13.655 16.6343 14.5522H15.7188Z"
            fill="white"
          />
          <path
            d="M8.77539 18.3975V13.0947H9.72754V17.5918H12.0713V18.3975H8.77539Z"
            fill="white"
          />
          <path
            d="M4.62256 13.0947L5.78711 15.043H5.83105L7.01025 13.0947H8.09424L6.46094 15.7461L8.12354 18.3975H7.01758L5.83105 16.4639H5.78711L4.60059 18.3975H3.50195L5.1792 15.7461L3.52393 13.0947H4.62256Z"
            fill="white"
          />
          <path
            d="M21.5049 0.375V7.5625H27.7549L21.5049 0.375Z"
            fill="#888D96"
          />
        </svg>
      );
    case 'uuid':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="8"
          viewBox="0 0 18 8"
          fill="none"
        >
          <rect y="3.34595" width="18" height="4" fill="#E7E9EC" />
          <path
            d="M14.875 5.95703H13.0732V0.654297H14.9043C16.4863 0.654297 17.4421 1.64673 17.4458 3.29834C17.4421 4.95728 16.4863 5.95703 14.875 5.95703ZM14.0254 5.12939H14.8237C15.9333 5.13306 16.4937 4.52148 16.4937 3.29834C16.4937 2.08252 15.9333 1.47827 14.853 1.48193H14.0254V5.12939Z"
            fill="black"
          />
          <path
            d="M12.084 0.654297V5.95703H11.1318V0.654297H12.084Z"
            fill="black"
          />
          <path
            d="M9.19092 0.654297H10.1504V4.11865C10.1467 5.25757 9.28979 6.0376 7.99707 6.0376C6.69702 6.0376 5.84741 5.25757 5.84375 4.11865V0.654297H6.7959V4.03809C6.79956 4.70825 7.26465 5.18433 7.99707 5.18799C8.72949 5.18433 9.19092 4.70825 9.19092 4.03809V0.654297Z"
            fill="black"
          />
          <path
            d="M3.90283 0.654297H4.8623V4.11865C4.85864 5.25757 4.00171 6.0376 2.70898 6.0376C1.40894 6.0376 0.559326 5.25757 0.555664 4.11865V0.654297H1.50781V4.03809C1.51147 4.70825 1.97656 5.18433 2.70898 5.18799C3.44141 5.18433 3.90283 4.70825 3.90283 4.03809V0.654297Z"
            fill="black"
          />
        </svg>
      );
    case 'clear':
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="8" cy="8" r="8" fill="#E8E8E8" />
          <path
            d="M10.3994 5.59961L5.59942 10.3997"
            stroke="white"
            strokeWidth="0.600008"
            strokeLinecap="square"
            strokeLinejoin="round"
          />
          <path
            d="M5.59961 5.59961L10.3996 10.3997"
            stroke="white"
            strokeWidth="0.600008"
            strokeLinecap="square"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'share':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
        >
          <path
            d="M8.6701 2.33816C8.88693 2.70082 9.28937 2.94444 9.75 2.94444C10.4404 2.94444 11 2.39724 11 1.72222C11 1.04721 10.4404 0.5 9.75 0.5C9.05964 0.5 8.5 1.04721 8.5 1.72222C8.5 1.94684 8.56197 2.1573 8.6701 2.33816ZM8.6701 2.33816L3.3299 5.38406M3.3299 5.38406C3.11307 5.0214 2.71063 4.77778 2.25 4.77778C1.55964 4.77778 1 5.32499 1 6C1 6.67501 1.55964 7.22222 2.25 7.22222C2.71063 7.22222 3.11307 6.9786 3.3299 6.61594M3.3299 5.38406C3.43803 5.56492 3.5 5.77538 3.5 6C3.5 6.22462 3.43803 6.43508 3.3299 6.61594M3.3299 6.61594L8.6701 9.66184M8.6701 9.66184C8.88693 9.29918 9.28937 9.05556 9.75 9.05556C10.4404 9.05556 11 9.60276 11 10.2778C11 10.9528 10.4404 11.5 9.75 11.5C9.05964 11.5 8.5 10.9528 8.5 10.2778C8.5 10.0532 8.56197 9.8427 8.6701 9.66184Z"
            stroke={color || '#0066CC'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'record_file':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="6"
          height="10"
          viewBox="0 0 6 10"
          fill="none"
        >
          <path
            d="M5.49902 3.6378L5.49902 2.99477C5.49902 2.66651 5.43437 2.34147 5.30875 2.0382C5.18313 1.73492 4.99901 1.45936 4.7669 1.22725C4.53479 0.995135 4.25923 0.811012 3.95597 0.685392C3.6527 0.559773 3.32766 0.495117 2.9994 0.495117C2.67115 0.495117 2.34611 0.559773 2.04284 0.685392C1.73957 0.811011 1.46401 0.995135 1.2319 1.22725C0.99979 1.45936 0.815669 1.73492 0.690052 2.0382C0.564434 2.34147 0.499779 2.66651 0.499779 2.99477L0.499779 3.6378"
            stroke="#888D96"
            strokeWidth="0.8"
            strokeLinecap="round"
          />
          <path
            d="M0.500977 6.36235L0.500977 7.00523C0.500977 7.33349 0.565631 7.65853 0.691249 7.9618C0.816867 8.26508 1.00099 8.54064 1.2331 8.77275C1.46521 9.00487 1.74077 9.18899 2.04403 9.31461C2.3473 9.44023 2.67234 9.50488 3.0006 9.50488C3.32885 9.50488 3.65389 9.44023 3.95716 9.31461C4.26043 9.18899 4.53599 9.00487 4.7681 8.77275C5.00021 8.54064 5.18433 8.26508 5.30995 7.9618C5.43557 7.65853 5.50022 7.33349 5.50022 7.00523L5.50022 6.36235"
            stroke="#888D96"
            strokeWidth="0.8"
            strokeLinecap="round"
          />
          <path
            d="M3 3.5L3 6.49959"
            stroke="#888D96"
            strokeWidth="0.8"
            strokeLinecap="round"
          />
        </svg>
      );
    case 'record_people':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M12.8016 9.125C13.6464 9.75626 14.4016 11.3456 14.4016 12.325C14.4016 12.6301 14.179 12.8774 13.9044 12.8774H13.6016M10.4016 6.53751C10.9481 6.22134 11.3158 5.6304 11.3158 4.95357C11.3158 4.27674 10.9481 3.6858 10.4016 3.36963M2.09874 12.8774H10.8568C11.1313 12.8774 11.3539 12.6301 11.3539 12.325C11.3539 10.4072 9.75177 8.85259 6.47775 8.85259C3.20374 8.85259 1.60156 10.4072 1.60156 12.325C1.60156 12.6301 1.82416 12.8774 2.09874 12.8774ZM8.30632 4.95357C8.30632 5.96346 7.48764 6.78214 6.47775 6.78214C5.46786 6.78214 4.64918 5.96346 4.64918 4.95357C4.64918 3.94368 5.46786 3.125 6.47775 3.125C7.48764 3.125 8.30632 3.94368 8.30632 4.95357Z"
            stroke="#888D96"
            strokeLinecap="round"
          />
        </svg>
      );
    case 'record_calendar':
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            width="8.66529"
            height="2.26745"
            transform="matrix(1 0 0 -1 3.66699 6.021)"
            stroke="#888D96"
            strokeLinejoin="round"
          />
          <rect
            x="3.66699"
            y="6.021"
            width="8.66529"
            height="6.62994"
            stroke="#888D96"
            strokeLinejoin="round"
          />
          <path
            d="M5.79199 2.77148L5.79199 4.66211"
            stroke="#888D96"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.209 2.77148L10.209 4.66211"
            stroke="#888D96"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'nfc':
      return (
        <svg
          fill="#000000"
          viewBox="-7 0 32 32"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <title>nfc</title>
            <path d="M13.88 24.96h-4.92c-1.4 0-2.52-0.44-3.32-1.28-1.48-1.52-1.4-3.8-1.4-3.88v-9.28c0-0.32 0.2-0.64 0.48-0.76 0.32-0.12 0.64-0.080 0.92 0.12l5.040 4.32c0.36 0.32 0.4 0.84 0.080 1.2s-0.84 0.4-1.2 0.080l-3.64-3.12v7.48c0 0.040-0.040 1.68 0.92 2.68 0.52 0.52 1.2 0.76 2.12 0.76h4.88c1.32 0 2.4-1.080 2.4-2.4v-9.76c0-1.040-0.68-1.96-1.68-2.28-0.44-0.16-0.68-0.6-0.56-1.080s0.64-0.68 1.080-0.56c1.72 0.56 2.88 2.12 2.88 3.92v9.76c0 2.28-1.84 4.080-4.080 4.080zM3.96 24.24c0.16-0.44-0.12-0.92-0.56-1.080-1-0.32-1.68-1.24-1.68-2.28v-9.76c0-1.32 1.080-2.4 2.4-2.4h4.88c0.92 0 1.6 0.24 2.12 0.76 0.96 1 0.92 2.64 0.92 2.68v7.48l-3.64-3.12c-0.36-0.32-0.88-0.28-1.2 0.080s-0.28 0.88 0.080 1.2l5.040 4.32c0.24 0.2 0.6 0.28 0.92 0.12 0.32-0.12 0.48-0.44 0.48-0.76v-9.28c0-0.080 0.080-2.36-1.4-3.88-0.84-0.84-1.96-1.28-3.32-1.28h-4.92c-2.24 0-4.080 1.8-4.080 4.080v9.76c0 1.8 1.16 3.36 2.88 3.92 0.080 0.040 0.16 0.040 0.24 0.040 0.36 0 0.72-0.24 0.84-0.6z"></path>
          </g>
        </svg>
      );
    case 'download':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
        >
          <path
            d="M1 13H13"
            stroke="#888D96"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.00098 8.99988V1"
            stroke="#888D96"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.00098 8.99976L11 5.7998"
            stroke="#888D96"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.99902 8.99976L3 5.7998"
            stroke="#888D96"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'audio_wave':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M4 15V9M12 20V4M8 17V7M20 9V15M16 7L16 17"
            stroke="#C77AC4"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'audio':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="16"
          viewBox="0 0 12 16"
          fill="none"
        >
          <path
            d="M5.47774 14.5002V12.3263C4.2588 12.2176 3.09977 11.7288 2.1676 10.9225C1.17008 10.0597 0.494494 8.88744 0.24703 7.59713L0.203288 7.33773L0.199219 7.23194C0.213095 6.99016 0.39481 6.78305 0.643758 6.74671C0.893045 6.71042 1.1273 6.85724 1.20935 7.08545L1.23478 7.18718L1.27039 7.4008C1.47382 8.46159 2.02908 9.42581 2.84916 10.1352C3.7239 10.8917 4.84207 11.3081 5.99858 11.3081L6.21423 11.303C7.29344 11.2545 8.32779 10.8446 9.14799 10.1352C10.0227 9.3785 10.5958 8.33173 10.7624 7.18718C10.8039 6.90267 11.0678 6.70539 11.3524 6.74671C11.637 6.78813 11.8343 7.05308 11.7928 7.33773C11.5902 8.72966 10.8933 10.0022 9.82955 10.9225C8.89754 11.7287 7.73814 12.2175 6.51941 12.3263V14.5002C6.51941 14.7878 6.28608 15.0209 5.99858 15.021C5.71093 15.021 5.47774 14.7879 5.47774 14.5002Z"
            fill="#C77AC4"
          />
          <path
            d="M7.9836 8.48494C8.5099 7.95864 8.80551 7.24458 8.80554 6.50028V3.4526C8.80554 2.70825 8.50993 1.99427 7.9836 1.46794C7.52307 1.0075 6.91908 0.724003 6.27665 0.660238L5.99894 0.645996C5.25488 0.646118 4.5415 0.941873 4.0153 1.46794C3.48897 1.99427 3.19336 2.70825 3.19336 3.4526V6.50028C3.19339 7.24458 3.489 7.95864 4.0153 8.48494C4.54149 9.01095 5.25493 9.30676 5.99894 9.30688C6.74315 9.30688 7.4573 9.01109 7.9836 8.48494Z"
            fill="#C77AC4"
            stroke="#C77AC4"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'farm_graph_0':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="240"
          height="120"
          viewBox="0 0 240 120"
          fill="none"
        >
          <g opacity="0.4" clipPath="url(#clip0_5093_3242)">
            <mask id="path-1-inside-1_5093_3242" fill="white">
              <path d="M6 120C2.68629 120 -0.0156487 117.312 0.149966 114.002C0.83601 100.293 3.87014 86.7872 9.13446 74.078C15.165 59.5189 24.0042 46.2902 35.1472 35.1472C46.2902 24.0041 59.5189 15.165 74.078 9.13445C88.6371 3.10389 104.241 -2.06649e-06 120 0C135.759 2.0665e-06 151.363 3.1039 165.922 9.13446C180.481 15.165 193.71 24.0042 204.853 35.1472C215.996 46.2902 224.835 59.5189 230.866 74.078C236.13 86.7872 239.164 100.293 239.85 114.002C240.016 117.312 237.314 120 234 120C230.686 120 228.017 117.312 227.833 114.003C227.159 101.87 224.44 89.9233 219.779 78.6702C214.351 65.567 206.396 53.6612 196.368 43.6325C186.339 33.6038 174.433 25.6485 161.33 20.221C148.227 14.7935 134.183 12 120 12C105.817 12 91.7734 14.7935 78.6702 20.221C65.567 25.6485 53.6612 33.6037 43.6325 43.6325C33.6037 53.6612 25.6485 65.567 20.221 78.6702C15.5598 89.9232 12.8414 101.87 12.1666 114.003C11.9826 117.312 9.31371 120 6 120Z" />
            </mask>
            <path
              d="M6 120C2.68629 120 -0.0156487 117.312 0.149966 114.002C0.83601 100.293 3.87014 86.7872 9.13446 74.078C15.165 59.5189 24.0042 46.2902 35.1472 35.1472C46.2902 24.0041 59.5189 15.165 74.078 9.13445C88.6371 3.10389 104.241 -2.06649e-06 120 0C135.759 2.0665e-06 151.363 3.1039 165.922 9.13446C180.481 15.165 193.71 24.0042 204.853 35.1472C215.996 46.2902 224.835 59.5189 230.866 74.078C236.13 86.7872 239.164 100.293 239.85 114.002C240.016 117.312 237.314 120 234 120C230.686 120 228.017 117.312 227.833 114.003C227.159 101.87 224.44 89.9233 219.779 78.6702C214.351 65.567 206.396 53.6612 196.368 43.6325C186.339 33.6038 174.433 25.6485 161.33 20.221C148.227 14.7935 134.183 12 120 12C105.817 12 91.7734 14.7935 78.6702 20.221C65.567 25.6485 53.6612 33.6037 43.6325 43.6325C33.6037 53.6612 25.6485 65.567 20.221 78.6702C15.5598 89.9232 12.8414 101.87 12.1666 114.003C11.9826 117.312 9.31371 120 6 120Z"
              fill="#D1D8E2"
              stroke="white"
              strokeWidth="2"
              mask="url(#path-1-inside-1_5093_3242)"
            />
          </g>
          <defs>
            <clipPath id="clip0_5093_3242">
              <rect width="240" height="120" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'farm_graph_25':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="240"
          height="120"
          viewBox="0 0 240 120"
          fill="none"
        >
          <g opacity="0.4" clipPath="url(#clip0_5079_7293)">
            <mask id="path-1-inside-1_5079_7293" fill="white">
              <path d="M6 120C2.68629 120 -0.0156487 117.312 0.149966 114.002C0.83601 100.293 3.87014 86.7872 9.13446 74.078C15.165 59.5189 24.0042 46.2902 35.1472 35.1472C46.2902 24.0041 59.5189 15.165 74.078 9.13445C88.6371 3.10389 104.241 -2.06649e-06 120 0C135.759 2.0665e-06 151.363 3.1039 165.922 9.13446C180.481 15.165 193.71 24.0042 204.853 35.1472C215.996 46.2902 224.835 59.5189 230.866 74.078C236.13 86.7872 239.164 100.293 239.85 114.002C240.016 117.312 237.314 120 234 120C230.686 120 228.017 117.312 227.833 114.003C227.159 101.87 224.44 89.9233 219.779 78.6702C214.351 65.567 206.396 53.6612 196.368 43.6325C186.339 33.6038 174.433 25.6485 161.33 20.221C148.227 14.7935 134.183 12 120 12C105.817 12 91.7734 14.7935 78.6702 20.221C65.567 25.6485 53.6612 33.6037 43.6325 43.6325C33.6037 53.6612 25.6485 65.567 20.221 78.6702C15.5598 89.9232 12.8414 101.87 12.1666 114.003C11.9826 117.312 9.31371 120 6 120Z" />
            </mask>
            <path
              d="M6 120C2.68629 120 -0.0156487 117.312 0.149966 114.002C0.83601 100.293 3.87014 86.7872 9.13446 74.078C15.165 59.5189 24.0042 46.2902 35.1472 35.1472C46.2902 24.0041 59.5189 15.165 74.078 9.13445C88.6371 3.10389 104.241 -2.06649e-06 120 0C135.759 2.0665e-06 151.363 3.1039 165.922 9.13446C180.481 15.165 193.71 24.0042 204.853 35.1472C215.996 46.2902 224.835 59.5189 230.866 74.078C236.13 86.7872 239.164 100.293 239.85 114.002C240.016 117.312 237.314 120 234 120C230.686 120 228.017 117.312 227.833 114.003C227.159 101.87 224.44 89.9233 219.779 78.6702C214.351 65.567 206.396 53.6612 196.368 43.6325C186.339 33.6038 174.433 25.6485 161.33 20.221C148.227 14.7935 134.183 12 120 12C105.817 12 91.7734 14.7935 78.6702 20.221C65.567 25.6485 53.6612 33.6037 43.6325 43.6325C33.6037 53.6612 25.6485 65.567 20.221 78.6702C15.5598 89.9232 12.8414 101.87 12.1666 114.003C11.9826 117.312 9.31371 120 6 120Z"
              fill="#D1D8E2"
              stroke="white"
              strokeWidth="2"
              mask="url(#path-1-inside-1_5079_7293)"
            />
            <mask id="path-2-inside-2_5079_7293" fill="white">
              <path d="M6 120C2.68629 120 -0.0156487 117.312 0.149966 114.002C0.83601 100.293 3.87014 86.7872 9.13446 74.078C14.3988 61.3688 21.8033 49.6733 31.0123 39.4941C33.2354 37.0368 37.0467 37.0467 39.3898 39.3898C41.733 41.733 41.7192 45.5212 39.5098 47.9908C31.4077 57.0471 24.8822 67.4171 20.221 78.6702C15.5598 89.9232 12.8414 101.87 12.1666 114.003C11.9826 117.312 9.31371 120 6 120Z" />
            </mask>
            <path
              d="M6 120C2.68629 120 -0.0156487 117.312 0.149966 114.002C0.83601 100.293 3.87014 86.7872 9.13446 74.078C14.3988 61.3688 21.8033 49.6733 31.0123 39.4941C33.2354 37.0368 37.0467 37.0467 39.3898 39.3898C41.733 41.733 41.7192 45.5212 39.5098 47.9908C31.4077 57.0471 24.8822 67.4171 20.221 78.6702C15.5598 89.9232 12.8414 101.87 12.1666 114.003C11.9826 117.312 9.31371 120 6 120Z"
              fill="#0066CC"
              stroke="white"
              strokeWidth="2"
              mask="url(#path-2-inside-2_5079_7293)"
            />
          </g>
          <defs>
            <clipPath id="clip0_5079_7293">
              <rect width="240" height="120" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'farm_graph_50':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="240"
          height="120"
          viewBox="0 0 240 120"
          fill="none"
        >
          <g opacity="0.4" clipPath="url(#clip0_5079_7405)">
            <mask id="path-1-inside-1_5079_7405" fill="white">
              <path d="M6 120C2.68629 120 -0.0156487 117.312 0.149966 114.002C0.83601 100.293 3.87014 86.7872 9.13446 74.078C15.165 59.5189 24.0042 46.2902 35.1472 35.1472C46.2902 24.0041 59.5189 15.165 74.078 9.13445C88.6371 3.10389 104.241 -2.06649e-06 120 0C135.759 2.0665e-06 151.363 3.1039 165.922 9.13446C180.481 15.165 193.71 24.0042 204.853 35.1472C215.996 46.2902 224.835 59.5189 230.866 74.078C236.13 86.7872 239.164 100.293 239.85 114.002C240.016 117.312 237.314 120 234 120C230.686 120 228.017 117.312 227.833 114.003C227.159 101.87 224.44 89.9233 219.779 78.6702C214.351 65.567 206.396 53.6612 196.368 43.6325C186.339 33.6038 174.433 25.6485 161.33 20.221C148.227 14.7935 134.183 12 120 12C105.817 12 91.7734 14.7935 78.6702 20.221C65.567 25.6485 53.6612 33.6037 43.6325 43.6325C33.6037 53.6612 25.6485 65.567 20.221 78.6702C15.5598 89.9232 12.8414 101.87 12.1666 114.003C11.9826 117.312 9.31371 120 6 120Z" />
            </mask>
            <path
              d="M6 120C2.68629 120 -0.0156487 117.312 0.149966 114.002C0.83601 100.293 3.87014 86.7872 9.13446 74.078C15.165 59.5189 24.0042 46.2902 35.1472 35.1472C46.2902 24.0041 59.5189 15.165 74.078 9.13445C88.6371 3.10389 104.241 -2.06649e-06 120 0C135.759 2.0665e-06 151.363 3.1039 165.922 9.13446C180.481 15.165 193.71 24.0042 204.853 35.1472C215.996 46.2902 224.835 59.5189 230.866 74.078C236.13 86.7872 239.164 100.293 239.85 114.002C240.016 117.312 237.314 120 234 120C230.686 120 228.017 117.312 227.833 114.003C227.159 101.87 224.44 89.9233 219.779 78.6702C214.351 65.567 206.396 53.6612 196.368 43.6325C186.339 33.6038 174.433 25.6485 161.33 20.221C148.227 14.7935 134.183 12 120 12C105.817 12 91.7734 14.7935 78.6702 20.221C65.567 25.6485 53.6612 33.6037 43.6325 43.6325C33.6037 53.6612 25.6485 65.567 20.221 78.6702C15.5598 89.9232 12.8414 101.87 12.1666 114.003C11.9826 117.312 9.31371 120 6 120Z"
              fill="#D1D8E2"
              stroke="white"
              strokeWidth="2"
              mask="url(#path-1-inside-1_5079_7405)"
            />
            <mask id="path-2-inside-2_5079_7405" fill="white">
              <path d="M6 120C2.68629 120 -0.0156615 117.312 0.149833 114.002C1.63208 84.3601 14.0606 56.2338 35.1472 35.1472C56.2338 14.0605 84.3601 1.63208 114.002 0.149833C117.312 -0.0156616 120 2.68629 120 6C120 9.31371 117.311 11.9826 114.002 12.1665C87.545 13.637 62.4682 24.7967 43.6325 43.6325C24.7967 62.4682 13.637 87.545 12.1665 114.002C11.9826 117.311 9.31371 120 6 120Z" />
            </mask>
            <path
              d="M6 120C2.68629 120 -0.0156615 117.312 0.149833 114.002C1.63208 84.3601 14.0606 56.2338 35.1472 35.1472C56.2338 14.0605 84.3601 1.63208 114.002 0.149833C117.312 -0.0156616 120 2.68629 120 6C120 9.31371 117.311 11.9826 114.002 12.1665C87.545 13.637 62.4682 24.7967 43.6325 43.6325C24.7967 62.4682 13.637 87.545 12.1665 114.002C11.9826 117.311 9.31371 120 6 120Z"
              fill="#43B16F"
              stroke="white"
              strokeWidth="2"
              mask="url(#path-2-inside-2_5079_7405)"
            />
          </g>
          <defs>
            <clipPath id="clip0_5079_7405">
              <rect width="240" height="120" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'farm_graph_75':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="240"
          height="120"
          viewBox="0 0 240 120"
          fill="none"
        >
          <g opacity="0.4" clipPath="url(#clip0_5079_7349)">
            <mask id="path-1-inside-1_5079_7349" fill="white">
              <path d="M6 120C2.68629 120 -0.0156487 117.312 0.149966 114.002C0.83601 100.293 3.87014 86.7872 9.13446 74.078C15.165 59.5189 24.0042 46.2902 35.1472 35.1472C46.2902 24.0041 59.5189 15.165 74.078 9.13445C88.6371 3.10389 104.241 -2.06649e-06 120 0C135.759 2.0665e-06 151.363 3.1039 165.922 9.13446C180.481 15.165 193.71 24.0042 204.853 35.1472C215.996 46.2902 224.835 59.5189 230.866 74.078C236.13 86.7872 239.164 100.293 239.85 114.002C240.016 117.312 237.314 120 234 120C230.686 120 228.017 117.312 227.833 114.003C227.159 101.87 224.44 89.9233 219.779 78.6702C214.351 65.567 206.396 53.6612 196.368 43.6325C186.339 33.6038 174.433 25.6485 161.33 20.221C148.227 14.7935 134.183 12 120 12C105.817 12 91.7734 14.7935 78.6702 20.221C65.567 25.6485 53.6612 33.6037 43.6325 43.6325C33.6037 53.6612 25.6485 65.567 20.221 78.6702C15.5598 89.9232 12.8414 101.87 12.1666 114.003C11.9826 117.312 9.31371 120 6 120Z" />
            </mask>
            <path
              d="M6 120C2.68629 120 -0.0156487 117.312 0.149966 114.002C0.83601 100.293 3.87014 86.7872 9.13446 74.078C15.165 59.5189 24.0042 46.2902 35.1472 35.1472C46.2902 24.0041 59.5189 15.165 74.078 9.13445C88.6371 3.10389 104.241 -2.06649e-06 120 0C135.759 2.0665e-06 151.363 3.1039 165.922 9.13446C180.481 15.165 193.71 24.0042 204.853 35.1472C215.996 46.2902 224.835 59.5189 230.866 74.078C236.13 86.7872 239.164 100.293 239.85 114.002C240.016 117.312 237.314 120 234 120C230.686 120 228.017 117.312 227.833 114.003C227.159 101.87 224.44 89.9233 219.779 78.6702C214.351 65.567 206.396 53.6612 196.368 43.6325C186.339 33.6038 174.433 25.6485 161.33 20.221C148.227 14.7935 134.183 12 120 12C105.817 12 91.7734 14.7935 78.6702 20.221C65.567 25.6485 53.6612 33.6037 43.6325 43.6325C33.6037 53.6612 25.6485 65.567 20.221 78.6702C15.5598 89.9232 12.8414 101.87 12.1666 114.003C11.9826 117.312 9.31371 120 6 120Z"
              fill="#D1D8E2"
              stroke="white"
              strokeWidth="2"
              mask="url(#path-1-inside-1_5079_7349)"
            />
            <mask id="path-2-inside-2_5079_7349" fill="white">
              <path d="M6 120C2.68629 120 -0.0156484 117.312 0.149947 114.002C1.23214 92.3736 8.15106 71.3995 20.2237 53.3316C33.4094 33.5977 52.1509 18.217 74.078 9.13445C96.0051 0.0519341 120.133 -2.32446 143.411 2.30577C164.723 6.54511 184.447 16.4836 200.506 31.0121C202.963 33.2352 202.953 37.0467 200.61 39.3899C198.267 41.733 194.479 41.7192 192.009 39.5098C177.638 26.6523 160.054 17.8515 141.07 14.0752C120.12 9.90799 98.4046 12.0467 78.6702 20.221C58.9358 28.3953 42.0685 42.2379 30.2013 59.9984C19.4474 76.0927 13.2372 94.7492 12.1666 114.003C11.9826 117.312 9.31371 120 6 120Z" />
            </mask>
            <path
              d="M6 120C2.68629 120 -0.0156484 117.312 0.149947 114.002C1.23214 92.3736 8.15106 71.3995 20.2237 53.3316C33.4094 33.5977 52.1509 18.217 74.078 9.13445C96.0051 0.0519341 120.133 -2.32446 143.411 2.30577C164.723 6.54511 184.447 16.4836 200.506 31.0121C202.963 33.2352 202.953 37.0467 200.61 39.3899C198.267 41.733 194.479 41.7192 192.009 39.5098C177.638 26.6523 160.054 17.8515 141.07 14.0752C120.12 9.90799 98.4046 12.0467 78.6702 20.221C58.9358 28.3953 42.0685 42.2379 30.2013 59.9984C19.4474 76.0927 13.2372 94.7492 12.1666 114.003C11.9826 117.312 9.31371 120 6 120Z"
              fill="#FEAE00"
              stroke="white"
              strokeWidth="2"
              mask="url(#path-2-inside-2_5079_7349)"
            />
          </g>
          <defs>
            <clipPath id="clip0_5079_7349">
              <rect width="240" height="120" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'farm_graph_100':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="240"
          height="120"
          viewBox="0 0 240 120"
          fill="none"
        >
          <g opacity="0.4" clipPath="url(#clip0_5079_7461)">
            <mask id="path-1-inside-1_5079_7461" fill="white">
              <path d="M6 120C2.68629 120 -0.0156487 117.312 0.149966 114.002C0.83601 100.293 3.87014 86.7872 9.13446 74.078C15.165 59.5189 24.0042 46.2902 35.1472 35.1472C46.2902 24.0041 59.5189 15.165 74.078 9.13445C88.6371 3.10389 104.241 -2.06649e-06 120 0C135.759 2.0665e-06 151.363 3.1039 165.922 9.13446C180.481 15.165 193.71 24.0042 204.853 35.1472C215.996 46.2902 224.835 59.5189 230.866 74.078C236.13 86.7872 239.164 100.293 239.85 114.002C240.016 117.312 237.314 120 234 120C230.686 120 228.017 117.312 227.833 114.003C227.159 101.87 224.44 89.9233 219.779 78.6702C214.351 65.567 206.396 53.6612 196.368 43.6325C186.339 33.6038 174.433 25.6485 161.33 20.221C148.227 14.7935 134.183 12 120 12C105.817 12 91.7734 14.7935 78.6702 20.221C65.567 25.6485 53.6612 33.6037 43.6325 43.6325C33.6037 53.6612 25.6485 65.567 20.221 78.6702C15.5598 89.9232 12.8414 101.87 12.1666 114.003C11.9826 117.312 9.31371 120 6 120Z" />
            </mask>
            <path
              d="M6 120C2.68629 120 -0.0156487 117.312 0.149966 114.002C0.83601 100.293 3.87014 86.7872 9.13446 74.078C15.165 59.5189 24.0042 46.2902 35.1472 35.1472C46.2902 24.0041 59.5189 15.165 74.078 9.13445C88.6371 3.10389 104.241 -2.06649e-06 120 0C135.759 2.0665e-06 151.363 3.1039 165.922 9.13446C180.481 15.165 193.71 24.0042 204.853 35.1472C215.996 46.2902 224.835 59.5189 230.866 74.078C236.13 86.7872 239.164 100.293 239.85 114.002C240.016 117.312 237.314 120 234 120C230.686 120 228.017 117.312 227.833 114.003C227.159 101.87 224.44 89.9233 219.779 78.6702C214.351 65.567 206.396 53.6612 196.368 43.6325C186.339 33.6038 174.433 25.6485 161.33 20.221C148.227 14.7935 134.183 12 120 12C105.817 12 91.7734 14.7935 78.6702 20.221C65.567 25.6485 53.6612 33.6037 43.6325 43.6325C33.6037 53.6612 25.6485 65.567 20.221 78.6702C15.5598 89.9232 12.8414 101.87 12.1666 114.003C11.9826 117.312 9.31371 120 6 120Z"
              fill="#D1D8E2"
              stroke="white"
              strokeWidth="2"
              mask="url(#path-1-inside-1_5079_7461)"
            />
            <mask id="path-2-inside-2_5079_7461" fill="white">
              <path d="M6 120C2.68629 120 -0.0156487 117.312 0.149966 114.002C0.83601 100.293 3.87014 86.7872 9.13446 74.078C15.165 59.5189 24.0042 46.2902 35.1472 35.1472C46.2902 24.0041 59.5189 15.165 74.078 9.13445C88.6371 3.10389 104.241 -2.06649e-06 120 0C135.759 2.0665e-06 151.363 3.1039 165.922 9.13446C180.481 15.165 193.71 24.0042 204.853 35.1472C215.996 46.2902 224.835 59.5189 230.866 74.078C236.13 86.7872 239.164 100.293 239.85 114.002C240.016 117.312 237.314 120 234 120C230.686 120 228.017 117.312 227.833 114.003C227.159 101.87 224.44 89.9233 219.779 78.6702C214.351 65.567 206.396 53.6612 196.368 43.6325C186.339 33.6038 174.433 25.6485 161.33 20.221C148.227 14.7935 134.183 12 120 12C105.817 12 91.7734 14.7935 78.6702 20.221C65.567 25.6485 53.6612 33.6037 43.6325 43.6325C33.6037 53.6612 25.6485 65.567 20.221 78.6702C15.5598 89.9232 12.8414 101.87 12.1666 114.003C11.9826 117.312 9.31371 120 6 120Z" />
            </mask>
            <path
              d="M6 120C2.68629 120 -0.0156487 117.312 0.149966 114.002C0.83601 100.293 3.87014 86.7872 9.13446 74.078C15.165 59.5189 24.0042 46.2902 35.1472 35.1472C46.2902 24.0041 59.5189 15.165 74.078 9.13445C88.6371 3.10389 104.241 -2.06649e-06 120 0C135.759 2.0665e-06 151.363 3.1039 165.922 9.13446C180.481 15.165 193.71 24.0042 204.853 35.1472C215.996 46.2902 224.835 59.5189 230.866 74.078C236.13 86.7872 239.164 100.293 239.85 114.002C240.016 117.312 237.314 120 234 120C230.686 120 228.017 117.312 227.833 114.003C227.159 101.87 224.44 89.9233 219.779 78.6702C214.351 65.567 206.396 53.6612 196.368 43.6325C186.339 33.6038 174.433 25.6485 161.33 20.221C148.227 14.7935 134.183 12 120 12C105.817 12 91.7734 14.7935 78.6702 20.221C65.567 25.6485 53.6612 33.6037 43.6325 43.6325C33.6037 53.6612 25.6485 65.567 20.221 78.6702C15.5598 89.9232 12.8414 101.87 12.1666 114.003C11.9826 117.312 9.31371 120 6 120Z"
              fill="#F55060"
              stroke="white"
              strokeWidth="2"
              mask="url(#path-2-inside-2_5079_7461)"
            />
          </g>
          <defs>
            <clipPath id="clip0_5079_7461">
              <rect width="240" height="120" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'takeOut':
      return (
        <svg
          width="33"
          height="32"
          viewBox="0 0 33 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            width="32"
            height="32"
            rx="4"
            fill="#0066CC"
            fillOpacity="0.24"
          />
          <g clipPath="url(#clip0_5107_161100)">
            <path
              d="M25.818 29.3337H24.7307C24.5418 29.3337 24.3835 29.2697 24.2557 29.1417C24.1279 29.0137 24.064 28.8551 24.064 28.666C24.064 28.4769 24.1279 28.3187 24.2557 28.1914C24.3835 28.064 24.5418 28.0004 24.7307 28.0004H25.9307L27.7973 9.84635H16.4333C16.2445 9.84635 16.0861 9.78247 15.9583 9.65469C15.8306 9.52669 15.7667 9.36813 15.7667 9.17902C15.7667 8.98991 15.8306 8.83169 15.9583 8.70435C16.0861 8.5768 16.2445 8.51302 16.4333 8.51302H21.7563V3.84635C21.7563 3.65747 21.8203 3.49913 21.9483 3.37135C22.0763 3.24358 22.2349 3.17969 22.424 3.17969C22.6131 3.17969 22.7714 3.24358 22.8987 3.37135C23.026 3.49913 23.0897 3.65747 23.0897 3.84635V8.51302H28.059C28.3821 8.51302 28.6535 8.62969 28.873 8.86302C29.0928 9.09635 29.1805 9.37458 29.136 9.69769L27.2487 28.1184C27.1991 28.4859 27.0401 28.7804 26.7717 29.0017C26.5035 29.223 26.1856 29.3337 25.818 29.3337Z"
              fill="white"
            />
            <path
              d="M21.2846 25.5519C21.8496 25.8495 22.315 25.7794 22.6807 25.3415C23.0467 24.9037 23.0939 24.4219 22.8224 23.8961L20.8677 20.2305L19.1647 24.4468L21.2846 25.5519ZM15.8569 24.6198H17.9887L20.4821 18.4565C20.6383 18.0712 20.6648 17.7596 20.5619 17.5216C20.459 17.2835 20.2646 17.1062 19.9788 16.9896L17.9335 16.1715C17.6228 16.0416 17.3229 16.0259 17.0339 16.1242C16.7448 16.2226 16.5833 16.4402 16.5492 16.7772L15.8569 24.6198ZM8.48612 24.6198H10.618L9.9257 16.6984C9.89161 16.4324 9.7366 16.2456 9.46067 16.138C9.18473 16.0305 8.87829 16.0416 8.54134 16.1715L6.49611 16.9896C6.18933 17.1193 6.00935 17.3228 5.95617 17.6001C5.90317 17.8774 5.94152 18.1891 6.07122 18.5353L8.48612 24.6198ZM5.19024 25.5519L7.31011 24.4468L5.64658 20.2305L3.65248 23.9748C3.3549 24.5136 3.40535 24.9789 3.80383 25.3709C4.20231 25.7629 4.66444 25.8233 5.19024 25.5519ZM11.6406 24.6198H14.8342L15.6406 15.5068C15.6747 15.1961 15.5969 14.9329 15.4074 14.7171C15.2181 14.5015 14.9549 14.3937 14.618 14.3937H11.8569C11.6026 14.3937 11.361 14.4917 11.1321 14.6877C10.9034 14.8837 10.8041 15.1305 10.8343 15.4281L11.6406 24.6198ZM4.57514 26.7044C3.98219 26.7044 3.4881 26.5015 3.09286 26.0957C2.69762 25.6899 2.5 25.1992 2.5 24.6237C2.5 24.4328 2.52326 24.2457 2.56979 24.0625C2.61632 23.8795 2.6822 23.7008 2.76741 23.5264L5.13527 18.9955C4.90979 18.4054 4.88226 17.8207 5.0527 17.2412C5.22313 16.6617 5.57968 16.2618 6.12235 16.0416L8.16757 15.2236C8.45868 15.099 8.75634 15.0361 9.06057 15.0349C9.36463 15.0335 9.63596 15.1239 9.87457 15.3061C9.92962 14.7725 10.144 14.3166 10.5178 13.9384C10.8914 13.5602 11.3479 13.3711 11.8873 13.3711H14.618C15.1502 13.3711 15.6065 13.5504 15.9867 13.909C16.367 14.2676 16.5977 14.7071 16.679 15.2276C16.8783 15.0361 17.1299 14.9596 17.434 14.9983C17.7382 15.037 18.0293 15.1121 18.3073 15.2236L20.3525 16.0416C20.9032 16.2618 21.2755 16.6585 21.4695 17.2315C21.6634 17.8045 21.6333 18.3754 21.379 18.9443L23.7468 23.4753C23.8228 23.6234 23.8864 23.7721 23.9375 23.9214C23.9887 24.0707 24.0142 24.2261 24.0142 24.3877C24.0142 25.0236 23.7936 25.5686 23.3524 26.0229C22.9113 26.4772 22.3757 26.7044 21.7456 26.7044C21.5917 26.7044 21.445 26.6864 21.3056 26.6502C21.1662 26.6143 21.0268 26.5602 20.8873 26.4881L19.2236 25.6424H7.2393L5.68978 26.4488C5.52071 26.5418 5.3421 26.6077 5.15394 26.6464C4.96577 26.6851 4.77284 26.7044 4.57514 26.7044Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_5107_161100">
              <rect
                width="32"
                height="32"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      );
    case 'food':
      return (
        <svg
          width="33"
          height="32"
          viewBox="0 0 33 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            width="32"
            height="32"
            rx="4"
            fill="#0066CC"
            fillOpacity="0.24"
          />
          <g clipPath="url(#clip0_1536_19739)">
            <path
              d="M12.1667 24.923C12.336 24.923 12.4766 24.867 12.5883 24.755C12.7003 24.6432 12.7563 24.5027 12.7563 24.3333V16.282C13.3854 16.1556 13.9102 15.8646 14.3307 15.409C14.7513 14.9534 14.9617 14.3949 14.9617 13.7333V8.923C14.9617 8.77944 14.912 8.65811 14.8127 8.559C14.7136 8.45989 14.5922 8.41033 14.4487 8.41033C14.3051 8.41033 14.1838 8.45989 14.0847 8.559C13.9856 8.65811 13.936 8.77944 13.936 8.923V13.1793H12.6793V8.923C12.6793 8.77944 12.6298 8.65811 12.5307 8.559C12.4316 8.45989 12.3102 8.41033 12.1667 8.41033C12.0231 8.41033 11.9018 8.45989 11.8027 8.559C11.7036 8.65811 11.654 8.77944 11.654 8.923V13.1793H10.3973V8.923C10.3973 8.77944 10.3478 8.65811 10.2487 8.559C10.1496 8.45989 10.0282 8.41033 9.88467 8.41033C9.74111 8.41033 9.61978 8.45989 9.52067 8.559C9.42133 8.65811 9.37167 8.77944 9.37167 8.923V13.7333C9.37167 14.3949 9.582 14.9534 10.0027 15.409C10.4231 15.8646 10.9479 16.1556 11.577 16.282V24.3333C11.577 24.5027 11.633 24.6432 11.745 24.755C11.8568 24.867 11.9973 24.923 12.1667 24.923ZM20.1667 24.923C20.336 24.923 20.4766 24.867 20.5883 24.755C20.7003 24.6432 20.7563 24.5027 20.7563 24.3333V16.6103C21.4726 16.3401 22.0406 15.8418 22.4603 15.1153C22.8799 14.3889 23.0897 13.5206 23.0897 12.5103C23.0897 11.329 22.8114 10.3503 22.255 9.57433C21.6988 8.79833 21.0027 8.41033 20.1667 8.41033C19.3307 8.41033 18.6346 8.79833 18.0783 9.57433C17.5219 10.3503 17.2437 11.329 17.2437 12.5103C17.2437 13.5206 17.4534 14.3889 17.873 15.1153C18.2928 15.8418 18.8608 16.3401 19.577 16.6103V24.3333C19.577 24.5027 19.633 24.6432 19.745 24.755C19.8568 24.867 19.9973 24.923 20.1667 24.923ZM6.654 28C6.04022 28 5.52778 27.7944 5.11667 27.3833C4.70556 26.9722 4.5 26.4598 4.5 25.846V6.154C4.5 5.54022 4.70556 5.02778 5.11667 4.61667C5.52778 4.20556 6.04022 4 6.654 4H26.346C26.9598 4 27.4722 4.20556 27.8833 4.61667C28.2944 5.02778 28.5 5.54022 28.5 6.154V25.846C28.5 26.4598 28.2944 26.9722 27.8833 27.3833C27.4722 27.7944 26.9598 28 26.346 28H6.654ZM6.654 26.6667H26.346C26.5513 26.6667 26.7394 26.5812 26.9103 26.4103C27.0812 26.2394 27.1667 26.0513 27.1667 25.846V6.154C27.1667 5.94867 27.0812 5.76056 26.9103 5.58967C26.7394 5.41878 26.5513 5.33333 26.346 5.33333H6.654C6.44867 5.33333 6.26056 5.41878 6.08967 5.58967C5.91878 5.76056 5.83333 5.94867 5.83333 6.154V25.846C5.83333 26.0513 5.91878 26.2394 6.08967 26.4103C6.26056 26.5812 6.44867 26.6667 6.654 26.6667Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_1536_19739">
              <rect
                width="32"
                height="32"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      );

    case 'coffee':
      return (
        <svg
          width="33"
          height="32"
          viewBox="0 0 33 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            width="32"
            height="32"
            rx="4"
            fill="#0066CC"
            fillOpacity="0.24"
          />
          <g clipPath="url(#clip0_1536_19730)">
            <path
              d="M7.83366 26.6654C7.64477 26.6654 7.48644 26.6014 7.35866 26.4734C7.23088 26.3454 7.16699 26.1868 7.16699 25.9977C7.16699 25.8086 7.23088 25.6504 7.35866 25.523C7.48644 25.3957 7.64477 25.332 7.83366 25.332H25.167C25.3559 25.332 25.5142 25.396 25.642 25.524C25.7698 25.652 25.8337 25.8106 25.8337 25.9997C25.8337 26.1888 25.7698 26.347 25.642 26.4744C25.5142 26.6017 25.3559 26.6654 25.167 26.6654H7.83366ZM11.3463 21.6397C10.1874 21.6397 9.20121 21.2457 8.38766 20.4577C7.57388 19.6697 7.16699 18.7133 7.16699 17.5884V6.7167C7.16699 6.32514 7.29988 5.99648 7.56566 5.7307C7.83144 5.46492 8.1601 5.33203 8.55166 5.33203H26.244C26.8644 5.33203 27.3957 5.54181 27.8377 5.96136C28.2794 6.38114 28.5003 6.89781 28.5003 7.51136V10.486C28.5003 11.0996 28.2794 11.6163 27.8377 12.036C27.3957 12.4556 26.8644 12.6654 26.244 12.6654H23.5773V17.5884C23.5773 18.7133 23.1704 19.6697 22.3567 20.4577C21.5431 21.2457 20.5568 21.6397 19.3977 21.6397H11.3463ZM11.3463 20.3064H19.3977C20.1803 20.3064 20.8504 20.0393 21.408 19.505C21.9653 18.9708 22.244 18.3285 22.244 17.578V6.66536H8.50033V17.5877C8.50033 18.3386 8.77899 18.9795 9.33633 19.5104C9.89366 20.041 10.5637 20.3064 11.3463 20.3064ZM23.5773 11.332H26.244C26.5004 11.332 26.7183 11.2508 26.8977 11.0884C27.0772 10.9259 27.167 10.7251 27.167 10.486V7.51136C27.167 7.27225 27.0772 7.07148 26.8977 6.90903C26.7183 6.74659 26.5004 6.66536 26.244 6.66536H23.5773V11.332ZM11.3463 20.3064H8.50033H22.244H11.3463Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_1536_19730">
              <rect
                width="32"
                height="32"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      );
    case 'wallet_android':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="174"
          height="48"
          viewBox="0 0 174 48"
          fill="none"
        >
          <g clipPath="url(#clip0_4813_106418)">
            <path
              d="M149.851 0.4375H24.1486C11.1317 0.4375 0.579346 10.9873 0.579346 24.0011C0.579346 37.015 11.1317 47.5648 24.1486 47.5648H149.851C162.868 47.5648 173.421 37.015 173.421 24.0011C173.421 10.9873 162.868 0.4375 149.851 0.4375Z"
              fill="#1F1F1F"
            />
            <path
              d="M49.9001 20.7621H18.4744V15.8352C18.4744 13.1605 20.7808 10.9082 23.5198 10.9082H44.8547C47.5936 10.9082 49.9001 13.1605 49.9001 15.8352V20.7621Z"
              fill="#34A853"
            />
            <path
              d="M49.9001 25.3087H18.4744V20.0723C18.4744 17.2297 20.7808 14.8359 23.5198 14.8359H44.8547C47.5936 14.8359 49.9001 17.2297 49.9001 20.0723V25.3087Z"
              fill="#FBBC04"
            />
            <path
              d="M49.9001 29.6739H18.4744V24.4375C18.4744 21.595 20.7808 19.2012 23.5198 19.2012H44.8547C47.5936 19.2012 49.9001 21.595 49.9001 24.4375V29.6739Z"
              fill="#EA4335"
            />
            <path
              d="M18.4744 22.0276L38.4203 26.5323C40.7163 27.0954 43.2993 26.5323 45.1646 25.1246L49.9001 21.7461V32.3038C49.9001 34.9785 47.6042 37.09 44.8777 37.09H23.4967C20.7703 37.09 18.4744 34.9785 18.4744 32.3038V22.0276Z"
              fill="url(#paint0_linear_4813_106418)"
            />
            <path
              d="M60.5459 18.762L63.6099 10.6387H65.0284L68.1038 18.762H66.7307L65.9817 16.6745H62.668L61.919 18.762H60.5459ZM63.9844 13.0326L63.0879 15.5172H65.5618L64.6653 13.0326L64.3589 12.1022H64.2908L63.9844 13.0326ZM71.2999 18.9435C70.7778 18.9435 70.3051 18.815 69.8813 18.5578C69.4653 18.2931 69.1324 17.93 68.8827 17.4686C68.6406 16.9997 68.5196 16.4665 68.5196 15.8689C68.5196 15.2714 68.6406 14.742 68.8827 14.2806C69.1324 13.8192 69.4653 13.4561 69.8813 13.1914C70.3051 12.9267 70.7778 12.7943 71.2999 12.7943C71.7463 12.7943 72.1283 12.8927 72.446 13.0893C72.7714 13.2859 73.0097 13.5091 73.161 13.7587H73.229L73.161 12.9531V10.6387H74.3752V18.762H73.229V17.9905H73.161C73.0097 18.2401 72.7714 18.4633 72.446 18.6599C72.1283 18.849 71.7463 18.9435 71.2999 18.9435ZM71.4814 17.8203C71.7841 17.8203 72.0678 17.7409 72.3325 17.5821C72.6049 17.4233 72.8205 17.2001 72.9794 16.9127C73.1459 16.6177 73.229 16.2698 73.229 15.8689C73.229 15.4681 73.1459 15.1239 72.9794 14.8365C72.8205 14.5415 72.6049 14.3146 72.3325 14.1558C72.0678 13.9969 71.7841 13.9175 71.4814 13.9175C71.1789 13.9175 70.8952 13.9969 70.6303 14.1558C70.3656 14.3146 70.1499 14.5415 69.9835 14.8365C69.8171 15.1239 69.7338 15.4681 69.7338 15.8689C69.7338 16.2698 69.8171 16.6177 69.9835 16.9127C70.1499 17.2001 70.3656 17.4233 70.6303 17.5821C70.8952 17.7409 71.1789 17.8203 71.4814 17.8203ZM78.2374 18.9435C77.7153 18.9435 77.2425 18.815 76.8188 18.5578C76.4027 18.2931 76.0698 17.93 75.8202 17.4686C75.5781 16.9997 75.457 16.4665 75.457 15.8689C75.457 15.2714 75.5781 14.742 75.8202 14.2806C76.0698 13.8192 76.4027 13.4561 76.8188 13.1914C77.2425 12.9267 77.7153 12.7943 78.2374 12.7943C78.6837 12.7943 79.0658 12.8927 79.3835 13.0893C79.7089 13.2859 79.9472 13.5091 80.0984 13.7587H80.1665L80.0984 12.9531V10.6387H81.3127V18.762H80.1665V17.9905H80.0984C79.9472 18.2401 79.7089 18.4633 79.3835 18.6599C79.0658 18.849 78.6837 18.9435 78.2374 18.9435ZM78.4189 17.8203C78.7216 17.8203 79.0053 17.7409 79.27 17.5821C79.5424 17.4233 79.758 17.2001 79.9169 16.9127C80.0833 16.6177 80.1665 16.2698 80.1665 15.8689C80.1665 15.4681 80.0833 15.1239 79.9169 14.8365C79.758 14.5415 79.5424 14.3146 79.27 14.1558C79.0053 13.9969 78.7216 13.9175 78.4189 13.9175C78.1163 13.9175 77.8326 13.9969 77.5678 14.1558C77.303 14.3146 77.0874 14.5415 76.921 14.8365C76.7545 15.1239 76.6713 15.4681 76.6713 15.8689C76.6713 16.2698 76.7545 16.6177 76.921 16.9127C77.0874 17.2001 77.303 17.4233 77.5678 17.5821C77.8326 17.7409 78.1163 17.8203 78.4189 17.8203ZM86.0177 17.0829V14.0423H85.0078V12.9758H86.0177V11.3421H87.2433V12.9758H88.6623V14.0423H87.2433V16.8219C87.2433 17.1093 87.3001 17.3287 87.4136 17.48C87.5345 17.6312 87.7352 17.7069 88.0155 17.7069C88.1586 17.7069 88.28 17.688 88.3786 17.6502C88.4842 17.6124 88.5898 17.5594 88.6963 17.4913V18.6826C88.5672 18.7356 88.431 18.7771 88.2878 18.8074C88.1438 18.8377 87.9736 18.8528 87.7771 18.8528C87.2396 18.8528 86.8121 18.6977 86.4944 18.3876C86.1766 18.0699 86.0177 17.6351 86.0177 17.0829ZM92.34 18.9435C91.742 18.9435 91.2165 18.8074 90.7626 18.5351C90.3087 18.2628 89.9525 17.896 89.6959 17.4346C89.4383 16.9732 89.31 16.4513 89.31 15.8689C89.31 15.2941 89.4383 14.776 89.6959 14.3146C89.9525 13.8457 90.3087 13.475 90.7626 13.2027C91.2165 12.9305 91.742 12.7943 92.34 12.7943C92.9301 12.7943 93.4521 12.9305 93.906 13.2027C94.36 13.475 94.7152 13.8457 94.9728 14.3146C95.2294 14.776 95.3586 15.2941 95.3586 15.8689C95.3586 16.4513 95.2294 16.9732 94.9728 17.4346C94.7152 17.896 94.36 18.2628 93.906 18.5351C93.4521 18.8074 92.9301 18.9435 92.34 18.9435ZM92.34 17.8203C92.6577 17.8203 92.9528 17.7447 93.2251 17.5934C93.4975 17.4346 93.7166 17.2114 93.8833 16.9241C94.057 16.6291 94.1443 16.2774 94.1443 15.8689C94.1443 15.4605 94.057 15.1125 93.8833 14.8251C93.7166 14.5302 93.4975 14.307 93.2251 14.1558C92.9528 13.9969 92.6577 13.9175 92.34 13.9175C92.0222 13.9175 91.7228 13.9969 91.4435 14.1558C91.1711 14.307 90.9476 14.5302 90.7739 14.8251C90.6072 15.1125 90.5243 15.4605 90.5243 15.8689C90.5243 16.2774 90.6072 16.6291 90.7739 16.9241C90.9476 17.2114 91.1711 17.4346 91.4435 17.5934C91.7228 17.7447 92.0222 17.8203 92.34 17.8203Z"
              fill="white"
            />
            <path
              d="M66.6082 36.455C65.8464 36.455 65.1292 36.3165 64.4564 36.0396C63.7936 35.7627 63.2049 35.3769 62.6904 34.8824C62.176 34.3779 61.7704 33.7894 61.4736 33.1168C61.1866 32.4344 61.0432 31.6975 61.0432 30.9062C61.0432 30.1149 61.1866 29.383 61.4736 28.7104C61.7704 28.028 62.171 27.4395 62.6756 26.9449C63.19 26.4405 63.7836 26.0498 64.4564 25.7728C65.1292 25.4959 65.8464 25.3574 66.6082 25.3574C67.4194 25.3574 68.1664 25.5008 68.849 25.7877C69.5415 26.0745 70.1203 26.4751 70.5853 26.9894L69.4574 28.1021C69.1112 27.7164 68.6956 27.4197 68.2109 27.212C67.736 27.0043 67.2018 26.9004 66.6082 26.9004C65.9057 26.9004 65.2578 27.0686 64.6642 27.4048C64.0706 27.7312 63.5907 28.1961 63.2247 28.7995C62.8685 29.3929 62.6904 30.0952 62.6904 30.9062C62.6904 31.7172 62.8735 32.4245 63.2395 33.0278C63.6055 33.6213 64.0854 34.0862 64.679 34.4224C65.2726 34.7488 65.9206 34.912 66.623 34.912C67.2661 34.912 67.8498 34.7933 68.3741 34.556C68.8985 34.3087 69.3189 33.9625 69.6355 33.5174C69.962 33.0723 70.1599 32.5382 70.2291 31.9151H66.5933V30.476H71.7576C71.817 30.743 71.8467 31.0249 71.8467 31.3216V31.3365C71.8467 32.3652 71.6191 33.2652 71.164 34.0367C70.7188 34.7983 70.1005 35.3918 69.309 35.8171C68.5176 36.2423 67.6173 36.455 66.6082 36.455ZM76.625 36.455C75.8434 36.455 75.1559 36.277 74.5623 35.9209C73.9687 35.5648 73.5037 35.0851 73.1673 34.4818C72.8309 33.8785 72.6628 33.196 72.6628 32.4344C72.6628 31.6827 72.8309 31.0051 73.1673 30.4018C73.5037 29.7885 73.9687 29.3039 74.5623 28.9478C75.1559 28.5917 75.8434 28.4137 76.625 28.4137C77.3967 28.4137 78.0793 28.5917 78.6729 28.9478C79.2665 29.3039 79.7315 29.7885 80.0679 30.4018C80.4042 31.0051 80.5725 31.6827 80.5725 32.4344C80.5725 33.196 80.4042 33.8785 80.0679 34.4818C79.7315 35.0851 79.2665 35.5648 78.6729 35.9209C78.0793 36.277 77.3967 36.455 76.625 36.455ZM76.625 34.9862C77.0406 34.9862 77.4264 34.8873 77.7826 34.6895C78.1387 34.4818 78.4256 34.19 78.6433 33.8141C78.8708 33.4284 78.9846 32.9685 78.9846 32.4344C78.9846 31.9003 78.8708 31.4453 78.6433 31.0694C78.4256 30.6837 78.1387 30.3919 77.7826 30.1941C77.4264 29.9864 77.0406 29.8825 76.625 29.8825C76.2095 29.8825 75.8187 29.9864 75.4527 30.1941C75.0965 30.3919 74.8046 30.6837 74.5771 31.0694C74.3594 31.4453 74.2506 31.9003 74.2506 32.4344C74.2506 32.9685 74.3594 33.4284 74.5771 33.8141C74.8046 34.19 75.0965 34.4818 75.4527 34.6895C75.8187 34.8873 76.2095 34.9862 76.625 34.9862ZM85.6101 36.455C84.8285 36.455 84.1409 36.277 83.5473 35.9209C82.9537 35.5648 82.4888 35.0851 82.1524 34.4818C81.816 33.8785 81.6478 33.196 81.6478 32.4344C81.6478 31.6827 81.816 31.0051 82.1524 30.4018C82.4888 29.7885 82.9537 29.3039 83.5473 28.9478C84.1409 28.5917 84.8285 28.4137 85.6101 28.4137C86.3818 28.4137 87.0644 28.5917 87.6582 28.9478C88.2518 29.3039 88.717 29.7885 89.0531 30.4018C89.3892 31.0051 89.5577 31.6827 89.5577 32.4344C89.5577 33.196 89.3892 33.8785 89.0531 34.4818C88.717 35.0851 88.2518 35.5648 87.6582 35.9209C87.0644 36.277 86.3818 36.455 85.6101 36.455ZM85.6101 34.9862C86.0256 34.9862 86.4114 34.8873 86.7676 34.6895C87.1238 34.4818 87.4107 34.19 87.6285 33.8141C87.8563 33.4284 87.9698 32.9685 87.9698 32.4344C87.9698 31.9003 87.8563 31.4453 87.6285 31.0694C87.4107 30.6837 87.1238 30.3919 86.7676 30.1941C86.4114 29.9864 86.0256 29.8825 85.6101 29.8825C85.1946 29.8825 84.8038 29.9864 84.4377 30.1941C84.0816 30.3919 83.7897 30.6837 83.5622 31.0694C83.3445 31.4453 83.2357 31.9003 83.2357 32.4344C83.2357 32.9685 83.3445 33.4284 83.5622 33.8141C83.7897 34.19 84.0816 34.4818 84.4377 34.6895C84.8038 34.8873 85.1946 34.9862 85.6101 34.9862ZM94.447 39.6597C93.7836 39.6597 93.21 39.5508 92.7256 39.3333C92.2507 39.1256 91.8648 38.8535 91.568 38.5173C91.2712 38.1909 91.0582 37.8546 90.9299 37.5084L92.4139 36.8853C92.5719 37.2809 92.8242 37.6024 93.1708 37.8496C93.5269 38.1068 93.952 38.2354 94.447 38.2354C95.1392 38.2354 95.6831 38.0277 96.0794 37.6123C96.4844 37.1968 96.6878 36.6084 96.6878 35.8467V35.1197H96.5988C96.3613 35.4758 96.0296 35.7627 95.6045 35.9803C95.189 36.188 94.7141 36.2918 94.1799 36.2918C93.5365 36.2918 92.9482 36.1286 92.4139 35.8022C91.8797 35.4758 91.4493 35.0209 91.1228 34.4373C90.7964 33.8438 90.6331 33.1515 90.6331 32.3602C90.6331 31.559 90.7964 30.8667 91.1228 30.2831C91.4493 29.6896 91.8797 29.2297 92.4139 28.9033C92.9482 28.5769 93.5365 28.4137 94.1799 28.4137C94.7141 28.4137 95.189 28.5225 95.6045 28.7401C96.0296 28.9577 96.3613 29.2445 96.5988 29.6006H96.6878V28.6511H98.2163V35.8171C98.2163 36.638 98.0531 37.3353 97.7266 37.909C97.4097 38.4826 96.9698 38.9179 96.4059 39.2146C95.8419 39.5113 95.189 39.6597 94.447 39.6597ZM94.4618 34.8379C94.8573 34.8379 95.223 34.7439 95.56 34.556C95.8961 34.3581 96.1684 34.0762 96.3762 33.7103C96.5839 33.3344 96.6878 32.8844 96.6878 32.3602C96.6878 31.8162 96.5839 31.3612 96.3762 30.9952C96.1684 30.6194 95.8961 30.3375 95.56 30.1496C95.223 29.9617 94.8573 29.8677 94.4618 29.8677C94.0655 29.8677 93.6945 29.9666 93.3488 30.1644C93.0119 30.3523 92.7404 30.6293 92.5326 30.9952C92.3249 31.3612 92.221 31.8162 92.221 32.3602C92.221 32.8943 92.3249 33.3492 92.5326 33.7251C92.7404 34.0911 93.0119 34.3681 93.3488 34.556C93.6945 34.7439 94.0655 34.8379 94.4618 34.8379ZM100.106 36.2176V25.5948H101.709V36.2176H100.106ZM106.983 36.455C106.241 36.455 105.579 36.282 104.995 35.9357C104.412 35.5895 103.952 35.1148 103.615 34.5115C103.288 33.9081 103.125 33.2207 103.125 32.4492C103.125 31.7272 103.284 31.0596 103.6 30.4463C103.917 29.833 104.357 29.3434 104.92 28.9775C105.495 28.6016 106.152 28.4137 106.894 28.4137C107.676 28.4137 108.339 28.5819 108.883 28.9181C109.437 29.2544 109.858 29.7143 110.144 30.2979C110.431 30.8815 110.574 31.5392 110.574 32.2712C110.574 32.38 110.57 32.4789 110.56 32.5679C110.56 32.6569 110.555 32.7261 110.545 32.7756H104.698C104.777 33.5273 105.039 34.0911 105.484 34.4669C105.94 34.8428 106.454 35.0307 107.028 35.0307C107.543 35.0307 107.968 34.917 108.304 34.6895C108.641 34.4521 108.908 34.1604 109.105 33.8141L110.426 34.4521C110.1 35.0456 109.654 35.5302 109.09 35.9061C108.527 36.272 107.825 36.455 106.983 36.455ZM106.909 29.7787C106.375 29.7787 105.92 29.9419 105.544 30.2683C105.168 30.5947 104.916 31.0299 104.787 31.5739H108.987C108.967 31.3167 108.883 31.0496 108.734 30.7727C108.586 30.4958 108.359 30.2633 108.052 30.0754C107.755 29.8775 107.374 29.7787 106.909 29.7787ZM117.098 36.2176L114.249 25.5948H116.059L117.751 32.4937L117.929 33.4136H118.018L118.241 32.4937L120.378 25.5948H122.01L124.058 32.4937L124.28 33.3987H124.369L124.548 32.4937L126.239 25.5948H128.035L125.23 36.2176H123.509L121.476 29.1704L121.238 28.1763H121.149L120.897 29.1704L118.775 36.2176H117.098ZM131.015 36.455C130.471 36.455 129.986 36.3512 129.561 36.1435C129.136 35.9259 128.804 35.6242 128.567 35.2384C128.329 34.8527 128.21 34.4126 128.21 33.918C128.21 33.3839 128.349 32.9289 128.626 32.5531C128.913 32.1673 129.294 31.8756 129.769 31.6777C130.243 31.4799 130.768 31.381 131.342 31.381C131.817 31.381 132.232 31.4255 132.588 31.5145C132.954 31.6035 133.232 31.6975 133.419 31.7964V31.3958C133.419 30.9012 133.241 30.5056 132.885 30.2089C132.529 29.9122 132.069 29.7638 131.505 29.7638C131.119 29.7638 130.753 29.8528 130.407 30.0309C130.06 30.199 129.783 30.4315 129.576 30.7282L128.478 29.8825C128.804 29.4276 129.234 29.0715 129.769 28.8143C130.312 28.5472 130.906 28.4137 131.549 28.4137C132.648 28.4137 133.493 28.6857 134.087 29.2297C134.681 29.7638 134.977 30.5155 134.977 31.4848V36.2176H133.419V35.2829H133.33C133.132 35.5895 132.835 35.8616 132.44 36.0989C132.044 36.3363 131.569 36.455 131.015 36.455ZM131.297 35.1494C131.713 35.1494 132.078 35.0505 132.395 34.8527C132.712 34.6548 132.959 34.3977 133.137 34.0812C133.325 33.7548 133.419 33.4037 133.419 33.0278C133.191 32.8993 132.924 32.7954 132.618 32.7163C132.311 32.6272 131.985 32.5827 131.638 32.5827C130.985 32.5827 130.52 32.7163 130.243 32.9833C129.967 33.2405 129.828 33.557 129.828 33.9328C129.828 34.2889 129.962 34.5807 130.229 34.8082C130.496 35.0357 130.852 35.1494 131.297 35.1494ZM136.756 36.2176V25.5948H138.359V36.2176H136.756ZM140.264 36.2176V25.5948H141.867V36.2176H140.264ZM147.141 36.455C146.399 36.455 145.736 36.282 145.152 35.9357C144.569 35.5895 144.109 35.1148 143.772 34.5115C143.446 33.9081 143.283 33.2207 143.283 32.4492C143.283 31.7272 143.441 31.0596 143.757 30.4463C144.074 29.833 144.514 29.3434 145.078 28.9775C145.653 28.6016 146.31 28.4137 147.052 28.4137C147.834 28.4137 148.497 28.5819 149.04 28.9181C149.595 29.2544 150.015 29.7143 150.302 30.2979C150.589 30.8815 150.732 31.5392 150.732 32.2712C150.732 32.38 150.728 32.4789 150.717 32.5679C150.717 32.6569 150.713 32.7261 150.702 32.7756H144.856C144.935 33.5273 145.197 34.0911 145.642 34.4669C146.098 34.8428 146.612 35.0307 147.185 35.0307C147.7 35.0307 148.126 34.917 148.462 34.6895C148.799 34.4521 149.066 34.1604 149.263 33.8141L150.584 34.4521C150.257 35.0456 149.812 35.5302 149.248 35.9061C148.684 36.272 147.982 36.455 147.141 36.455ZM147.067 29.7787C146.532 29.7787 146.078 29.9419 145.701 30.2683C145.326 30.5947 145.074 31.0299 144.945 31.5739H149.144C149.125 31.3167 149.04 31.0496 148.892 30.7727C148.744 30.4958 148.517 30.2633 148.209 30.0754C147.913 29.8775 147.532 29.7787 147.067 29.7787ZM152.804 34.0219V30.0457H151.483V28.6511H152.804V26.5147H154.406V28.6511H156.261V30.0457H154.406V33.6806C154.406 34.0565 154.481 34.3433 154.629 34.5411C154.787 34.739 155.049 34.8379 155.415 34.8379C155.603 34.8379 155.761 34.8132 155.89 34.7637C156.028 34.7142 156.167 34.645 156.306 34.556V36.1138C156.137 36.183 155.959 36.2374 155.772 36.277C155.583 36.3165 155.36 36.3363 155.104 36.3363C154.401 36.3363 153.842 36.1336 153.427 35.728C153.011 35.3126 152.804 34.7439 152.804 34.0219Z"
              fill="white"
            />
            <path
              d="M149.851 0.4375H24.1486C11.1317 0.4375 0.579346 10.9873 0.579346 24.0011C0.579346 37.015 11.1317 47.5648 24.1486 47.5648H149.851C162.868 47.5648 173.421 37.015 173.421 24.0011C173.421 10.9873 162.868 0.4375 149.851 0.4375Z"
              stroke="#747775"
              strokeWidth="1.02128"
            />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_4813_106418"
              x1="32.6895"
              y1="29.711"
              x2="16.5429"
              y2="48.6337"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#4285F4" />
              <stop offset="1" stopColor="#1B74E8" />
            </linearGradient>
            <clipPath id="clip0_4813_106418">
              <rect
                width="173.714"
                height="48"
                fill="white"
                transform="translate(0.142822)"
              />
            </clipPath>
          </defs>
        </svg>
      );
    case 'wallet_apple':
      return (
        <svg
          width="151"
          height="47"
          viewBox="0 0 151 47"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M137.469 -0.000582323H13.1672C12.6641 -0.000582323 12.1679 -0.000582323 11.6676 0.00215928C11.2467 0.00490088 10.8314 0.0131257 10.4078 0.0199797C9.49484 0.0419125 8.57229 0.0981154 7.66071 0.261241C6.74364 0.422995 5.891 0.697156 5.05619 1.12073C4.23507 1.54157 3.48525 2.08715 2.83686 2.73691C2.18161 3.3853 1.63741 4.13787 1.22205 4.95898C0.795733 5.79243 0.525685 6.64918 0.365301 7.56762C0.200805 8.47509 0.143231 9.39215 0.119927 10.3106C0.10759 10.7314 0.106219 11.1523 0.0993652 11.5731C0.0993652 12.0693 0.0993652 12.5669 0.0993652 13.07V33.5608C0.0993652 34.0666 0.0993652 34.5614 0.0993652 35.0604C0.106219 35.4854 0.10759 35.898 0.119927 36.3243C0.143231 37.2427 0.200805 38.1612 0.365301 39.0686C0.525685 39.9871 0.795733 40.8479 1.22205 41.6786C1.63741 42.4956 2.18161 43.2468 2.83686 43.8911C3.48525 44.545 4.23507 45.0906 5.05481 45.5059C5.88963 45.9336 6.74227 46.205 7.66071 46.3709C8.57092 46.534 9.49484 46.5875 10.4078 46.6135C10.8314 46.6231 11.2481 46.6286 11.6676 46.6286C12.1693 46.6314 12.6655 46.6314 13.1686 46.6314H137.47C137.962 46.6314 138.463 46.6314 138.956 46.6286C139.374 46.6286 139.802 46.6231 140.22 46.6135C141.138 46.5889 142.06 46.534 142.962 46.3709C143.88 46.205 144.734 45.935 145.577 45.5059C146.395 45.0892 147.145 44.545 147.794 43.8911C148.446 43.2468 148.99 42.4956 149.413 41.6786C149.833 40.8479 150.106 39.9871 150.261 39.0686C150.43 38.1612 150.483 37.2427 150.516 36.3243C150.522 35.898 150.522 35.4867 150.522 35.0604C150.533 34.5628 150.533 34.068 150.533 33.5608V13.0686C150.533 12.5669 150.533 12.0693 150.522 11.5717C150.522 11.1509 150.522 10.7301 150.516 10.3092C150.485 9.39078 150.431 8.47234 150.261 7.56487C150.106 6.64644 149.833 5.78968 149.413 4.95624C148.989 4.13513 148.446 3.38393 147.794 2.73417C147.145 2.08441 146.397 1.53883 145.577 1.11799C144.734 0.693043 143.88 0.418883 142.962 0.258499C142.06 0.0953738 141.138 0.0391709 140.22 0.0158673C139.802 0.00901329 139.374 0.000788479 138.956 -0.00195312C138.463 -0.000582323 137.962 -0.000582323 137.469 -0.000582323Z"
            fill="#A6A6A6"
          />
          <path
            d="M137.469 0.890625C137.96 0.890625 138.459 0.890625 138.95 0.893367C139.287 0.896108 139.633 0.901591 139.973 0.907075L140.197 0.911187C140.923 0.929008 141.872 0.971502 142.807 1.14011C143.656 1.28816 144.43 1.54313 145.169 1.91461C145.908 2.29433 146.578 2.78233 147.164 3.36903C147.744 3.94477 148.233 4.61646 148.615 5.35944C148.987 6.0983 149.238 6.86869 149.383 7.72956C149.543 8.59316 149.593 9.49515 149.623 10.3217C149.628 10.7385 149.628 11.1566 149.628 11.5911C149.639 12.0819 149.639 12.5726 149.639 13.0688V33.5596C149.639 34.0585 149.639 34.5479 149.628 35.0592C149.628 35.4814 149.628 35.8899 149.623 36.2916C149.593 37.1374 149.543 38.0394 149.38 38.918C149.236 39.7707 148.986 40.5411 148.62 41.2662C148.23 42.0188 147.741 42.6877 147.158 43.2621C146.578 43.8474 145.911 44.3341 145.172 44.7097C144.444 45.0798 143.668 45.3348 142.802 45.4924C141.904 45.6555 140.98 45.6994 140.2 45.7213C139.789 45.7309 139.368 45.7364 138.951 45.7364C138.461 45.7392 137.962 45.7392 137.471 45.7392H13.1679C12.6675 45.7392 12.1727 45.7392 11.6668 45.7364C11.2542 45.7364 10.8444 45.7309 10.4317 45.7227C9.64764 45.7008 8.72509 45.6569 7.81899 45.4938C6.95127 45.3375 6.17951 45.0812 5.45847 44.7111C4.71961 44.3368 4.05066 43.8488 3.46121 43.2539C2.88273 42.685 2.3961 42.0188 2.01502 41.2703C1.64764 40.5534 1.39404 39.7816 1.24188 38.9071C1.07191 37.9736 1.02941 37.0236 1.01022 36.2971C1.00199 36.0119 0.997882 35.7337 0.99514 35.4527L0.991028 35.0592V33.5596V13.0688V11.587L0.996511 11.1771C0.999253 10.8975 1.00337 10.6178 1.01159 10.3341C1.02941 9.6103 1.07328 8.66033 1.24463 7.71996C1.39541 6.85635 1.64764 6.08596 2.01776 5.36081C2.39473 4.61646 2.88136 3.94614 3.46807 3.36629C4.05203 2.78096 4.72372 2.29296 5.45984 1.91598C6.19459 1.54176 6.96498 1.28816 7.81899 1.13874C8.75662 0.970132 9.70796 0.929007 10.4221 0.909816L10.6936 0.905704C11.0212 0.900221 11.3461 0.894737 11.6723 0.893367C12.1713 0.890625 12.6675 0.890625 13.1679 0.890625H137.469Z"
            fill="black"
          />
          <mask
            id="mask0_4813_105989"
            maskUnits="userSpaceOnUse"
            x="10"
            y="10"
            width="36"
            height="27"
          >
            <path
              d="M45.6987 31.6022V31.9655C45.6987 32.1396 45.6987 32.3137 45.6973 32.4878C45.6959 32.6344 45.6945 32.7811 45.6904 32.9278C45.6822 33.2472 45.663 33.5693 45.6068 33.8846C45.5492 34.2054 45.4546 34.5042 45.3066 34.7948C45.1613 35.0813 44.9708 35.3431 44.7432 35.5693C44.5156 35.7969 44.2538 35.986 43.9687 36.1327C43.6781 36.2808 43.3793 36.3753 43.0585 36.4329C42.7432 36.4891 42.4211 36.5083 42.1017 36.5165C41.955 36.5207 41.8083 36.522 41.6616 36.5234C41.4875 36.5248 41.3135 36.5248 41.1394 36.5248L39.1394 36.5234L41.0009 36.5248H15.1572L17.0187 36.5234L15.0187 36.5248C14.8446 36.5248 14.6705 36.5248 14.4965 36.5234C14.3498 36.522 14.2031 36.5207 14.0564 36.5165C13.737 36.5083 13.4149 36.4891 13.0996 36.4329C12.7788 36.3753 12.4814 36.2808 12.1894 36.1327C11.9029 35.9874 11.6411 35.7969 11.4149 35.5693C11.1873 35.3418 10.9982 35.0799 10.8515 34.7948C10.7034 34.5042 10.6089 34.2054 10.5513 33.8846C10.4951 33.5693 10.4759 33.2472 10.4677 32.9278C10.4636 32.7811 10.4622 32.6344 10.4622 32.4878C10.4608 32.3137 10.4608 32.1396 10.4608 31.9655V31.6804V14.9401V16.6536V14.655C10.4608 14.4809 10.4608 14.3068 10.4622 14.1327C10.4636 13.986 10.4649 13.8394 10.469 13.6927C10.4773 13.3733 10.4965 13.0512 10.5527 12.7359C10.6102 12.4151 10.7048 12.1163 10.8529 11.8257C10.9982 11.5392 11.1887 11.2773 11.4163 11.0512C11.6438 10.8236 11.9056 10.6344 12.1908 10.4878C12.4814 10.3397 12.7802 10.2451 13.101 10.1875C13.4163 10.1313 13.7384 10.1122 14.0578 10.1039C14.2045 10.0998 14.3512 10.0984 14.4978 10.0971C14.6719 10.0957 14.846 10.0957 15.0201 10.0957H17.0187H41.0023H41.1394C41.3135 10.0957 41.4875 10.0957 41.6616 10.0971C41.8083 10.0984 41.955 10.0998 42.1017 10.1039C42.4211 10.1122 42.7432 10.1313 43.0585 10.1875C43.3793 10.2451 43.6767 10.3397 43.9687 10.4878C44.2552 10.6331 44.517 10.8236 44.7432 11.0512C44.9708 11.2787 45.1599 11.5405 45.3066 11.8257C45.4546 12.1163 45.5492 12.4151 45.6068 12.7359C45.663 13.0512 45.6822 13.3733 45.6904 13.6927C45.6945 13.8394 45.6959 13.986 45.6973 14.1327C45.6987 14.3068 45.6987 14.4809 45.6987 14.655V15.0183V31.6022Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_4813_105989)">
            <path
              d="M44.5829 11.1973H11.548V34.1993H44.5829V11.1973Z"
              fill="#DEDBCE"
            />
          </g>
          <mask
            id="mask1_4813_105989"
            maskUnits="userSpaceOnUse"
            x="10"
            y="10"
            width="36"
            height="27"
          >
            <path
              d="M45.6987 31.6022V31.9655C45.6987 32.1396 45.6987 32.3137 45.6973 32.4878C45.6959 32.6344 45.6945 32.7811 45.6904 32.9278C45.6822 33.2472 45.663 33.5693 45.6068 33.8846C45.5492 34.2054 45.4546 34.5042 45.3066 34.7948C45.1613 35.0813 44.9708 35.3431 44.7432 35.5693C44.5156 35.7969 44.2538 35.986 43.9687 36.1327C43.6781 36.2808 43.3793 36.3753 43.0585 36.4329C42.7432 36.4891 42.4211 36.5083 42.1017 36.5165C41.955 36.5207 41.8083 36.522 41.6616 36.5234C41.4875 36.5248 41.3135 36.5248 41.1394 36.5248L39.1394 36.5234L41.0009 36.5248H15.1572L17.0187 36.5234L15.0187 36.5248C14.8446 36.5248 14.6705 36.5248 14.4965 36.5234C14.3498 36.522 14.2031 36.5207 14.0564 36.5165C13.737 36.5083 13.4149 36.4891 13.0996 36.4329C12.7788 36.3753 12.4814 36.2808 12.1894 36.1327C11.9029 35.9874 11.6411 35.7969 11.4149 35.5693C11.1873 35.3418 10.9982 35.0799 10.8515 34.7948C10.7034 34.5042 10.6089 34.2054 10.5513 33.8846C10.4951 33.5693 10.4759 33.2472 10.4677 32.9278C10.4636 32.7811 10.4622 32.6344 10.4622 32.4878C10.4608 32.3137 10.4608 32.1396 10.4608 31.9655V31.6804V14.9401V16.6536V14.655C10.4608 14.4809 10.4608 14.3068 10.4622 14.1327C10.4636 13.986 10.4649 13.8394 10.469 13.6927C10.4773 13.3733 10.4965 13.0512 10.5527 12.7359C10.6102 12.4151 10.7048 12.1163 10.8529 11.8257C10.9982 11.5392 11.1887 11.2773 11.4163 11.0512C11.6438 10.8236 11.9056 10.6344 12.1908 10.4878C12.4814 10.3397 12.7802 10.2451 13.101 10.1875C13.4163 10.1313 13.7384 10.1122 14.0578 10.1039C14.2045 10.0998 14.3512 10.0984 14.4978 10.0971C14.6719 10.0957 14.846 10.0957 15.0201 10.0957H17.0187H41.0023H41.1394C41.3135 10.0957 41.4875 10.0957 41.6616 10.0971C41.8083 10.0984 41.955 10.0998 42.1017 10.1039C42.4211 10.1122 42.7432 10.1313 43.0585 10.1875C43.3793 10.2451 43.6767 10.3397 43.9687 10.4878C44.2552 10.6331 44.517 10.8236 44.7432 11.0512C44.9708 11.2787 45.1599 11.5405 45.3066 11.8257C45.4546 12.1163 45.5492 12.4151 45.6068 12.7359C45.663 13.0512 45.6822 13.3733 45.6904 13.6927C45.6945 13.8394 45.6959 13.986 45.6973 14.1327C45.6987 14.3068 45.6987 14.4809 45.6987 14.655V15.0183V31.6022Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask1_4813_105989)">
            <path
              d="M44.2311 11.5625H11.9295V25.2664H44.2311V11.5625Z"
              fill="#40A5D9"
            />
          </g>
          <mask
            id="mask2_4813_105989"
            maskUnits="userSpaceOnUse"
            x="10"
            y="10"
            width="36"
            height="27"
          >
            <path
              d="M45.6987 31.6022V31.9655C45.6987 32.1396 45.6987 32.3137 45.6973 32.4878C45.6959 32.6344 45.6945 32.7811 45.6904 32.9278C45.6822 33.2472 45.663 33.5693 45.6068 33.8846C45.5492 34.2054 45.4546 34.5042 45.3066 34.7948C45.1613 35.0813 44.9708 35.3431 44.7432 35.5693C44.5156 35.7969 44.2538 35.986 43.9687 36.1327C43.6781 36.2808 43.3793 36.3753 43.0585 36.4329C42.7432 36.4891 42.4211 36.5083 42.1017 36.5165C41.955 36.5207 41.8083 36.522 41.6616 36.5234C41.4875 36.5248 41.3135 36.5248 41.1394 36.5248L39.1394 36.5234L41.0009 36.5248H15.1572L17.0187 36.5234L15.0187 36.5248C14.8446 36.5248 14.6705 36.5248 14.4965 36.5234C14.3498 36.522 14.2031 36.5207 14.0564 36.5165C13.737 36.5083 13.4149 36.4891 13.0996 36.4329C12.7788 36.3753 12.4814 36.2808 12.1894 36.1327C11.9029 35.9874 11.6411 35.7969 11.4149 35.5693C11.1873 35.3418 10.9982 35.0799 10.8515 34.7948C10.7034 34.5042 10.6089 34.2054 10.5513 33.8846C10.4951 33.5693 10.4759 33.2472 10.4677 32.9278C10.4636 32.7811 10.4622 32.6344 10.4622 32.4878C10.4608 32.3137 10.4608 32.1396 10.4608 31.9655V31.6804V14.9401V16.6536V14.655C10.4608 14.4809 10.4608 14.3068 10.4622 14.1327C10.4636 13.986 10.4649 13.8394 10.469 13.6927C10.4773 13.3733 10.4965 13.0512 10.5527 12.7359C10.6102 12.4151 10.7048 12.1163 10.8529 11.8257C10.9982 11.5392 11.1887 11.2773 11.4163 11.0512C11.6438 10.8236 11.9056 10.6344 12.1908 10.4878C12.4814 10.3397 12.7802 10.2451 13.101 10.1875C13.4163 10.1313 13.7384 10.1122 14.0578 10.1039C14.2045 10.0998 14.3512 10.0984 14.4978 10.0971C14.6719 10.0957 14.846 10.0957 15.0201 10.0957H17.0187H41.0023H41.1394C41.3135 10.0957 41.4875 10.0957 41.6616 10.0971C41.8083 10.0984 41.955 10.0998 42.1017 10.1039C42.4211 10.1122 42.7432 10.1313 43.0585 10.1875C43.3793 10.2451 43.6767 10.3397 43.9687 10.4878C44.2552 10.6331 44.517 10.8236 44.7432 11.0512C44.9708 11.2787 45.1599 11.5405 45.3066 11.8257C45.4546 12.1163 45.5492 12.4151 45.6068 12.7359C45.663 13.0512 45.6822 13.3733 45.6904 13.6927C45.6945 13.8394 45.6959 13.986 45.6973 14.1327C45.6987 14.3068 45.6987 14.4809 45.6987 14.655V15.0183V31.6022Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask2_4813_105989)">
            <rect
              x="10.3033"
              y="12.4844"
              width="35.8602"
              height="17.1076"
              fill="url(#pattern0_4813_105989)"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M44.2314 17.3918C44.2314 17.2808 44.2314 17.1711 44.2314 17.0601C44.2314 16.9669 44.23 16.8736 44.2273 16.7804C44.2218 16.5776 44.2095 16.3733 44.1738 16.1732C44.1368 15.9703 44.0779 15.7811 43.9833 15.5961C43.8914 15.4151 43.7708 15.2479 43.6269 15.1039C43.4829 14.96 43.3171 14.8394 43.1347 14.7462C42.9497 14.6516 42.7605 14.5926 42.5576 14.5556C42.3575 14.52 42.1533 14.5076 41.9504 14.5022C41.8572 14.4994 41.7639 14.498 41.6707 14.498C41.5597 14.498 41.45 14.498 41.339 14.498H41.2485H16.0902H14.8222C14.7112 14.498 14.6015 14.498 14.4905 14.498C14.3973 14.498 14.304 14.4994 14.2108 14.5022C14.0079 14.5076 13.8037 14.52 13.6036 14.5556C13.4007 14.5926 13.2115 14.6516 13.0265 14.7462C12.8455 14.838 12.6783 14.9586 12.5343 15.1039C12.3904 15.2479 12.2698 15.4137 12.1779 15.5961C12.0833 15.7811 12.0244 15.9703 11.9874 16.1732C11.9517 16.3733 11.9394 16.5776 11.9339 16.7804C11.9312 16.8736 11.9298 16.9669 11.9298 17.0601C11.9298 17.1711 11.9298 17.2808 11.9298 17.3918V18.6598V17.6632V28.2033H44.2314V17.7304V17.3918Z"
              fill="#FFB003"
            />
          </g>
          <mask
            id="mask3_4813_105989"
            maskUnits="userSpaceOnUse"
            x="10"
            y="10"
            width="36"
            height="27"
          >
            <path
              d="M45.6987 31.6022V31.9655C45.6987 32.1396 45.6987 32.3137 45.6973 32.4878C45.6959 32.6344 45.6945 32.7811 45.6904 32.9278C45.6822 33.2472 45.663 33.5693 45.6068 33.8846C45.5492 34.2054 45.4546 34.5042 45.3066 34.7948C45.1613 35.0813 44.9708 35.3431 44.7432 35.5693C44.5156 35.7969 44.2538 35.986 43.9687 36.1327C43.6781 36.2808 43.3793 36.3753 43.0585 36.4329C42.7432 36.4891 42.4211 36.5083 42.1017 36.5165C41.955 36.5207 41.8083 36.522 41.6616 36.5234C41.4875 36.5248 41.3135 36.5248 41.1394 36.5248L39.1394 36.5234L41.0009 36.5248H15.1572L17.0187 36.5234L15.0187 36.5248C14.8446 36.5248 14.6705 36.5248 14.4965 36.5234C14.3498 36.522 14.2031 36.5207 14.0564 36.5165C13.737 36.5083 13.4149 36.4891 13.0996 36.4329C12.7788 36.3753 12.4814 36.2808 12.1894 36.1327C11.9029 35.9874 11.6411 35.7969 11.4149 35.5693C11.1873 35.3418 10.9982 35.0799 10.8515 34.7948C10.7034 34.5042 10.6089 34.2054 10.5513 33.8846C10.4951 33.5693 10.4759 33.2472 10.4677 32.9278C10.4636 32.7811 10.4622 32.6344 10.4622 32.4878C10.4608 32.3137 10.4608 32.1396 10.4608 31.9655V31.6804V14.9401V16.6536V14.655C10.4608 14.4809 10.4608 14.3068 10.4622 14.1327C10.4636 13.986 10.4649 13.8394 10.469 13.6927C10.4773 13.3733 10.4965 13.0512 10.5527 12.7359C10.6102 12.4151 10.7048 12.1163 10.8529 11.8257C10.9982 11.5392 11.1887 11.2773 11.4163 11.0512C11.6438 10.8236 11.9056 10.6344 12.1908 10.4878C12.4814 10.3397 12.7802 10.2451 13.101 10.1875C13.4163 10.1313 13.7384 10.1122 14.0578 10.1039C14.2045 10.0998 14.3512 10.0984 14.4978 10.0971C14.6719 10.0957 14.846 10.0957 15.0201 10.0957H17.0187H41.0023H41.1394C41.3135 10.0957 41.4875 10.0957 41.6616 10.0971C41.8083 10.0984 41.955 10.0998 42.1017 10.1039C42.4211 10.1122 42.7432 10.1313 43.0585 10.1875C43.3793 10.2451 43.6767 10.3397 43.9687 10.4878C44.2552 10.6331 44.517 10.8236 44.7432 11.0512C44.9708 11.2787 45.1599 11.5405 45.3066 11.8257C45.4546 12.1163 45.5492 12.4151 45.6068 12.7359C45.663 13.0512 45.6822 13.3733 45.6904 13.6927C45.6945 13.8394 45.6959 13.986 45.6973 14.1327C45.6987 14.3068 45.6987 14.4809 45.6987 14.655V15.0183V31.6022Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask3_4813_105989)">
            <rect
              x="10.3033"
              y="15.4453"
              width="35.8602"
              height="17.1076"
              fill="url(#pattern1_4813_105989)"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M44.2314 20.3293C44.2314 20.2183 44.2314 20.1086 44.2314 19.9976C44.2314 19.9044 44.23 19.8111 44.2273 19.7179C44.2218 19.5151 44.2095 19.3108 44.1738 19.1107C44.1368 18.9078 44.0779 18.7186 43.9833 18.5336C43.8914 18.3526 43.7708 18.1854 43.6269 18.0414C43.4829 17.8975 43.3171 17.7769 43.1347 17.6837C42.9497 17.5891 42.7605 17.5301 42.5576 17.4931C42.3575 17.4575 42.1533 17.4451 41.9504 17.4397C41.8572 17.4369 41.7639 17.4355 41.6707 17.4355C41.5597 17.4355 41.45 17.4355 41.339 17.4355H41.2472H16.0902H14.8222C14.7112 17.4355 14.6015 17.4355 14.4905 17.4355C14.3973 17.4355 14.304 17.4369 14.2108 17.4397C14.0079 17.4451 13.8037 17.4575 13.6036 17.4931C13.4007 17.5301 13.2115 17.5891 13.0265 17.6837C12.8455 17.7755 12.6783 17.8961 12.5343 18.0414C12.3904 18.1854 12.2698 18.3512 12.1779 18.5336C12.0833 18.7186 12.0244 18.9078 11.9874 19.1107C11.9517 19.3108 11.9394 19.5151 11.9339 19.7179C11.9312 19.8111 11.9298 19.9044 11.9298 19.9976C11.9298 20.1086 11.9298 20.2183 11.9298 20.3293V21.5973V20.6007V31.1408H44.2314V20.6679V20.3293Z"
              fill="#40C740"
            />
          </g>
          <mask
            id="mask4_4813_105989"
            maskUnits="userSpaceOnUse"
            x="10"
            y="10"
            width="36"
            height="27"
          >
            <path
              d="M45.6987 31.6022V31.9655C45.6987 32.1396 45.6987 32.3137 45.6973 32.4878C45.6959 32.6344 45.6945 32.7811 45.6904 32.9278C45.6822 33.2472 45.663 33.5693 45.6068 33.8846C45.5492 34.2054 45.4546 34.5042 45.3066 34.7948C45.1613 35.0813 44.9708 35.3431 44.7432 35.5693C44.5156 35.7969 44.2538 35.986 43.9687 36.1327C43.6781 36.2808 43.3793 36.3753 43.0585 36.4329C42.7432 36.4891 42.4211 36.5083 42.1017 36.5165C41.955 36.5207 41.8083 36.522 41.6616 36.5234C41.4875 36.5248 41.3135 36.5248 41.1394 36.5248L39.1394 36.5234L41.0009 36.5248H15.1572L17.0187 36.5234L15.0187 36.5248C14.8446 36.5248 14.6705 36.5248 14.4965 36.5234C14.3498 36.522 14.2031 36.5207 14.0564 36.5165C13.737 36.5083 13.4149 36.4891 13.0996 36.4329C12.7788 36.3753 12.4814 36.2808 12.1894 36.1327C11.9029 35.9874 11.6411 35.7969 11.4149 35.5693C11.1873 35.3418 10.9982 35.0799 10.8515 34.7948C10.7034 34.5042 10.6089 34.2054 10.5513 33.8846C10.4951 33.5693 10.4759 33.2472 10.4677 32.9278C10.4636 32.7811 10.4622 32.6344 10.4622 32.4878C10.4608 32.3137 10.4608 32.1396 10.4608 31.9655V31.6804V14.9401V16.6536V14.655C10.4608 14.4809 10.4608 14.3068 10.4622 14.1327C10.4636 13.986 10.4649 13.8394 10.469 13.6927C10.4773 13.3733 10.4965 13.0512 10.5527 12.7359C10.6102 12.4151 10.7048 12.1163 10.8529 11.8257C10.9982 11.5392 11.1887 11.2773 11.4163 11.0512C11.6438 10.8236 11.9056 10.6344 12.1908 10.4878C12.4814 10.3397 12.7802 10.2451 13.101 10.1875C13.4163 10.1313 13.7384 10.1122 14.0578 10.1039C14.2045 10.0998 14.3512 10.0984 14.4978 10.0971C14.6719 10.0957 14.846 10.0957 15.0201 10.0957H17.0187H41.0023H41.1394C41.3135 10.0957 41.4875 10.0957 41.6616 10.0971C41.8083 10.0984 41.955 10.0998 42.1017 10.1039C42.4211 10.1122 42.7432 10.1313 43.0585 10.1875C43.3793 10.2451 43.6767 10.3397 43.9687 10.4878C44.2552 10.6331 44.517 10.8236 44.7432 11.0512C44.9708 11.2787 45.1599 11.5405 45.3066 11.8257C45.4546 12.1163 45.5492 12.4151 45.6068 12.7359C45.663 13.0512 45.6822 13.3733 45.6904 13.6927C45.6945 13.8394 45.6959 13.986 45.6973 14.1327C45.6987 14.3068 45.6987 14.4809 45.6987 14.655V15.0183V31.6022Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask4_4813_105989)">
            <rect
              x="10.3033"
              y="18.4062"
              width="35.8602"
              height="17.1076"
              fill="url(#pattern2_4813_105989)"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M44.2314 23.2649C44.2314 23.1538 44.2314 23.0442 44.2314 22.9331C44.2314 22.8399 44.23 22.7467 44.2273 22.6535C44.2218 22.4506 44.2095 22.2464 44.1738 22.0462C44.1368 21.8433 44.0779 21.6542 43.9833 21.4691C43.8914 21.2882 43.7708 21.1209 43.6269 20.977C43.4829 20.8331 43.3171 20.7124 43.1347 20.6192C42.9497 20.5246 42.7605 20.4657 42.5576 20.4287C42.3575 20.393 42.1533 20.3807 41.9504 20.3752C41.8572 20.3725 41.7639 20.3711 41.6707 20.3711C41.5597 20.3711 41.45 20.3711 41.339 20.3711H41.2472H16.0902H14.8222C14.7112 20.3711 14.6015 20.3711 14.4905 20.3711C14.3973 20.3711 14.304 20.3725 14.2108 20.3752C14.0079 20.3807 13.8037 20.393 13.6036 20.4287C13.4007 20.4657 13.2115 20.5246 13.0265 20.6192C12.8455 20.7111 12.6783 20.8317 12.5343 20.977C12.3904 21.1209 12.2698 21.2868 12.1779 21.4691C12.0833 21.6542 12.0244 21.8433 11.9874 22.0462C11.9517 22.2464 11.9394 22.4506 11.9339 22.6535C11.9312 22.7467 11.9298 22.8399 11.9298 22.9331C11.9298 23.0442 11.9298 23.1538 11.9298 23.2649V24.5328V23.5363V34.0764H44.2314V23.6034V23.2649Z"
              fill="#F26D5F"
            />
          </g>
          <mask
            id="mask5_4813_105989"
            maskUnits="userSpaceOnUse"
            x="10"
            y="10"
            width="36"
            height="27"
          >
            <path
              d="M45.6987 31.6022V31.9655C45.6987 32.1396 45.6987 32.3137 45.6973 32.4878C45.6959 32.6344 45.6945 32.7811 45.6904 32.9278C45.6822 33.2472 45.663 33.5693 45.6068 33.8846C45.5492 34.2054 45.4546 34.5042 45.3066 34.7948C45.1613 35.0813 44.9708 35.3431 44.7432 35.5693C44.5156 35.7969 44.2538 35.986 43.9687 36.1327C43.6781 36.2808 43.3793 36.3753 43.0585 36.4329C42.7432 36.4891 42.4211 36.5083 42.1017 36.5165C41.955 36.5207 41.8083 36.522 41.6616 36.5234C41.4875 36.5248 41.3135 36.5248 41.1394 36.5248L39.1394 36.5234L41.0009 36.5248H15.1572L17.0187 36.5234L15.0187 36.5248C14.8446 36.5248 14.6705 36.5248 14.4965 36.5234C14.3498 36.522 14.2031 36.5207 14.0564 36.5165C13.737 36.5083 13.4149 36.4891 13.0996 36.4329C12.7788 36.3753 12.4814 36.2808 12.1894 36.1327C11.9029 35.9874 11.6411 35.7969 11.4149 35.5693C11.1873 35.3418 10.9982 35.0799 10.8515 34.7948C10.7034 34.5042 10.6089 34.2054 10.5513 33.8846C10.4951 33.5693 10.4759 33.2472 10.4677 32.9278C10.4636 32.7811 10.4622 32.6344 10.4622 32.4878C10.4608 32.3137 10.4608 32.1396 10.4608 31.9655V31.6804V14.9401V16.6536V14.655C10.4608 14.4809 10.4608 14.3068 10.4622 14.1327C10.4636 13.986 10.4649 13.8394 10.469 13.6927C10.4773 13.3733 10.4965 13.0512 10.5527 12.7359C10.6102 12.4151 10.7048 12.1163 10.8529 11.8257C10.9982 11.5392 11.1887 11.2773 11.4163 11.0512C11.6438 10.8236 11.9056 10.6344 12.1908 10.4878C12.4814 10.3397 12.7802 10.2451 13.101 10.1875C13.4163 10.1313 13.7384 10.1122 14.0578 10.1039C14.2045 10.0998 14.3512 10.0984 14.4978 10.0971C14.6719 10.0957 14.846 10.0957 15.0201 10.0957H17.0187H41.0023H41.1394C41.3135 10.0957 41.4875 10.0957 41.6616 10.0971C41.8083 10.0984 41.955 10.0998 42.1017 10.1039C42.4211 10.1122 42.7432 10.1313 43.0585 10.1875C43.3793 10.2451 43.6767 10.3397 43.9687 10.4878C44.2552 10.6331 44.517 10.8236 44.7432 11.0512C44.9708 11.2787 45.1599 11.5405 45.3066 11.8257C45.4546 12.1163 45.5492 12.4151 45.6068 12.7359C45.663 13.0512 45.6822 13.3733 45.6904 13.6927C45.6945 13.8394 45.6959 13.986 45.6973 14.1327C45.6987 14.3068 45.6987 14.4809 45.6987 14.655V15.0183V31.6022Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask5_4813_105989)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.97101 9.60547V24.7775H11.9285V15.7234V14.4554C11.9285 14.3443 11.9285 14.2347 11.9285 14.1236C11.9285 14.0304 11.9299 13.9372 11.9326 13.844C11.9381 13.6411 11.9504 13.4369 11.9861 13.2367C12.0231 13.0338 12.082 12.8447 12.1766 12.6596C12.2685 12.4787 12.3891 12.3114 12.533 12.1675C12.6783 12.0249 12.8442 11.9043 13.0252 11.8125C13.2102 11.7179 13.3994 11.6589 13.6023 11.6219C13.8024 11.5863 14.0066 11.5739 14.2095 11.5685C14.3027 11.5657 14.396 11.5643 14.4892 11.5643C14.6002 11.5643 14.7099 11.5643 14.8209 11.5643H16.0889H41.2404H41.3377C41.4487 11.5643 41.5584 11.5643 41.6694 11.5643C41.7626 11.5643 41.8559 11.5657 41.9491 11.5685C42.152 11.5739 42.3562 11.5863 42.5563 11.6219C42.7592 11.6589 42.9484 11.7179 43.1334 11.8125C43.3144 11.9043 43.4816 12.0249 43.6256 12.1702C43.7695 12.3142 43.8901 12.48 43.982 12.6624C44.0766 12.8474 44.1355 13.0366 44.1725 13.2395C44.2082 13.4396 44.2205 13.6439 44.226 13.8467C44.2287 13.9399 44.2301 14.0332 44.2301 14.1264C44.2301 14.2374 44.2301 14.3471 44.2301 14.4581V15.7261V24.7802H46.1876V9.60547H9.97101Z"
              fill="#D9D6CC"
            />
          </g>
          <mask
            id="mask6_4813_105989"
            maskUnits="userSpaceOnUse"
            x="10"
            y="10"
            width="36"
            height="27"
          >
            <path
              d="M45.6987 31.6022V31.9655C45.6987 32.1396 45.6987 32.3137 45.6973 32.4878C45.6959 32.6344 45.6945 32.7811 45.6904 32.9278C45.6822 33.2472 45.663 33.5693 45.6068 33.8846C45.5492 34.2054 45.4546 34.5042 45.3066 34.7948C45.1613 35.0813 44.9708 35.3431 44.7432 35.5693C44.5156 35.7969 44.2538 35.986 43.9687 36.1327C43.6781 36.2808 43.3793 36.3753 43.0585 36.4329C42.7432 36.4891 42.4211 36.5083 42.1017 36.5165C41.955 36.5207 41.8083 36.522 41.6616 36.5234C41.4875 36.5248 41.3135 36.5248 41.1394 36.5248L39.1394 36.5234L41.0009 36.5248H15.1572L17.0187 36.5234L15.0187 36.5248C14.8446 36.5248 14.6705 36.5248 14.4965 36.5234C14.3498 36.522 14.2031 36.5207 14.0564 36.5165C13.737 36.5083 13.4149 36.4891 13.0996 36.4329C12.7788 36.3753 12.4814 36.2808 12.1894 36.1327C11.9029 35.9874 11.6411 35.7969 11.4149 35.5693C11.1873 35.3418 10.9982 35.0799 10.8515 34.7948C10.7034 34.5042 10.6089 34.2054 10.5513 33.8846C10.4951 33.5693 10.4759 33.2472 10.4677 32.9278C10.4636 32.7811 10.4622 32.6344 10.4622 32.4878C10.4608 32.3137 10.4608 32.1396 10.4608 31.9655V31.6804V14.9401V16.6536V14.655C10.4608 14.4809 10.4608 14.3068 10.4622 14.1327C10.4636 13.986 10.4649 13.8394 10.469 13.6927C10.4773 13.3733 10.4965 13.0512 10.5527 12.7359C10.6102 12.4151 10.7048 12.1163 10.8529 11.8257C10.9982 11.5392 11.1887 11.2773 11.4163 11.0512C11.6438 10.8236 11.9056 10.6344 12.1908 10.4878C12.4814 10.3397 12.7802 10.2451 13.101 10.1875C13.4163 10.1313 13.7384 10.1122 14.0578 10.1039C14.2045 10.0998 14.3512 10.0984 14.4978 10.0971C14.6719 10.0957 14.846 10.0957 15.0201 10.0957H17.0187H41.0023H41.1394C41.3135 10.0957 41.4875 10.0957 41.6616 10.0971C41.8083 10.0984 41.955 10.0998 42.1017 10.1039C42.4211 10.1122 42.7432 10.1313 43.0585 10.1875C43.3793 10.2451 43.6767 10.3397 43.9687 10.4878C44.2552 10.6331 44.517 10.8236 44.7432 11.0512C44.9708 11.2787 45.1599 11.5405 45.3066 11.8257C45.4546 12.1163 45.5492 12.4151 45.6068 12.7359C45.663 13.0512 45.6822 13.3733 45.6904 13.6927C45.6945 13.8394 45.6959 13.986 45.6973 14.1327C45.6987 14.3068 45.6987 14.4809 45.6987 14.655V15.0183V31.6022Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask6_4813_105989)">
            <rect
              x="8.32977"
              y="21.0391"
              width="39.8081"
              height="17.4366"
              fill="url(#pattern3_4813_105989)"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M37.0902 23.3105C36.8805 23.3105 36.6694 23.3105 36.4596 23.3119C36.2828 23.3133 36.106 23.3147 35.9291 23.3201C35.5439 23.3311 35.1546 23.353 34.7735 23.4216C34.387 23.4915 34.0265 23.6053 33.6755 23.7835C33.6303 23.8068 32.6639 24.2454 31.7948 25.597C31.1354 26.6238 29.8524 27.7122 28.0566 27.7122C26.2609 27.7122 24.9778 26.6238 24.3184 25.597C23.4041 24.1728 22.3609 23.7451 22.4363 23.7835C22.0854 23.6039 21.7249 23.4915 21.3383 23.4216C20.9572 23.353 20.5679 23.3297 20.1827 23.3201C20.0059 23.316 19.8291 23.3133 19.6522 23.3119C19.4425 23.3105 19.2314 23.3105 19.0217 23.3105H9.97437V37.0131H46.191V23.3105H37.0902Z"
              fill="#DEDBCE"
            />
          </g>
          <path
            d="M56.6173 24.209H58.4693L62.4803 35.2535H60.6818L59.6715 32.2693H55.4151L54.3966 35.2535H52.5981L56.6173 24.209ZM55.8744 30.8916H59.204L57.5591 26.039H57.5289L55.8744 30.8916Z"
            fill="white"
          />
          <path
            d="M63.5403 27.201H65.1935V28.5869H65.2319C65.7144 27.63 66.6027 27.0488 67.75 27.0488C69.8021 27.0488 71.1181 28.6568 71.1181 31.227V31.2353C71.1181 33.8 69.7939 35.4135 67.7733 35.4135C66.6328 35.4135 65.7062 34.8322 65.2319 33.8987H65.1935V37.933H63.5403V27.201ZM69.4347 31.2353V31.227C69.4347 29.5122 68.615 28.4649 67.3223 28.4649C66.0667 28.4649 65.1866 29.5519 65.1866 31.227V31.2353C65.1866 32.9049 66.0749 33.9906 67.3223 33.9906C68.6218 33.9906 69.4347 32.9337 69.4347 31.2353Z"
            fill="white"
          />
          <path
            d="M72.7504 27.201H74.4036V28.5869H74.4419C74.9245 27.63 75.8114 27.0488 76.9601 27.0488C79.0122 27.0488 80.3282 28.6568 80.3282 31.227V31.2353C80.3282 33.8 79.004 35.4135 76.9834 35.4135C75.8429 35.4135 74.9162 34.8322 74.4419 33.8987H74.4036V37.933H72.7504V27.201ZM78.6434 31.2353V31.227C78.6434 29.5122 77.8237 28.4649 76.531 28.4649C75.2754 28.4649 74.3953 29.5519 74.3953 31.227V31.2353C74.3953 32.9049 75.2836 33.9906 76.531 33.9906C77.8319 33.9906 78.6434 32.9337 78.6434 31.2353Z"
            fill="white"
          />
          <path
            d="M81.7852 24.209H83.4397V35.2535H81.7852V24.209Z"
            fill="white"
          />
          <path
            d="M85.0475 31.2566V31.2484C85.0475 28.7302 86.5019 27.0469 88.761 27.0469C91.0201 27.0469 92.4046 28.6685 92.4046 31.088V31.6473H86.7034C86.7336 33.1702 87.5684 34.0572 88.8844 34.0572C89.8645 34.0572 90.5156 33.5527 90.7226 32.9482L90.7459 32.8865H92.3141L92.299 32.9715C92.0399 34.2491 90.798 35.4129 88.8473 35.4129C86.48 35.4129 85.0475 33.7981 85.0475 31.2566ZM86.7253 30.4766H90.7665C90.628 29.0839 89.848 28.4026 88.7692 28.4026C87.6959 28.4026 86.8693 29.1291 86.7253 30.4766Z"
            fill="white"
          />
          <path
            d="M97.6604 24.209H99.4438L101.504 32.8656H101.534L103.869 24.209H105.49L107.825 32.8656H107.863L109.922 24.209H111.707L108.721 35.2535H107.076L104.704 26.9259H104.664L102.283 35.2535H100.636L97.6604 24.209Z"
            fill="white"
          />
          <path
            d="M112.177 32.9633V32.9482C112.177 31.5472 113.265 30.6905 115.171 30.5753L117.359 30.4451V29.8406C117.359 28.9537 116.784 28.4163 115.759 28.4163C114.802 28.4163 114.213 28.8687 114.076 29.5116L114.059 29.5815H112.499L112.506 29.4965C112.621 28.1106 113.823 27.0469 115.806 27.0469C117.773 27.0469 119.02 28.0887 119.02 29.7021V35.2511H117.359V33.9804H117.328C116.861 34.8454 115.929 35.3964 114.864 35.3964C113.257 35.3978 112.177 34.4108 112.177 32.9633ZM115.315 34.075C116.477 34.075 117.359 33.2868 117.359 32.2367V31.6089L115.392 31.7323C114.398 31.7926 113.845 32.2285 113.845 32.9098V32.9262C113.845 33.6295 114.428 34.075 115.315 34.075Z"
            fill="white"
          />
          <path
            d="M120.832 24.209H122.485V35.2535H120.832V24.209Z"
            fill="white"
          />
          <path
            d="M124.813 24.209H126.466V35.2535H124.813V24.209Z"
            fill="white"
          />
          <path
            d="M127.92 31.2566V31.2484C127.92 28.7302 129.373 27.0469 131.632 27.0469C133.891 27.0469 135.277 28.6685 135.277 31.088V31.6473H129.574C129.605 33.1702 130.439 34.0572 131.757 34.0572C132.737 34.0572 133.387 33.5527 133.594 32.9482L133.618 32.8865H135.186L135.171 32.9715C134.911 34.2491 133.67 35.4129 131.718 35.4129C129.351 35.4129 127.92 33.7981 127.92 31.2566ZM129.596 30.4766H133.639C133.5 29.0839 132.72 28.4026 131.64 28.4026C130.568 28.4026 129.742 29.1291 129.596 30.4766Z"
            fill="white"
          />
          <path
            d="M137.374 33.1337V28.5182H136.217V27.2008H137.374V25.1035H139.064V27.2008H140.572V28.5182H139.064V33.0336C139.064 33.8533 139.433 34.0973 140.128 34.0973C140.305 34.0973 140.449 34.0809 140.572 34.0672V35.3448C140.38 35.3749 140.068 35.4133 139.73 35.4133C138.139 35.4147 137.374 34.7416 137.374 33.1337Z"
            fill="white"
          />
          <path
            d="M57.9364 17.1107H54.6355L53.802 19.4863H52.715L55.7746 11.1875H56.7986L59.8582 19.4863H58.7712L57.9364 17.1107ZM54.9411 16.2307H57.6334L56.3325 12.5268H56.2407L54.9411 16.2307Z"
            fill="white"
          />
          <path
            d="M60.5154 16.3856C60.5154 14.4418 61.5448 13.1765 63.1213 13.1765C63.9835 13.1765 64.7141 13.585 65.0651 14.2636H65.1514V10.8242H66.1412V19.4849H65.198V18.4952H65.1062C64.7155 19.1847 63.9794 19.5932 63.1213 19.5932C61.5339 19.5946 60.5154 18.3348 60.5154 16.3856ZM61.5394 16.3856C61.5394 17.8345 62.2179 18.7036 63.3516 18.7036C64.4784 18.7036 65.1747 17.8181 65.1747 16.3856C65.1747 14.9654 64.4729 14.0675 63.3516 14.0675C62.2234 14.0675 61.5394 14.9421 61.5394 16.3856Z"
            fill="white"
          />
          <path
            d="M67.7362 16.3856C67.7362 14.4418 68.7657 13.1765 70.3421 13.1765C71.2043 13.1765 71.935 13.585 72.2859 14.2636H72.3723V10.8242H73.362V19.4849H72.4189V18.4952H72.3257C71.935 19.1847 71.1989 19.5932 70.3407 19.5932C68.7533 19.5946 67.7362 18.3348 67.7362 16.3856ZM68.7588 16.3856C68.7588 17.8345 69.4374 18.7036 70.571 18.7036C71.6978 18.7036 72.3942 17.8181 72.3942 16.3856C72.3942 14.9654 71.6923 14.0675 70.571 14.0675C69.4429 14.0675 68.7588 14.9421 68.7588 16.3856Z"
            fill="white"
          />
          <path
            d="M79.9808 11.6816V13.2868H81.3626V14.1148H79.9808V17.6241C79.9808 18.3547 80.2577 18.6645 80.902 18.6645C81.0802 18.6645 81.1775 18.659 81.3626 18.6412V19.4746C81.1652 19.5089 80.9774 19.5322 80.7814 19.5322C79.5052 19.5322 78.9925 19.0607 78.9925 17.8763V14.1148H77.9932V13.2868H78.9925V11.6816H79.9808Z"
            fill="white"
          />
          <path
            d="M82.4456 16.3848C82.4456 14.3889 83.5395 13.1758 85.3051 13.1758C87.0706 13.1758 88.1632 14.3889 88.1632 16.3848C88.1632 18.3739 87.0706 19.5939 85.3051 19.5939C83.5395 19.5939 82.4456 18.3739 82.4456 16.3848ZM87.1392 16.3848C87.1392 14.9126 86.4771 14.0668 85.3037 14.0668C84.1303 14.0668 83.4682 14.9126 83.4682 16.3848C83.4682 17.8516 84.1289 18.7029 85.3037 18.7029C86.4771 18.7029 87.1392 17.8516 87.1392 16.3848Z"
            fill="white"
          />
          <defs>
            <pattern
              id="pattern0_4813_105989"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image0_4813_105989"
                transform="scale(0.00884956 0.0172414)"
              />
            </pattern>
            <pattern
              id="pattern1_4813_105989"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image1_4813_105989"
                transform="scale(0.00884956 0.0172414)"
              />
            </pattern>
            <pattern
              id="pattern2_4813_105989"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image2_4813_105989"
                transform="scale(0.00884956 0.0172414)"
              />
            </pattern>
            <pattern
              id="pattern3_4813_105989"
              patternContentUnits="objectBoundingBox"
              width="1"
              height="1"
            >
              <use
                xlinkHref="#image3_4813_105989"
                transform="scale(0.008 0.0172414)"
              />
            </pattern>
            <image
              id="image0_4813_105989"
              width="113"
              height="58"
              preserveAspectRatio="none"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHEAAAA6CAYAAACH4bZ/AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAArlJREFUeNrsnG1vEkEUhXeXBSpUFCW+6zdN/P8/qGk00WhFY6CWsqD3JmfS6bpLoWGXNnlOckJ32NkPPNw7MzT3JglCCKE9KN3zfWh/+rsPiGn0Ghs1D6/sW0H08czckXNdZ4BsHODavDIXel3dBDOvGAuwuuYj8wO5r/uJyGYBOryF+Vy+0Fhtis1rItCBHZvH5qfmx7ruKzJZJ5tZ/wLA3+Yz+ZdgFttATKMIdGDPzW/lFwJ6JIgAbAZkIWAO75P5RO95hP6pS6vlSOwI1FjwPprfm18pGoHYDsRv5pHGF/IyWh9rIWa6Hpgn5ncC+MH80vzQ3GNNbBTiSmvgSDzm5p9KqXOB/C8a89IxIqRSh/ja/EZROFEU5gBsVGttIjOlz+/mz+YvArnQPbUQO4q0Y21mngneSA/u6eGo2Wh0FkMtXxOxGEWbyuWmdBrWQ5/wRB5FEcgZsR2FYAogx1rK4v1IGkdjVorEvib45EdaH7sAbE1picVAPIYCW7mpzCrS6VATB5smokZBhk1mTzC7m35oyUrfgFwT+noAafTwEdkppdGkDuLOE1FrIG/850N224no7ogjAxAREBEQERCBiICIgIiACEQERAREBEQgIiAiICIgAhEBEQERARGICIgIiAiIQET3RXnN+M4NcdDetPNnn1c8YJ1cb4gTeqhQl9EexPC5ryIeWzUjCgC9nNiL/73QfxbdB8R2Ic7E4EJMakHmJYCXmjg1fxU4Lzal0LRdiB6B52IwFZPLOpB5ib53bPBGOKca934qoVYctafQCmUqFmdiU2wDcSZwiR7gnTS6CbWKh9jYLMXjh5jMIojXQMbtMP244SXe3u5kmFw1XSCVHi6lLpVW54rEypSalv4OBf/B1OsfFuQ62qkWdWtiWnFNufc9OzNualqL7hZMhBBCzeqfAAMARUSzZ7uCWKkAAAAASUVORK5CYII="
            />
            <image
              id="image1_4813_105989"
              width="113"
              height="58"
              preserveAspectRatio="none"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHEAAAA6CAYAAACH4bZ/AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAqFJREFUeNrsnNtu00AURW3HdkJKUxAX8YAqUN/4//9BCCQQlIBQUtrGSZkj7ZGmxpNLZU9baS1pK7Xr8UNWzxkn1UyWAQBAD+Q9XQP9c9OHxLwjkEZeOwdL9MJGSqnXApFJBG5c1i6NXte7ZJYRgXZ+4jJVxjqHyOEFmrwrlwvlUueiLbZLYilxz1xeKrNAJPPkcPOfF/jH5Vz5LZnNPhJ9C51I4FuXdy6nEjnV9QgcTmQjYSbvs8tH/c4q9G+srXZJNFmvXN67fHA5c3mNxKQSv6v7ZapMyyqYHzsl5prvKpcjVd6pBJ7peCLJSBxO4lpz4Ew+li6/1FKXEvlfNZaR+fC5qu+NqtLaa60bw3BY23yi99na5w+XLy5fJfJK19xsq8RaEk8kbqbjWlVKFQ5fjbm6oX+wfBE8WI5UjdF2OpKspxo0019FFbRRJA6P9+BFWlc8bk1neViNRWvwWBJPgoElApMRftEyVhc8ltA69kxSdFTiVCKn2wbCoCILFU8tmdW2Yio6vqmp9hkIySpytGs6K+46EJKJ3PkPiOKuA+HhwOc+JAISAYmARCQCEgGJgEQkAhIBiYBEJAISAYmARCQCEgGJgEQkAhIBiYBEJMJjoYycP3hDHOiNg9/7suMGm+z2hjh+DxXWZaST6N/3deBjr82IvEBbTmyL/22h/yK4DolpJS7k4FJOoiLLlsBrDZy7fJM4W2zKQtO0Eq0CL+RgLifXMZFly77t2GAb4XzSedtPxa8Vh3T4rVDmcnEuN80+EhcSl+kGtuzb75pBJaZ9sFnJx085WQQSb4nMg1e/BYrtmHGkNlrRSu+1pa7UVpeqxM6Wmrd+9gv+fdhV8X5FboIn1SY2J+Ydxyz3fmSfGWOSkPfwZAIAwLD8E2AAOBuy81Gw3f4AAAAASUVORK5CYII="
            />
            <image
              id="image2_4813_105989"
              width="113"
              height="58"
              preserveAspectRatio="none"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHEAAAA6CAYAAACH4bZ/AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAvBJREFUeNrsnFtv00AQhX1NgkkvEYW+ICQET/z//4NASEBbUi5JyMVOmJHOiMF4mzRJnVQ6RzrazdbrB3+and1KO1FEURRFUZQqvsczcaBP7aYV3NTfGaKBSlybwokbp3YDuIQreOnGV5vAjO+AZ8BycSbuwF20GSNyLxFYiufiGdo5xhYO7J0wswBAHe+JC/FTtNbvo98B5IggtwIYAZBCm4hH4jH6E9efAmpwiW2CmAHSufhC/Fw8EJ+JT9H2EZEpAe4EskIEKsAf4p9ob8XX4hvxd8AsN4FoS2gPAF+KX4tfiV9gTCGeuEhkXtw9H1ok/gJEhXYl/ih+j2f1ud+hZbUJYoHoU4DvxG/FlwD4BJCZE/efE6cApSC/IlgiROrM5cggRNt95sh7F4hABfgGvwu3yUkJcK8gK7eZmSBdxciLt4jOMf7+XzRmgXw4wBJ6CYDnyIGJg0eA+wNpu/8l2hhRqXnxk/gzQM7c0SMYiR1APHM5sABALp8P+w+XFRhEWA1tY/kMHGwjuai/IKnlww5C+dTlwLwWgdTDwfQcDOQA+bEXSmOJ66eg3Uck2kRG4GFAdrEKngBoJ3Ska4rEouFAT4Dtgkxcnuy6DWW8DqJtbPJNJlKtRWS67jSQbDuRag3k2tNAsu1E6niU8BMQIkWIFCFShEiIFCFShEgRIiFShEgRIkWIhEgRIkWIFCESIkWIFCFShEiIFCFShEgRIiFSj0RZYHzVYKod3fvbZw0v8BWOyuhvDRXey2gPon33yvHYqBiRAdTrxFrJQS/6j9xzhNguRCtONAWTIMisBnCOiUPxF4DTy6a8aNouRI3ACRgMwWQeApnV6GvFBq1i9AHjWhTH7opT7alCBA7B4gZsyk0gjgAuwgv02nce8a7iITY2C/D4BiYjB/EfkL5+qZVA0YoZVpQv51J60CXVihONEYmNS2pc69uFfzNrtx0W5NLtVMtQTowbfvO69yM7M4YgEd7xwaQo6qj1R4ABAM5x0/sxgGqpAAAAAElFTkSuQmCC"
            />
            <image
              id="image3_4813_105989"
              width="125"
              height="58"
              preserveAspectRatio="none"
              xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH0AAAA6CAYAAACd3VbxAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABMZJREFUeNrsnQtz0kAUhTfJ8iog2LdI7VhH6/j//5DjjLa1D22hBQrEXT13uOwECBSTEO6ZObNIKWbvt3v3EdgqJRKJRCKRKA/y1vSaJBTmLK6pxc1bcOGu07roMOJxlhqC58RMpRwzHqvQjZs3pxK+sWb2U6iEvdAxPILpuTCiQaQF2mdlAPspxYzHbchMMYu8ILr4onHFuGq8Y1xAZbyEW6q94IFxH+WQNQD+eJwQfKo/B6wRnwLiVkKpU+jxIeLxbPxo3DV+Quz+gtczKqUBfN/40HjPuIZKJVEJAjfCxdLF27LHGsET3EMlR/8ZPNU9QCzKiBN5B52khsdFvDapcZ46io1Fx/jG+Mr4GsCfF0GvAfhH41PjXVQySLjF9lGBe5SPAP1g/Mv4DmUH8KdS2ZqB05BXRnyaiIstG8Z1lK/w81LC2ZE6io3DrfFXPNdDHG1svDg93QL/bPwGrTdIsNWOWU8n4GQL+qfxd/gSzz2iRa8TPAEvIAYW8pFxCz4E/Doz9fQkx3XqKDYGP/DcHeJEQ43SC8b0KipzbPwWrVcnnKqGgEhpfYCefo/U9Q29i2ehdYJ3gduhrm383vjM+ATQm/h5JcUxneLVweMrMJxqfDpGRctsnKonCJ2DHzkm8AfGr1kq9dnvdgH+JWO8xzIfAX9n/Mn4HNBbuIYdBlqzjJj0JG6Ix1WwK7jZRsdo4T6boeqEoVNFdMQSroaKVdjYqZzl3Zgt81aFHiB4TfRwC/wLyjYagru6SWtvI2RcZy4b9RKtPa3KeE6FAtYQNFs28dl+n83mexGbOsuk9RImZsfo2ecAfgrg1YjelOamzEJOWm2OvAUVi5r0DSI2dJYdx6uAa8fuD/CJs4z1Vba2Xudqk6AvAkPLuy6Wc138e8TWrnHAu++7izR+BrfxXHUTgW869Hk9kvf0sTOxG89I994SPXxjgecB+qyxt89SO80DbiJSfhix01Z0lmZ8pn6M/6O0qcDzAj1qls334gNAqmCXqst2p3ij0HgdpfSWM3Fr473LKeyyCfQ5kzxaT5MoA9CW6SV2qB6wzqd1fAGNoo419xHW42fYhOFLszRuogj0mDtnivX+BnbNLtS/mw+32NHr4XVlpG3bw/fZDmQLDaDJ1uL+JgPPG/SoiV3AxvoDwL5B+RtjvALQBqDvsbKJLFFW6X2mQKAvCd5nqbuBXsvv2PGeXlOTu2P0GYJyxE6bEujZH+P57dC6muzY9Z0xvaQmN0oKanorU+UFeJ6hc0j8/kER8N1P2/BPwQQsW+QK9jZAd+HTnj2l/Kh1uspTGt9m6G4DcG/gqLz2aIE+OwNsnXwlEugigS4S6CKBLhLoIoEuEugigS4S6CKBLhLoIoEuEugigS4S6CKBLhLo26g4H5eaefKgKHOKxUoveAN+WiOdPGjlSXwzC504jRi/MA50Ak6nOtlvenbY7wj0bEPvgBkdqjgFXs8BPsAv2u99XQB0kufIiVaDTufIXajJV7MHHLye01rsV3ntNzzp1EF7JlmSJ0aKVpN7YuQ1WA7jQO8AtMIbJHk2rOhlEzn3bNgOgx5m+RRo0ctS/MxToLN+3rtodfBLnffOwWfhLzuI1rxm36S/4SJaHb5o2/VHgAEAKq1w/7wLXkMAAAAASUVORK5CYII="
            />
          </defs>
        </svg>
      );
    case 'chat_search':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <g clipPath="url(#clip0_4322_3654)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16.3497 16.9498C16.3497 17.2811 16.6183 17.5498 16.9497 17.5498C17.2811 17.5498 17.5497 17.2811 17.5497 16.9498L17.5497 7.05027C17.5497 6.7189 17.2811 6.45027 16.9497 6.45027L7.05021 6.45027C6.71884 6.45027 6.45021 6.7189 6.45022 7.05027C6.45022 7.38164 6.71884 7.65027 7.05021 7.65027L15.5011 7.65027L6.62594 16.5255C6.39163 16.7598 6.39163 17.1397 6.62594 17.374C6.86026 17.6083 7.24016 17.6083 7.47447 17.374L16.3497 8.49875L16.3497 16.9498Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_4322_3654">
              <rect width="24" height="24" rx="12" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'chat_pause':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <g clipPath="url(#clip0_4322_4424)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M10.1639 10.1919C10.1639 10.2073 10.1764 10.2198 10.1918 10.2198C10.2072 10.2198 10.2197 10.2073 10.2197 10.1919L10.2197 9.80811C10.2197 9.80071 10.2168 9.79361 10.2115 9.78838C10.2063 9.78314 10.1992 9.7802 10.1918 9.7802L9.80802 9.7802C9.7926 9.7802 9.78011 9.7927 9.78011 9.80811C9.78011 9.82353 9.7926 9.83603 9.80802 9.83603L10.1244 9.83603L9.78828 10.1721C9.77738 10.183 9.77738 10.2007 9.78828 10.2116C9.79918 10.2225 9.81686 10.2225 9.82776 10.2116L10.1639 9.8755L10.1639 10.1919Z"
              fill="white"
            />
            <rect
              width="10"
              height="10"
              rx="2"
              transform="matrix(1 0 0 -1 5 15)"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_4322_4424">
              <rect width="20" height="20" rx="10" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'link_circle_black':
      return (
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="0.5"
            width="27"
            height="27"
            rx="13.5"
            stroke="#E7E9EC"
          />
          <path
            d="M17.4995 12.0924L17.4995 11.1921C17.4995 10.7325 17.409 10.2775 17.2331 9.85284C17.0572 9.42823 16.7994 9.04242 16.4744 8.71744C16.1495 8.39246 15.7636 8.13467 15.339 7.95879C14.9144 7.78291 14.4593 7.69238 13.9997 7.69238C13.5401 7.69238 13.085 7.78291 12.6604 7.95879C12.2358 8.13467 11.85 8.39246 11.525 8.71744C11.2 9.04242 10.9422 9.42823 10.7663 9.85284C10.5905 10.2775 10.4999 10.7325 10.4999 11.1921L10.4999 12.0924"
            stroke="black"
            strokeLinecap="round"
          />
          <path
            d="M10.5004 15.9068L10.5004 16.8069C10.5004 17.2665 10.5909 17.7216 10.7668 18.1462C10.9427 18.5708 11.2004 18.9566 11.5254 19.2816C11.8504 19.6066 12.2362 19.8644 12.6608 20.0402C13.0855 20.2161 13.5406 20.3066 14.0002 20.3066C14.4598 20.3066 14.9149 20.2161 15.3395 20.0402C15.7641 19.8644 16.1499 19.6066 16.4749 19.2816C16.7999 18.9566 17.0577 18.5708 17.2335 18.1462C17.4094 17.7216 17.5 17.2665 17.5 16.8069L17.5 15.9068"
            stroke="black"
            strokeLinecap="round"
          />
          <path
            d="M14.0001 11.8994L14.0001 16.0991"
            stroke="black"
            strokeLinecap="round"
          />
        </svg>
      );

    case 'right_arrow_white':
      return (
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="32" height="32" rx="16" fill="black" />
          <g clipPath="url(#clip0_4311_8075)">
            <path
              d="M22 16H9"
              stroke="white"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M16 23L23 16L16 9"
              stroke="white"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_4311_8075">
              <rect
                width="24"
                height="24"
                fill="white"
                transform="translate(4 4)"
              />
            </clipPath>
          </defs>
        </svg>
      );
    case 'link_circle_24':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="2.41667"
            y="2.41667"
            width="19.1667"
            height="19.1667"
            rx="9.58333"
            stroke="#E7E9EC"
            strokeWidth="0.833333"
          />
          <path
            d="M14.917 10.4109L14.917 9.66061C14.917 9.27761 14.8416 8.89837 14.695 8.54452C14.5484 8.19068 14.3336 7.86917 14.0628 7.59835C13.7919 7.32754 13.4704 7.11271 13.1166 6.96614C12.7627 6.81958 12.3835 6.74414 12.0005 6.74414C11.6175 6.74414 11.2382 6.81958 10.8844 6.96614C10.5306 7.11271 10.209 7.32754 9.93823 7.59835C9.6674 7.86917 9.45258 8.19068 9.30601 8.54452C9.15944 8.89837 9.084 9.27761 9.084 9.66061L9.084 10.4109"
            stroke="#888D96"
            strokeLinecap="round"
          />
          <path
            d="M9.08398 13.5893L9.08398 14.3394C9.08398 14.7224 9.15942 15.1016 9.30599 15.4555C9.45256 15.8093 9.66738 16.1308 9.93821 16.4016C10.209 16.6725 10.5305 16.8873 10.8844 17.0339C11.2382 17.1804 11.6175 17.2559 12.0005 17.2559C12.3835 17.2559 12.7627 17.1804 13.1166 17.0339C13.4704 16.8873 13.7919 16.6725 14.0628 16.4016C14.3336 16.1308 14.5484 15.8093 14.695 15.4555C14.8415 15.1016 14.917 14.7224 14.917 14.3394L14.917 13.5893"
            stroke="#888D96"
            strokeLinecap="round"
          />
          <path
            d="M12 10.25L12 13.7498"
            stroke="#888D96"
            strokeLinecap="round"
          />
        </svg>
      );

    case 'link_circle':
      return (
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="0.5"
            width="27"
            height="27"
            rx="13.5"
            stroke="#E7E9EC"
          />
          <path
            d="M17.4995 12.0924L17.4995 11.1921C17.4995 10.7325 17.409 10.2775 17.2331 9.85284C17.0572 9.42823 16.7994 9.04242 16.4744 8.71744C16.1495 8.39246 15.7636 8.13467 15.339 7.95879C14.9144 7.78291 14.4593 7.69238 13.9997 7.69238C13.5401 7.69238 13.085 7.78291 12.6604 7.95879C12.2358 8.13467 11.85 8.39246 11.525 8.71744C11.2 9.04242 10.9422 9.42823 10.7663 9.85284C10.5905 10.2775 10.4999 10.7325 10.4999 11.1921L10.4999 12.0924"
            stroke="white"
            strokeLinecap="round"
          />
          <path
            d="M10.5005 15.9068L10.5005 16.8069C10.5005 17.2665 10.591 17.7216 10.7669 18.1462C10.9428 18.5708 11.2006 18.9566 11.5256 19.2816C11.8505 19.6066 12.2364 19.8644 12.661 20.0402C13.0856 20.2161 13.5407 20.3066 14.0003 20.3066C14.4599 20.3066 14.915 20.2161 15.3396 20.0402C15.7642 19.8644 16.15 19.6066 16.475 19.2816C16.8 18.9566 17.0578 18.5708 17.2337 18.1462C17.4095 17.7216 17.5001 17.2665 17.5001 16.8069L17.5001 15.9068"
            stroke="white"
            strokeLinecap="round"
          />
          <path
            d="M14.0002 11.8994L14.0002 16.0991"
            stroke="white"
            strokeLinecap="round"
          />
        </svg>
      );

    case 'search_white':
      return (
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.6133 13.0576C20.6133 15.144 19.7676 17.0329 18.4003 18.4002C17.033 19.7675 15.1441 20.6132 13.0576 20.6132C8.88474 20.6132 5.50195 17.2305 5.50195 13.0576C5.50195 8.88473 8.88474 5.50195 13.0576 5.50195C17.2305 5.50195 20.6133 8.88473 20.6133 13.0576Z"
            stroke="white"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.502 22.502L18.3994 18.3994"
            stroke="white"
            strokeWidth="1.2"
            strokeLinecap="round"
          />
        </svg>
      );
    case 'back_white':
      return (
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_4311_8036)">
            <path
              d="M7 14L22.1667 14"
              stroke="white"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13.9997 5.83398L5.83301 14.0007L13.9997 22.1673"
              stroke="white"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_4311_8036">
              <rect width="28" height="28" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'bookMark':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M5 5C5 4.44772 5.44772 4 6 4H14C14.5523 4 15 4.44772 15 5V16.0503C15 16.4528 14.5488 16.6903 14.217 16.4626L10 13.568L5.78296 16.4626C5.45117 16.6903 5 16.4528 5 16.0503V5Z"
            fill="black"
          />
        </svg>
      );
    case 'bookMark_empty':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M10.283 13.1558C10.1125 13.0387 9.88753 13.0387 9.71704 13.1558L5.5 16.0503L5.5 5C5.5 4.72386 5.72386 4.5 6 4.5H14C14.2761 4.5 14.5 4.72386 14.5 5L14.5 16.0503L10.283 13.1558Z"
            stroke="#888D96"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'link_mini':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="8"
          height="12"
          viewBox="0 0 8 12"
          fill="none"
        >
          <path
            d="M6.91602 4.41086L6.91602 3.66061C6.91602 3.27761 6.84058 2.89837 6.69401 2.54452C6.54744 2.19068 6.33262 1.86917 6.06179 1.59835C5.79097 1.32754 5.46946 1.11271 5.11562 0.966143C4.76177 0.819577 4.38252 0.744141 3.99952 0.74414C3.61652 0.74414 3.23727 0.819577 2.88343 0.966143C2.52958 1.11271 2.20807 1.32754 1.93725 1.59835C1.66643 1.86917 1.4516 2.19068 1.30503 2.54452C1.15847 2.89837 1.08303 3.27761 1.08303 3.66061L1.08303 4.41086"
            stroke="#888D96"
            strokeLinecap="round"
          />
          <path
            d="M1.0835 7.58931L1.0835 8.33939C1.0835 8.72239 1.15893 9.10163 1.3055 9.45547C1.45207 9.80932 1.6669 10.1308 1.93772 10.4016C2.20854 10.6725 2.53005 10.8873 2.8839 11.0339C3.23774 11.1804 3.61699 11.2559 3.99999 11.2559C4.38299 11.2559 4.76224 11.1804 5.11608 11.0339C5.46993 10.8873 5.79144 10.6725 6.06226 10.4016C6.33308 10.1308 6.54791 9.80932 6.69448 9.45548C6.84105 9.10163 6.91648 8.72239 6.91648 8.33939L6.91648 7.58931"
            stroke="#888D96"
            strokeLinecap="round"
          />
          <path d="M4 4.25L4 7.74976" stroke="#888D96" strokeLinecap="round" />
        </svg>
      );
    case 'x2':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
        >
          <path
            d="M11.5 0.5L0.500002 11.5"
            stroke="black"
            strokeWidth="0.96"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M0.5 0.5L11.5 11.5"
            stroke="black"
            strokeWidth="0.96"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'link2':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="8"
          height="14"
          viewBox="0 0 8 14"
          fill="none"
        >
          <path
            d="M7.49951 5.09244L7.49951 4.19214C7.49951 3.73255 7.40899 3.27745 7.23311 2.85284C7.05722 2.42823 6.79943 2.04242 6.47445 1.71744C6.14946 1.39246 5.76365 1.13467 5.33903 0.958786C4.91442 0.782907 4.45932 0.692383 3.99972 0.692383C3.54012 0.692383 3.08502 0.782907 2.66041 0.958786C2.23579 1.13467 1.84998 1.39246 1.52499 1.71744C1.20001 2.04242 0.942213 2.42823 0.766332 2.85284C0.590451 3.27745 0.499926 3.73255 0.499926 4.19214L0.499926 5.09244"
            stroke="black"
            strokeLinecap="round"
          />
          <path
            d="M0.500489 8.90678L0.500489 9.80688C0.500489 10.2665 0.591013 10.7216 0.766894 11.1462C0.942775 11.5708 1.20057 11.9566 1.52555 12.2816C1.85054 12.6066 2.23635 12.8644 2.66097 13.0402C3.08558 13.2161 3.54068 13.3066 4.00028 13.3066C4.45988 13.3066 4.91498 13.2161 5.33959 13.0402C5.76421 12.8644 6.15002 12.6066 6.47501 12.2816C6.79999 11.9566 7.05779 11.5708 7.23367 11.1462C7.40955 10.7216 7.50007 10.2665 7.50007 9.80688L7.50007 8.90678"
            stroke="black"
            strokeLinecap="round"
          />
          <path
            d="M4.00024 4.89941L4.00024 9.09913"
            stroke="black"
            strokeLinecap="round"
          />
        </svg>
      );
    case 'teams2':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="16"
          viewBox="0 0 19 16"
          fill="none"
        >
          <g clipPath="url(#clip0_2480_110970)">
            <mask
              id="mask0_2480_110970"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="19"
              height="16"
            >
              <path d="M0.5 0H18.5V16H0.5V0Z" fill="white" />
            </mask>
            <g mask="url(#mask0_2480_110970)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.7297 1.4053C16.7707 1.4053 17.6147 2.2283 17.6147 3.2453C17.6147 4.2603 16.7707 5.0843 15.7297 5.0843C14.6877 5.0843 13.8438 4.2603 13.8438 3.2443C13.8438 2.2283 14.6877 1.4053 15.7297 1.4053Z"
                fill="url(#paint0_linear_2480_110970)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.7718 6.18264H13.6948C13.2948 6.18264 12.9668 6.50264 12.9668 6.89264V10.7876C12.9668 12.2476 14.1928 13.4446 15.6898 13.4446H15.7748C17.2728 13.4446 18.4988 12.2486 18.4988 10.7876V6.89164C18.4988 6.50164 18.1708 6.18164 17.7708 6.18164L17.7718 6.18264Z"
                fill="url(#paint1_linear_2480_110970)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.95852 0C11.3985 0 12.5645 1.137 12.5645 2.542C12.5645 3.947 11.3985 5.084 9.95852 5.084C8.51852 5.084 7.35352 3.947 7.35352 2.542C7.35352 1.137 8.52052 0 9.95852 0Z"
                fill="url(#paint2_linear_2480_110970)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.6973 6.18362H6.22033C6.02827 6.18201 5.84337 6.25636 5.70589 6.39047C5.5684 6.52458 5.48949 6.70759 5.48633 6.89962V11.7046C5.48633 14.0676 7.46833 15.9996 9.89033 15.9996H10.0273C12.4493 15.9996 14.4303 14.0666 14.4303 11.7046V6.89962C14.4272 6.70759 14.3483 6.52458 14.2108 6.39047C14.0733 6.25636 13.8894 6.18201 13.6973 6.18362Z"
                fill="url(#paint3_linear_2480_110970)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.22 12.4393H8.827C9.223 12.4393 9.547 12.1233 9.547 11.7363V4.31631C9.5441 4.12781 9.46678 3.94811 9.33189 3.81641C9.19701 3.68471 9.01551 3.6117 8.827 3.61331H1.22C1.03149 3.6117 0.849993 3.68471 0.715109 3.81641C0.580224 3.94811 0.502897 4.12781 0.5 4.31631L0.5 11.7363C0.5 12.1223 0.824 12.4393 1.22 12.4393Z"
                fill="url(#paint4_linear_2480_110970)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.22 12.4393H8.827C9.223 12.4393 9.547 12.1233 9.547 11.7363V4.31631C9.5441 4.12781 9.46678 3.94811 9.33189 3.81641C9.19701 3.68471 9.01551 3.6117 8.827 3.61331H8.781C9.172 3.61331 9.492 3.92631 9.492 4.30731V11.6843C9.492 12.0653 9.172 12.3783 8.782 12.3783H1.265C1.07905 12.3796 0.900098 12.3075 0.767117 12.1775C0.634136 12.0475 0.557897 11.8702 0.555 11.6843V4.30731C0.555 3.92631 0.875 3.61331 1.265 3.61331H1.22C1.03149 3.6117 0.849993 3.68471 0.715109 3.81641C0.580224 3.94811 0.502897 4.12781 0.5 4.31631V11.7363C0.5 12.1223 0.824 12.4393 1.22 12.4393Z"
                fill="url(#paint5_linear_2480_110970)"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.92969 5.74609H6.75369V6.52609H5.31869V10.3061H4.36569V6.52609H2.92969V5.74609Z"
                fill="url(#paint6_linear_2480_110970)"
              />
            </g>
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_2480_110970"
              x1="19.5587"
              y1="3.9353"
              x2="15.7607"
              y2="2.7373"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#4A5FCB" />
              <stop offset="1" stopColor="#1C245F" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_2480_110970"
              x1="20.6128"
              y1="10.7656"
              x2="14.8058"
              y2="9.40464"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#5468E8" />
              <stop offset="1" stopColor="#2F3C90" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_2480_110970"
              x1="14.1805"
              y1="3.41"
              x2="8.93152"
              y2="1.755"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#6B80F3" />
              <stop offset="1" stopColor="#464FA9" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_2480_110970"
              x1="16.2693"
              y1="12.4796"
              x2="7.08633"
              y2="9.90562"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#8094FF" />
              <stop offset="1" stopColor="#5060DA" />
            </linearGradient>
            <linearGradient
              id="paint4_linear_2480_110970"
              x1="10.897"
              y1="9.79731"
              x2="1.785"
              y2="6.92331"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#3744AE" />
              <stop offset="1" stopColor="#243176" />
            </linearGradient>
            <linearGradient
              id="paint5_linear_2480_110970"
              x1="1.534"
              y1="8.42431"
              x2="11.108"
              y2="8.42431"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#5160B4" />
              <stop offset="0.5" stopColor="#2E3C8F" />
              <stop offset="1" stopColor="#5367E7" />
            </linearGradient>
            <linearGradient
              id="paint6_linear_2480_110970"
              x1="4.10569"
              y1="8.42309"
              x2="8.15169"
              y2="8.42309"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#C1CFCF" />
              <stop offset="1" stopColor="#FEFEFE" />
            </linearGradient>
            <clipPath id="clip0_2480_110970">
              <rect
                width="18"
                height="16"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      );
    case 'star':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <path
            d="M11.6221 8.01048C11.8246 7.56219 12.4612 7.56219 12.6636 8.01048L14.8986 12.959C14.9559 13.0857 15.0574 13.1873 15.1842 13.2445L20.1327 15.4795C20.5809 15.682 20.5809 16.3186 20.1327 16.5211L15.1842 18.756C15.0574 18.8133 14.9559 18.9148 14.8986 19.0416L12.6636 23.9901C12.4612 24.4384 11.8246 24.4384 11.6221 23.9901L9.38712 19.0416C9.32986 18.9148 9.22832 18.8133 9.10155 18.756L4.15306 16.5211C3.70477 16.3186 3.70477 15.682 4.15306 15.4795L9.10155 13.2445C9.22832 13.1873 9.32986 13.0857 9.38712 12.959L11.6221 8.01048Z"
            fill="#34383D"
          />
          <path
            d="M21.8661 4.61257C21.9737 4.37441 22.3119 4.37441 22.4194 4.61256L23.6068 7.24145C23.6372 7.3088 23.6911 7.36274 23.7585 7.39316L26.3874 8.58048C26.6255 8.68804 26.6255 9.02624 26.3874 9.13381L23.7585 10.3211C23.6911 10.3515 23.6372 10.4055 23.6068 10.4728L22.4195 13.1017C22.3119 13.3399 21.9737 13.3399 21.8661 13.1017L20.6788 10.4728C20.6484 10.4055 20.5944 10.3515 20.5271 10.3211L17.8982 9.13381C17.6601 9.02624 17.6601 8.68804 17.8982 8.58048L20.5271 7.39316C20.5944 7.36274 20.6484 7.3088 20.6788 7.24145L21.8661 4.61257Z"
            fill="#B7BBC2"
          />
          <path
            d="M21.8661 18.8977C21.9737 18.6596 22.3119 18.6596 22.4194 18.8977L23.6068 21.5266C23.6372 21.594 23.6911 21.6479 23.7585 21.6783L26.3874 22.8656C26.6255 22.9732 26.6255 23.3114 26.3874 23.419L23.7585 24.6063C23.6911 24.6367 23.6372 24.6906 23.6068 24.758L22.4195 27.3869C22.3119 27.625 21.9737 27.625 21.8661 27.3869L20.6788 24.758C20.6484 24.6906 20.5944 24.6367 20.5271 24.6063L17.8982 23.419C17.6601 23.3114 17.6601 22.9732 17.8982 22.8656L20.5271 21.6783C20.5944 21.6479 20.6484 21.594 20.6788 21.5266L21.8661 18.8977Z"
            fill="#B7BBC2"
          />
        </svg>
      );
    case 'circle':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
        >
          <circle cx="6" cy="6" r="6" fill="black" />
        </svg>
      );
    case 'gpt':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="36"
          height="36"
          viewBox="0 0 36 36"
          fill="none"
        >
          <g clipPath="url(#clip0_1760_92846)">
            <rect width="36" height="36" rx="18" fill="white" />
            <path
              d="M29.0158 15.6666C29.304 14.8009 29.404 13.8838 29.3091 12.9764C29.2141 12.069 28.9264 11.1924 28.4653 10.4051C27.7816 9.21446 26.7374 8.27175 25.4832 7.71304C24.2291 7.15434 22.8298 7.00853 21.4874 7.29665C20.8819 6.61427 20.1376 6.0691 19.3043 5.69763C18.4711 5.32616 17.5681 5.13697 16.6558 5.1427C15.2833 5.13939 13.9452 5.57203 12.8344 6.37824C11.7236 7.18445 10.8976 8.32257 10.4753 9.62853C9.58123 9.81156 8.73652 10.1835 7.99777 10.7194C7.25903 11.2553 6.64329 11.9428 6.19179 12.736C5.50269 13.9234 5.20855 15.2989 5.35177 16.6644C5.495 18.0297 6.06818 19.3143 6.98868 20.3328C6.70046 21.1985 6.60048 22.1157 6.69542 23.0231C6.79036 23.9305 7.07804 24.8071 7.5392 25.5943C8.22291 26.7849 9.26716 27.7276 10.5213 28.2863C11.7755 28.845 13.1747 28.9908 14.5171 28.7028C15.1226 29.3852 15.8669 29.9303 16.7001 30.3018C17.5334 30.6733 18.4364 30.8625 19.3486 30.8567C20.7218 30.8603 22.0607 30.4275 23.1718 29.6208C24.2831 28.8141 25.1093 27.6751 25.5312 26.3684C26.4253 26.1853 27.27 25.8135 28.0088 25.2775C28.7475 24.7416 29.3632 24.054 29.8147 23.2609C30.503 22.0736 30.7964 20.6984 30.6528 19.3335C30.5093 17.9687 29.936 16.6847 29.0158 15.6666ZM19.3507 29.1757C18.2234 29.1773 17.1316 28.7826 16.266 28.0605C16.305 28.0392 16.3735 28.0017 16.4181 27.9744L21.5381 25.0169C21.6666 24.9438 21.7733 24.8378 21.8472 24.7097C21.9212 24.5817 21.9597 24.4363 21.9588 24.2885V17.0703L24.1229 18.3199C24.1343 18.3255 24.144 18.3339 24.1514 18.3442C24.1587 18.3546 24.1634 18.3666 24.165 18.3791V24.3569C24.1634 25.6336 23.6558 26.8577 22.7534 27.7609C21.851 28.6642 20.6274 29.173 19.3507 29.1757ZM8.99714 24.7538C8.43252 23.7782 8.22902 22.6352 8.42228 21.5246C8.46029 21.5475 8.5267 21.588 8.57436 21.6154L13.6943 24.5728C13.8219 24.6474 13.9671 24.6867 14.1149 24.6867C14.2626 24.6867 14.4078 24.6474 14.5354 24.5728L20.7863 20.9635V23.4627C20.787 23.4754 20.7846 23.4882 20.7792 23.4997C20.7738 23.5113 20.7656 23.5214 20.7554 23.5291L15.5796 26.5174C14.4726 27.155 13.1577 27.3274 11.9237 26.9968C10.6896 26.6661 9.63715 25.8595 8.99714 24.7538ZM7.65022 13.5765C8.2124 12.5996 9.10033 11.8517 10.1585 11.4636C10.1585 11.5077 10.156 11.5858 10.156 11.64V17.5549C10.1551 17.7026 10.1935 17.8479 10.2674 17.9759C10.3413 18.1038 10.4478 18.2097 10.5762 18.2828L16.8272 21.8917L14.6631 23.1412C14.6524 23.1483 14.6402 23.1525 14.6274 23.1537C14.6147 23.1549 14.6018 23.1529 14.5901 23.1479L9.41383 20.157C8.30869 19.5169 7.50242 18.4648 7.17182 17.2312C6.84122 15.9977 7.01326 14.6834 7.65022 13.5765ZM25.4303 17.714L19.1793 14.1047L21.3434 12.8556C21.3541 12.8486 21.3664 12.8443 21.3791 12.8432C21.3918 12.842 21.4046 12.8441 21.4164 12.8491L26.5927 15.8374C27.3857 16.2955 28.0318 16.97 28.4553 17.782C28.8789 18.594 29.0623 19.5098 28.9842 20.4223C28.9061 21.3347 28.5695 22.2061 28.0142 22.9342C27.4587 23.6624 26.7074 24.2172 25.848 24.5338C25.848 24.4892 25.848 24.4111 25.848 24.3569V18.442C25.8492 18.2945 25.8112 18.1494 25.7377 18.0214C25.6643 17.8935 25.5583 17.7874 25.4303 17.714ZM27.5842 14.4722C27.5462 14.4489 27.4798 14.4088 27.4322 14.3815L22.3121 11.4241C22.1845 11.3496 22.0394 11.3103 21.8916 11.3103C21.7439 11.3103 21.5988 11.3496 21.4712 11.4241L15.2202 15.0335V12.5343C15.2195 12.5215 15.2219 12.5088 15.2273 12.4972C15.2327 12.4856 15.2409 12.4755 15.2511 12.4679L20.4269 9.48202C21.2198 9.02481 22.1266 8.80285 23.041 8.84211C23.9555 8.88136 24.8398 9.18022 25.5906 9.7037C26.3414 10.2272 26.9277 10.9537 27.2807 11.7981C27.6338 12.6426 27.7391 13.5701 27.5842 14.4722ZM14.0437 18.9267L11.879 17.6771C11.8677 17.6714 11.8579 17.6631 11.8505 17.6527C11.8432 17.6424 11.8385 17.6303 11.837 17.6177V11.64C11.8376 10.7245 12.0989 9.82803 12.5905 9.05562C13.0821 8.28322 13.7835 7.66681 14.6126 7.27856C15.4418 6.89031 16.3644 6.74628 17.2724 6.86331C18.1805 6.98035 19.0364 7.35363 19.74 7.93944C19.701 7.96073 19.633 7.99825 19.5879 8.02562L14.4679 10.983C14.3394 11.0561 14.2328 11.162 14.1588 11.29C14.0849 11.4179 14.0464 11.5632 14.0472 11.711L14.0437 18.9267ZM15.2192 16.392L18.0033 14.784L20.7873 16.391V19.6059L18.0033 21.2129L15.2192 19.6059V16.392Z"
              fill="black"
            />
          </g>
          <rect
            x="0.5"
            y="0.5"
            width="35"
            height="35"
            rx="17.5"
            stroke="#D4D7DB"
          />
          <defs>
            <clipPath id="clip0_1760_92846">
              <rect width="36" height="36" rx="18" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'page_nation_arrow':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <g clipPath="url(#clip0_964_16368)">
            <path
              d="M10 7L15 12L10 17"
              stroke="black"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_964_16368">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case 'approval_create_link':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M8.75 5H5V15H15V11.25"
            stroke="#888D96"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.25 5L15 5L15 8.75"
            stroke="#888D96"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.7139 5L9.99982 9.71405"
            stroke="#888D96"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'approval_close':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.5 6.5L6.5 17.5"
            stroke="black"
            strokeWidth="0.96"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.5 6.5L17.5 17.5"
            stroke="black"
            strokeWidth="0.96"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'comments':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.0083 12.9019C15.7115 11.6856 15.9478 10.2548 15.6731 8.8769C15.3984 7.49901 14.6315 6.26825 13.5155 5.41455C12.3996 4.56085 11.0111 4.14261 9.60932 4.23795C8.20755 4.33329 6.88843 4.93569 5.89839 5.93263C4.90835 6.92956 4.31511 8.25283 4.2295 9.65523C4.14389 11.0576 4.57176 12.4432 5.43319 13.5532C6.29461 14.6632 7.53066 15.4215 8.91042 15.6867C10.2902 15.9518 11.7193 15.7056 12.9308 14.994L15.7861 15.7908L15.0083 12.9019Z"
            stroke="#888D96"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'comment':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.2716 5.30469H3.59708C3.3947 5.30469 3.2006 5.38509 3.05749 5.5282C2.91438 5.67132 2.83398 5.86542 2.83398 6.06782V13.6991C2.83398 13.9015 2.91438 14.0956 3.05749 14.2387C3.2006 14.3819 3.3947 14.4623 3.59708 14.4623H6.94301V16.7517L10.7585 14.4623H13.8109C14.0133 14.4623 14.2074 14.3819 14.3505 14.2387C14.4936 14.0956 14.574 13.9015 14.574 13.6991L14.574 11.3985"
            stroke="#888D96"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.8339 5.66317L12.8385 10.6586L10.5102 10.7436L10.6028 8.4229L15.5982 3.42748L17.8339 5.66317Z"
            stroke="#888D96"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'clock':
      return (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="7.00009" cy="6.9999" r="6.22305" stroke="#888D96" />
          <path
            d="M7 3.43726V6.99978L9.37502 9.37479"
            stroke="#888D96"
            strokeLinecap="round"
          />
        </svg>
      );
    case 'plus_12':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
        >
          <path
            d="M6 0.5V11.5"
            stroke={color ?? 'black'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M0.5 6H11.5"
            stroke={color ?? 'black'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'plus':
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 1.40002V14.6"
            stroke="#0066CC"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1.3999 8H14.5999"
            stroke="#0066CC"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'next-line':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width || 11}
          height={height || 13}
          viewBox="0 0 11 13"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.833008 0.25C1.10915 0.25 1.33301 0.473858 1.33301 0.75V8.16667H9.20923L6.31279 5.27022C6.11753 5.07496 6.11753 4.75838 6.31279 4.56311C6.50805 4.36785 6.82463 4.36785 7.01989 4.56311L10.7699 8.31311C10.9652 8.50838 10.9652 8.82496 10.7699 9.02022L7.01989 12.7702C6.82463 12.9655 6.50805 12.9655 6.31279 12.7702C6.11753 12.575 6.11753 12.2584 6.31279 12.0631L9.20923 9.16667H0.833008C0.556865 9.16667 0.333008 8.94281 0.333008 8.66667V0.75C0.333008 0.473858 0.556865 0.25 0.833008 0.25Z"
            fill={color || '#FF9A15'}
          />
        </svg>
      );
    case 'domestic':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <path
            d="M16.0054 15.641C16.599 15.641 17.1055 15.4297 17.5251 15.007C17.9448 14.5843 18.1547 14.0762 18.1547 13.4827C18.1547 12.8891 17.9433 12.3824 17.5204 11.9627C17.0977 11.5431 16.5896 11.3333 15.9961 11.3333C15.4025 11.3333 14.896 11.5447 14.4764 11.9673C14.0566 12.39 13.8467 12.8981 13.8467 13.4917C13.8467 14.0852 14.0582 14.5919 14.4811 15.0117C14.9037 15.4312 15.4118 15.641 16.0054 15.641ZM16.0007 26.236C18.5067 24.0547 20.488 21.8362 21.9444 19.5807C23.4008 17.3251 24.1291 15.3743 24.1291 13.7283C24.1291 11.289 23.3568 9.27567 21.8124 7.68833C20.268 6.10122 18.3307 5.30767 16.0007 5.30767C13.6707 5.30767 11.7335 6.10122 10.1891 7.68833C8.64462 9.27567 7.8724 11.289 7.8724 13.7283C7.8724 15.3743 8.60062 17.3251 10.0571 19.5807C11.5135 21.8362 13.4947 24.0547 16.0007 26.236ZM16.0007 28.0257C12.8674 25.2548 10.5072 22.6706 8.92006 20.273C7.33273 17.8757 6.53906 15.6941 6.53906 13.7283C6.53906 10.9077 7.45751 8.58111 9.2944 6.74867C11.1311 4.91622 13.3665 4 16.0007 4C18.635 4 20.8704 4.91622 22.7071 6.74867C24.544 8.58111 25.4624 10.9077 25.4624 13.7283C25.4624 15.6941 24.6687 17.8757 23.0814 20.273C21.4943 22.6706 19.1341 25.2548 16.0007 28.0257Z"
            fill="black"
          />
        </svg>
      );
    case 'domestic_grey':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <path
            d="M16.0054 15.641C16.599 15.641 17.1055 15.4297 17.5251 15.007C17.9448 14.5843 18.1547 14.0762 18.1547 13.4827C18.1547 12.8891 17.9433 12.3824 17.5204 11.9627C17.0977 11.5431 16.5896 11.3333 15.9961 11.3333C15.4025 11.3333 14.896 11.5447 14.4764 11.9673C14.0566 12.39 13.8467 12.8981 13.8467 13.4917C13.8467 14.0852 14.0582 14.5919 14.4811 15.0117C14.9037 15.4312 15.4118 15.641 16.0054 15.641ZM16.0007 26.236C18.5067 24.0547 20.488 21.8362 21.9444 19.5807C23.4008 17.3251 24.1291 15.3743 24.1291 13.7283C24.1291 11.289 23.3568 9.27567 21.8124 7.68833C20.268 6.10122 18.3307 5.30767 16.0007 5.30767C13.6707 5.30767 11.7335 6.10122 10.1891 7.68833C8.64462 9.27567 7.8724 11.289 7.8724 13.7283C7.8724 15.3743 8.60062 17.3251 10.0571 19.5807C11.5135 21.8362 13.4947 24.0547 16.0007 26.236ZM16.0007 28.0257C12.8674 25.2548 10.5072 22.6706 8.92006 20.273C7.33273 17.8757 6.53906 15.6941 6.53906 13.7283C6.53906 10.9077 7.45751 8.58111 9.2944 6.74867C11.1311 4.91622 13.3665 4 16.0007 4C18.635 4 20.8704 4.91622 22.7071 6.74867C24.544 8.58111 25.4624 10.9077 25.4624 13.7283C25.4624 15.6941 24.6687 17.8757 23.0814 20.273C21.4943 22.6706 19.1341 25.2548 16.0007 28.0257Z"
            fill="#888D96"
          />
        </svg>
      );
    case 'international':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <path
            d="M16.0043 28C14.345 28 12.7849 27.6851 11.324 27.0553C9.86333 26.4256 8.59267 25.5709 7.512 24.4913C6.43133 23.4118 5.57589 22.1422 4.94567 20.6827C4.31522 19.2233 4 17.6639 4 16.0043C4 14.345 4.31489 12.7849 4.94467 11.324C5.57444 9.86333 6.42911 8.59267 7.50867 7.512C8.58822 6.43133 9.85778 5.57589 11.3173 4.94567C12.7767 4.31522 14.3361 4 15.9957 4C17.655 4 19.2151 4.31489 20.676 4.94467C22.1367 5.57445 23.4073 6.42911 24.488 7.50867C25.5687 8.58822 26.4241 9.85778 27.0543 11.3173C27.6848 12.7767 28 14.3361 28 15.9957C28 17.655 27.6851 19.2151 27.0553 20.676C26.4256 22.1367 25.5709 23.4073 24.4913 24.488C23.4118 25.5687 22.1422 26.4241 20.6827 27.0543C19.2233 27.6848 17.6639 28 16.0043 28ZM16 26.6667C18.9778 26.6667 21.5 25.6333 23.5667 23.5667C25.6333 21.5 26.6667 18.9778 26.6667 16C26.6667 15.8444 26.6653 15.6876 26.6627 15.5293C26.6602 15.3713 26.6504 15.2197 26.6333 15.0743C26.5736 15.6674 26.3377 16.158 25.9257 16.546C25.5137 16.9342 25.0086 17.1283 24.4103 17.1283H21.0257C20.4052 17.1283 19.874 16.9077 19.432 16.4663C18.9902 16.0252 18.7693 15.4949 18.7693 14.8753V13.749H14.2563V11.496C14.2563 10.8764 14.4773 10.344 14.9193 9.89867C15.3611 9.45333 15.8922 9.23067 16.5127 9.23067H17.641V8.205C17.641 7.55722 17.8526 7.04745 18.2757 6.67567C18.6988 6.30389 19.2043 6.08978 19.7923 6.03333C19.1941 5.80267 18.581 5.62833 17.953 5.51033C17.325 5.39233 16.674 5.33333 16 5.33333C13.0222 5.33333 10.5 6.36667 8.43333 8.43333C6.36667 10.5 5.33333 13.0222 5.33333 16V16.3847C5.33333 16.5042 5.34189 16.6324 5.359 16.7693H11.3333C12.5949 16.7693 13.6624 17.206 14.536 18.0793C15.4093 18.9529 15.846 20.0166 15.846 21.2703V22.4103H12.4617V26.0513C13.0086 26.2478 13.5799 26.3994 14.1757 26.5063C14.7714 26.6132 15.3796 26.6667 16 26.6667Z"
            fill="black"
          />
        </svg>
      );
    case 'international_grey':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <path
            d="M16.0043 28C14.345 28 12.7849 27.6851 11.324 27.0553C9.86333 26.4256 8.59267 25.5709 7.512 24.4913C6.43133 23.4118 5.57589 22.1422 4.94567 20.6827C4.31522 19.2233 4 17.6639 4 16.0043C4 14.345 4.31489 12.7849 4.94467 11.324C5.57444 9.86333 6.42911 8.59267 7.50867 7.512C8.58822 6.43133 9.85778 5.57589 11.3173 4.94567C12.7767 4.31522 14.3361 4 15.9957 4C17.655 4 19.2151 4.31489 20.676 4.94467C22.1367 5.57445 23.4073 6.42911 24.488 7.50867C25.5687 8.58822 26.4241 9.85778 27.0543 11.3173C27.6848 12.7767 28 14.3361 28 15.9957C28 17.655 27.6851 19.2151 27.0553 20.676C26.4256 22.1367 25.5709 23.4073 24.4913 24.488C23.4118 25.5687 22.1422 26.4241 20.6827 27.0543C19.2233 27.6848 17.6639 28 16.0043 28ZM16 26.6667C18.9778 26.6667 21.5 25.6333 23.5667 23.5667C25.6333 21.5 26.6667 18.9778 26.6667 16C26.6667 15.8444 26.6653 15.6876 26.6627 15.5293C26.6602 15.3713 26.6504 15.2197 26.6333 15.0743C26.5736 15.6674 26.3377 16.158 25.9257 16.546C25.5137 16.9342 25.0086 17.1283 24.4103 17.1283H21.0257C20.4052 17.1283 19.874 16.9077 19.432 16.4663C18.9902 16.0252 18.7693 15.4949 18.7693 14.8753V13.749H14.2563V11.496C14.2563 10.8764 14.4773 10.344 14.9193 9.89867C15.3611 9.45333 15.8922 9.23067 16.5127 9.23067H17.641V8.205C17.641 7.55722 17.8526 7.04745 18.2757 6.67567C18.6988 6.30389 19.2043 6.08978 19.7923 6.03333C19.1941 5.80267 18.581 5.62833 17.953 5.51033C17.325 5.39233 16.674 5.33333 16 5.33333C13.0222 5.33333 10.5 6.36667 8.43333 8.43333C6.36667 10.5 5.33333 13.0222 5.33333 16V16.3847C5.33333 16.5042 5.34189 16.6324 5.359 16.7693H11.3333C12.5949 16.7693 13.6624 17.206 14.536 18.0793C15.4093 18.9529 15.846 20.0166 15.846 21.2703V22.4103H12.4617V26.0513C13.0086 26.2478 13.5799 26.3994 14.1757 26.5063C14.7714 26.6132 15.3796 26.6667 16 26.6667Z"
            fill="#888D96"
          />
        </svg>
      );
    case 'refresh_white':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 4.5C13.0376 4.5 15.5 6.96243 15.5 10C15.5 13.0376 13.0376 15.5 10 15.5C6.96243 15.5 4.5 13.0376 4.5 10C4.5 8.27223 5.29669 6.73053 6.54274 5.72222"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.5 5.41699H6.94444V7.86144"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'refresh_grey':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
        >
          <path
            d="M6 0.5C9.03757 0.5 11.5 2.96243 11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6C0.5 4.27223 1.29669 2.73053 2.54274 1.72222"
            stroke="#888D96"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M0.5 1.4165H2.94444V3.86095"
            stroke="#888D96"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'refresh':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 5C15.866 5 19 8.13401 19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 9.80102 6.01396 7.83885 7.59985 6.55556"
            stroke="black"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5 6.1666H8.11111V9.27771"
            stroke="black"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'document':
      return (
        <Box
          sx={{
            '& svg': {
              '& path, & rect, & circle': {
                stroke: color || 'white',
              },
              ...style,
            },
          }}
        >
          <AddDocumentIcon />
        </Box>
      );
    case 'marker':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          // xmlns:xlink="http://www.w3.org/1999/xlink"
          width="36px"
          height="36px"
          viewBox="-4 0 36 36"
          version="1.1"
          style={style}
        >
          <title>map-marker</title>
          <desc>Created with Sketch.</desc>
          <defs></defs>
          <g
            id="Vivid.JS"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g id="Vivid-Icons" transform="translate(-125.000000, -643.000000)">
              <g id="Icons" transform="translate(37.000000, 169.000000)">
                <g id="map-marker" transform="translate(78.000000, 468.000000)">
                  <g transform="translate(10.000000, 6.000000)">
                    <path
                      d="M14,0 C21.732,0 28,5.641 28,12.6 C28,23.963 14,36 14,36 C14,36 0,24.064 0,12.6 C0,5.641 6.268,0 14,0 Z"
                      id="Shape"
                      fill="#FF6E6E"
                    ></path>
                    <circle
                      id="Oval"
                      fill="#0C0058"
                      fillRule="nonzero"
                      cx="14"
                      cy="14"
                      r="7"
                    ></circle>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      );
    case 'type_icon':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="33"
          height="32"
          viewBox="0 0 33 32"
          fill="none"
        >
          <path
            d="M29.4646 16.0002C29.4646 23.0694 23.7338 28.8002 16.6646 28.8002C9.59535 28.8002 3.86459 23.0694 3.86459 16.0002C3.86459 8.93095 9.59535 3.2002 16.6646 3.2002C23.7338 3.2002 29.4646 8.93095 29.4646 16.0002Z"
            fill="white"
          />
          <path
            d="M11.8646 20.8002L21.4646 11.2002M29.4646 16.0002C29.4646 23.0694 23.7338 28.8002 16.6646 28.8002C9.59535 28.8002 3.86459 23.0694 3.86459 16.0002C3.86459 8.93095 9.59535 3.2002 16.6646 3.2002C23.7338 3.2002 29.4646 8.93095 29.4646 16.0002Z"
            stroke="black"
            strokeLinecap="round"
          />
          <path
            d="M12.6022 11.9331L12.5833 11.9141M20.7496 20.1643L20.7307 20.1452"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      );
    case 'type_icon_grey':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="33"
          height="32"
          viewBox="0 0 33 32"
          fill="none"
        >
          <path
            d="M29.4646 16.0002C29.4646 23.0694 23.7338 28.8002 16.6646 28.8002C9.59535 28.8002 3.86459 23.0694 3.86459 16.0002C3.86459 8.93095 9.59535 3.2002 16.6646 3.2002C23.7338 3.2002 29.4646 8.93095 29.4646 16.0002Z"
            fill="white"
          />
          <path
            d="M11.8646 20.8002L21.4646 11.2002M29.4646 16.0002C29.4646 23.0694 23.7338 28.8002 16.6646 28.8002C9.59535 28.8002 3.86459 23.0694 3.86459 16.0002C3.86459 8.93095 9.59535 3.2002 16.6646 3.2002C23.7338 3.2002 29.4646 8.93095 29.4646 16.0002Z"
            stroke="#888D96"
            strokeLinecap="round"
          />
          <path
            d="M12.6022 11.9331L12.5833 11.9141M20.7496 20.1643L20.7307 20.1452"
            stroke="#888D96"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      );
    case 'cloth_icon':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <path
            d="M3.47071 13.7418L2.34375 8.91452L11.5204 5.33301C12.3733 5.53924 14.4546 5.95032 15.9971 5.95582C17.5396 5.95032 19.6209 5.53924 20.4738 5.33301L29.6504 8.91452L28.5235 13.7418H24.1766V26.6663H16.0282H15.9659H7.81755V13.7418H3.47071Z"
            fill="white"
          />
          <path
            d="M16.0282 26.6663H7.81755V13.7418H3.47071L2.34375 8.91452L11.5204 5.33301C12.379 5.54063 14.4827 5.95588 16.0282 5.95588M15.9659 26.6663H24.1766V13.7418H28.5235L29.6504 8.91452L20.4738 5.33301C19.6151 5.54063 17.5115 5.95588 15.9659 5.95588"
            stroke="black"
            strokeLinejoin="round"
          />
          <path
            d="M15.4121 9.66221L13.0443 12.1598L9.72925 6.22806L10.8343 5.75977L15.4121 9.66221ZM15.4121 9.66221H16.4197M16.4197 9.66221L18.7876 12.1598L22.1026 6.22806L20.9976 5.75977L16.4197 9.66221Z"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M16 12V24" stroke="black" strokeLinecap="round" />
        </svg>
      );
    case 'cloth_icon_grey':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <path
            d="M3.47071 13.7418L2.34375 8.91452L11.5204 5.33301C12.3733 5.53924 14.4546 5.95032 15.9971 5.95582C17.5396 5.95032 19.6209 5.53924 20.4738 5.33301L29.6504 8.91452L28.5235 13.7418H24.1766V26.6663H16.0282H15.9659H7.81755V13.7418H3.47071Z"
            fill="white"
          />
          <path
            d="M16.0282 26.6663H7.81755V13.7418H3.47071L2.34375 8.91452L11.5204 5.33301C12.379 5.54063 14.4827 5.95588 16.0282 5.95588M15.9659 26.6663H24.1766V13.7418H28.5235L29.6504 8.91452L20.4738 5.33301C19.6151 5.54063 17.5115 5.95588 15.9659 5.95588"
            stroke="#888D96"
            strokeLinejoin="round"
          />
          <path
            d="M15.4121 9.66221L13.0443 12.1598L9.72925 6.22806L10.8343 5.75977L15.4121 9.66221ZM15.4121 9.66221H16.4197M16.4197 9.66221L18.7876 12.1598L22.1026 6.22806L20.9976 5.75977L16.4197 9.66221Z"
            stroke="#888D96"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M16 12V24" stroke="#888D96" strokeLinecap="round" />
        </svg>
      );
    case 'acc_icon':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="33"
          height="32"
          viewBox="0 0 33 32"
          fill="none"
        >
          <path
            d="M6.37556 12H26.2905L28.333 26.6667C28.333 26.6667 22.4607 24.2222 16.5883 24.2222C10.716 24.2222 4.33301 26.6667 4.33301 26.6667L6.37556 12Z"
            fill="white"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.6665 18.667V21.3337"
            stroke="black"
            strokeLinecap="round"
          />
          <path
            d="M16.9995 18.667V21.3337"
            stroke="black"
            strokeLinecap="round"
          />
          <path
            d="M11.1896 12.0003C11.1896 12.0003 9.47706 2.66699 16.3328 2.66699C23.1886 2.66699 21.4761 12.0003 21.4761 12.0003"
            stroke="black"
            strokeLinejoin="round"
          />
          <path
            d="M24.333 21.3022C23.5921 20.8576 21.5144 20 16.5101 20C11.3863 20 9.12598 20.899 8.33301 21.3333"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'acc_icon_grey':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="33"
          height="32"
          viewBox="0 0 33 32"
          fill="none"
        >
          <path
            d="M6.37556 12H26.2905L28.333 26.6667C28.333 26.6667 22.4607 24.2222 16.5883 24.2222C10.716 24.2222 4.33301 26.6667 4.33301 26.6667L6.37556 12Z"
            fill="white"
            stroke="#888D96"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.6665 18.667V21.3337"
            stroke="#888D96"
            strokeLinecap="round"
          />
          <path
            d="M16.9995 18.667V21.3337"
            stroke="#888D96"
            strokeLinecap="round"
          />
          <path
            d="M11.1896 12.0003C11.1896 12.0003 9.47706 2.66699 16.3328 2.66699C23.1886 2.66699 21.4761 12.0003 21.4761 12.0003"
            stroke="#888D96"
            strokeLinejoin="round"
          />
          <path
            d="M24.333 21.3022C23.5921 20.8576 21.5144 20 16.5101 20C11.3863 20 9.12598 20.899 8.33301 21.3333"
            stroke="#888D96"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'close_button':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <rect
            x="0.5"
            y="0.5"
            width="23"
            height="23"
            rx="1.5"
            stroke="#E7E9EC"
          />
          <path
            d="M7 10L12 15L17 10"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'open_button':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <rect width="24" height="24" rx="2" fill="black" />
          <path
            d="M7 14.5L12 9.5L17 14.5"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'arrow_down':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width || 32}
          height={height || 32}
          viewBox="0 0 32 33"
          fill="none"
        >
          <path
            d="M8 13.5391L16 21.5391L24 13.5391"
            stroke={color || '#B7BBC2'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'calendar':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
        >
          <mask
            id="mask0_3405_44488"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="20"
            height="21"
          >
            <rect y="0.539062" width="20" height="20" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_3405_44488)">
            <path
              d="M4.75648 18.1224C4.38134 18.1224 4.06426 17.9905 3.80523 17.7266C3.5462 17.4627 3.41669 17.1481 3.41669 16.7827V6.29557C3.41669 5.93016 3.5462 5.6155 3.80523 5.35162C4.06426 5.08773 4.38134 4.95578 4.75648 4.95578H6.5769V2.85974H7.69231V4.95578H12.3398V2.85974H13.4231V4.95578H15.2436C15.6187 4.95578 15.9358 5.08773 16.1948 5.35162C16.4538 5.6155 16.5834 5.93016 16.5834 6.29557V16.7827C16.5834 17.1481 16.4538 17.4627 16.1948 17.7266C15.9358 17.9905 15.6187 18.1224 15.2436 18.1224H4.75648ZM4.75648 17.0391H15.2436C15.3077 17.0391 15.3665 17.0124 15.4198 16.9589C15.4733 16.9056 15.5 16.8468 15.5 16.7827V9.79557H4.50002V16.7827C4.50002 16.8468 4.52676 16.9056 4.58023 16.9589C4.63356 17.0124 4.69231 17.0391 4.75648 17.0391ZM4.50002 8.71224H15.5V6.29557C15.5 6.23141 15.4733 6.17266 15.4198 6.11932C15.3665 6.06585 15.3077 6.03912 15.2436 6.03912H4.75648C4.69231 6.03912 4.63356 6.06585 4.58023 6.11932C4.52676 6.17266 4.50002 6.23141 4.50002 6.29557V8.71224ZM6.20835 12.3308V11.2474H13.7917V12.3308H6.20835ZM6.20835 15.3308V14.2474H11.7917V15.3308H6.20835Z"
              fill="#1C1B1F"
            />
          </g>
        </svg>
      );
    case 'sort':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="13"
          viewBox="0 0 16 13"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.76721 0.658942C4.71032 0.600225 4.64096 0.552666 4.56211 0.520651C4.33583 0.428785 4.07644 0.483233 3.90621 0.658335L1.13913 3.50447C0.908142 3.74206 0.913492 4.12192 1.15108 4.35291C1.38867 4.5839 1.76854 4.57855 1.99953 4.34096L3.7364 2.55446V11.5124C3.7364 11.8438 4.00503 12.1124 4.3364 12.1124C4.66777 12.1124 4.9364 11.8438 4.9364 11.5124V2.55319L6.67452 4.34096C6.90551 4.57855 7.28537 4.5839 7.52296 4.35291C7.76055 4.12192 7.7659 3.74206 7.53491 3.50447L4.76784 0.658335L4.76721 0.658942Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.811 11.9261C12.7558 11.9822 12.6889 12.0279 12.6132 12.0593C12.389 12.1522 12.131 12.1008 11.9594 11.9292L9.11324 9.08309C8.87892 8.84878 8.87892 8.46888 9.11324 8.23457C9.34755 8.00025 9.72745 8.00025 9.96176 8.23457L11.7836 10.0564V1.06914C11.7836 0.737769 12.0523 0.46914 12.3836 0.46914C12.715 0.46914 12.9836 0.737769 12.9836 1.06914V10.0564L14.8055 8.23457C15.0398 8.00025 15.4197 8.00025 15.654 8.23457C15.8883 8.46888 15.8883 8.84878 15.654 9.08309L12.811 11.9261Z"
            fill="black"
          />
        </svg>
      );
    case 'sort_28':
      return (
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.89975 7.03198C8.84281 6.97311 8.77335 6.92543 8.69435 6.89335C8.46809 6.80147 8.20873 6.85588 8.03847 7.03094L4.27104 10.9047C4.04001 11.1422 4.04529 11.5221 4.28285 11.7531C4.5204 11.9842 4.90026 11.9789 5.13129 11.7413L7.8686 8.92678V21.653C7.8686 21.9844 8.13723 22.253 8.4686 22.253C8.79997 22.253 9.0686 21.9844 9.0686 21.653V8.92462L11.808 11.7413C12.039 11.9789 12.4189 11.9842 12.6565 11.7531C12.894 11.5221 12.8993 11.1422 12.6683 10.9047L8.90082 7.03094L8.89975 7.03198Z"
            fill="black"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.8564 22.0312C19.8005 22.0889 19.7326 22.1357 19.6555 22.1677C19.4313 22.2606 19.1733 22.2093 19.0017 22.0377L15.1266 18.1639C14.8922 17.9297 14.8922 17.5498 15.1264 17.3154C15.3607 17.0811 15.7406 17.081 15.975 17.3153L18.8259 20.1652V7.40961C18.8259 7.07824 19.0945 6.80961 19.4258 6.80961C19.7572 6.80961 20.0258 7.07824 20.0258 7.40961V20.1651L22.8767 17.3153C23.111 17.081 23.4909 17.0811 23.7252 17.3154C23.9595 17.5498 23.9594 17.9297 23.725 18.1639L19.8564 22.0312Z"
            fill="black"
          />
        </svg>
      );
    case 'checked':
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.25 4.91553L6.81306 11.1947L3.75 8.13166"
            stroke="white"
            strokeWidth="0.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'checked_black':
      return (
        <svg
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.9751 6.76019L8.5787 14.1475L4.9751 10.5439"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'delete':
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="8" cy="8" r="8" fill="#D4D7DB" />
          <path
            d="M10.3999 5.6001L5.59998 10.4001"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.6001 5.6001L10.4 10.4001"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'search':
      return (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.25 13.2501L10.2339 10.234M10.2339 10.234C11.2393 9.22862 11.8611 7.83972 11.8611 6.30559C11.8611 3.23732 9.3738 0.75 6.30556 0.75C3.23731 0.75 0.75 3.23732 0.75 6.30559C0.75 9.37386 3.23731 11.8612 6.30556 11.8612C7.83968 11.8612 9.22857 11.2394 10.2339 10.234Z"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'search_28':
      return (
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.6131 13.5964C20.6131 15.6828 19.7674 17.5718 18.4001 18.9391C17.0327 20.3064 15.1438 21.1521 13.0574 21.1521C8.8845 21.1521 5.50171 17.7693 5.50171 13.5964C5.50171 9.42355 8.8845 6.04077 13.0574 6.04077C17.2303 6.04077 20.6131 9.42355 20.6131 13.5964Z"
            stroke="black"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22.5017 23.0408L18.3992 18.9382"
            stroke="black"
            strokeWidth="1.2"
            strokeLinecap="round"
          />
        </svg>
      );
    case 'open':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17 9.5L12 14.5L7 9.5"
            stroke="black"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'sales_open':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7 10L12 15L17 10"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'sales_close':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          style={style}
        >
          <path
            d="M7 14.5L12 9.5L17 14.5"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'close':
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_2115_14024)">
            <path
              d="M7 14.5L12 9.5L17 14.5"
              stroke="black"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_2115_14024">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'menuClose':
      return (
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 23L9 16L15 9"
            stroke="#5F636B"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M22 23L16 16L22 9"
            stroke="#5F636B"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'x_2':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.5 5.5L5.50014 14.5"
            stroke="#34383D"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.5 5.5L14.4999 14.5"
            stroke="#34383D"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'x':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width ? width : 10}
          height={height ? height : 10}
          viewBox="0 0 10 10"
          fill="none"
        >
          <path
            d="M9.5 0.5L0.50014 9.5"
            stroke={color ?? '#5F636B'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M0.5 0.5L9.49986 9.5"
            stroke={color ?? '#5F636B'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'back':
      return (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2 9L17.1667 9"
            stroke="black"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.99998 0.833344L0.833313 9.00001L8.99998 17.1667"
            stroke="black"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'link':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="14"
          viewBox="0 0 18 14"
          fill="none"
        >
          <path
            d="M15.8677 7.30625C17.4044 5.76953 17.4044 3.27851 15.8677 1.7418C14.4048 0.278905 12.056 0.199608 10.4974 1.56406L10.3306 1.71172C10.0571 1.94961 10.0298 2.36523 10.2677 2.63867C10.5056 2.91211 10.9212 2.93945 11.1946 2.70156L11.3614 2.5539C12.4005 1.64609 13.9646 1.69805 14.9407 2.67422C15.9634 3.69687 15.9634 5.35664 14.9407 6.38203L11.8427 9.47734C10.82 10.5 9.15752 10.5 8.13486 9.47734C7.15869 8.50117 7.10674 6.93711 8.01455 5.89805L8.14307 5.75039C8.38096 5.47695 8.35361 5.06406 8.08018 4.82344C7.80674 4.58281 7.39385 4.61289 7.15322 4.88633L7.02471 5.03398C5.66299 6.59258 5.74228 8.9414 7.20518 10.4043C8.74189 11.941 11.2329 11.941 12.7696 10.4043L15.8677 7.30625ZM1.63252 6.69375C0.0958008 8.23047 0.0958008 10.7215 1.63252 12.2555C3.09814 13.7211 5.44697 13.7977 7.00557 12.4332L7.17236 12.2855C7.4458 12.0477 7.47314 11.632 7.23525 11.3586C6.99736 11.0852 6.58174 11.0578 6.3083 11.2957L6.1415 11.4434C5.10244 12.3512 3.53838 12.2992 2.56221 11.323C1.53955 10.3004 1.53955 8.64062 2.56221 7.61523L5.66025 4.52265C6.68291 3.5 8.34268 3.5 9.36807 4.52265C10.3442 5.49883 10.3962 7.06289 9.48838 8.10195L9.34072 8.26875C9.10283 8.54218 9.13018 8.95508 9.40361 9.1957C9.67705 9.43633 10.0899 9.40625 10.3306 9.13281L10.4782 8.96601C11.8427 7.40742 11.7634 5.05859 10.3005 3.59297C8.76377 2.05625 6.27275 2.05625 4.73603 3.59297L1.63252 6.69375Z"
            fill="#888D96"
          />
        </svg>
      );
    case 'message':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="29"
          viewBox="0 0 28 29"
          fill="none"
        >
          <path
            d="M21.2934 7H7.37337C7.09755 7 6.83302 7.11238 6.63798 7.31242C6.44295 7.51246 6.33337 7.78377 6.33337 8.06667V18.7333C6.33337 19.0162 6.44295 19.2875 6.63798 19.4876C6.83302 19.6876 7.09755 19.8 7.37337 19.8H11.9334V23L17.1334 19.8H21.2934C21.5692 19.8 21.8337 19.6876 22.0288 19.4876C22.2238 19.2875 22.3334 19.0162 22.3334 18.7333V8.06667C22.3334 7.78377 22.2238 7.51246 22.0288 7.31242C21.8337 7.11238 21.5692 7 21.2934 7Z"
            stroke="#34383D"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'phone':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="29"
          viewBox="0 0 28 29"
          fill="none"
        >
          <g clipPath="url(#clip0_3109_29636)">
            <path
              d="M18.678 15.4604C18.0374 15.2006 17.2952 15.3713 16.8538 15.8834L15.5569 17.3901C13.76 16.3992 12.26 14.9742 11.217 13.2672L12.7991 12.0389C13.3381 11.6196 13.5217 10.9145 13.2444 10.3059L11.3694 6.14963C11.0764 5.49651 10.3381 5.13283 9.60767 5.28127L5.23267 6.1719C4.51392 6.31662 3.99829 6.92151 3.99829 7.62287C3.99829 16.4067 11.1663 23.5985 20.2483 24.2071C20.4241 24.2182 20.6038 24.2293 20.7834 24.2367C20.7834 24.2367 20.7834 24.2367 20.7874 24.2367C21.0256 24.2442 21.26 24.2516 21.5022 24.2516C22.2405 24.2516 22.8772 23.7617 23.0295 23.0789L23.967 18.9227C24.1233 18.2287 23.7405 17.5274 23.053 17.249L18.678 15.4678V15.4604ZM21.4866 23.0604C12.5178 23.0529 5.24829 16.1469 5.24829 7.62287C5.24829 7.48186 5.34985 7.36311 5.49438 7.33342L9.86938 6.4428C10.0139 6.41311 10.1624 6.48733 10.2209 6.61721L12.0959 10.7735C12.1506 10.8959 12.1155 11.0369 12.0061 11.1186L10.4202 12.3506C9.94751 12.718 9.82251 13.36 10.1311 13.8647C11.2834 15.7535 12.9397 17.327 14.9241 18.418C15.4553 18.7112 16.1311 18.5924 16.5178 18.1434L17.8147 16.6367C17.9045 16.5328 18.053 16.4994 18.178 16.5514L22.553 18.3326C22.6897 18.3883 22.7678 18.5293 22.7366 18.6666L21.7991 22.8229C21.7678 22.9602 21.6389 23.0567 21.4944 23.0567C21.4905 23.0567 21.4866 23.0567 21.4827 23.0567L21.4866 23.0604Z"
              fill="black"
            />
          </g>
          <defs>
            <clipPath id="clip0_3109_29636">
              <rect
                width="28"
                height="28"
                fill="white"
                transform="translate(0 0.75)"
              />
            </clipPath>
          </defs>
        </svg>
      );
    case 'teams':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="29"
          viewBox="0 0 28 29"
          fill="none"
        >
          <g clipPath="url(#clip0_3109_29711)">
            <path
              d="M22.901 9.62741C22.901 10.4706 22.2175 11.1541 21.3744 11.1541C20.5312 11.1541 19.8477 10.4706 19.8477 9.62741C19.8477 8.78427 20.5312 8.10077 21.3744 8.10077C22.2175 8.10077 22.901 8.78427 22.901 9.62741Z"
              stroke="black"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <mask
              id="mask0_3109_29711"
              // style="mask-type:luminance"
              maskUnits="userSpaceOnUse"
              x="18"
              y="12"
              width="6"
              height="9"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.6137 20.1926C19.1656 20.6906 19.8967 20.9937 20.6986 20.9936H20.7134C22.4324 20.9936 23.8259 19.6001 23.8259 17.8811V13.3715C23.8259 12.9039 23.4467 12.5247 22.9791 12.5247H18.0389C18.501 12.5361 18.8667 12.9197 18.8559 13.3818V18.5251C18.8694 19.1071 18.7836 19.6684 18.6137 20.1926Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask0_3109_29711)">
              <path
                d="M18.6136 20.1926L17.702 19.8971L17.5105 20.4879L17.9716 20.904L18.6136 20.1926ZM18.0389 12.5247V11.5663L18.0152 13.4827L18.0389 12.5247ZM18.8559 13.3818L17.8979 13.3597L17.8976 13.3708V13.3818H18.8559ZM18.8559 18.5252H17.8976V18.5363L17.8979 18.5475L18.8559 18.5252ZM20.6986 20.0353C20.1429 20.0354 19.6383 19.8264 19.2557 19.4811L17.9716 20.904C18.6928 21.5548 19.6506 21.9522 20.6988 21.952L20.6986 20.0353ZM20.7133 20.0353H20.6986L20.6988 21.952H20.7133V20.0353ZM22.8676 17.8811C22.8676 19.0708 21.9031 20.0353 20.7133 20.0353V21.952C22.9616 21.952 24.7842 20.1294 24.7842 17.8811H22.8676ZM22.8676 13.3715V17.8811H24.7842V13.3715H22.8676ZM22.979 13.483C22.9175 13.483 22.8676 13.4332 22.8676 13.3715H24.7842C24.7842 12.3746 23.976 11.5663 22.979 11.5663V13.483ZM18.0389 13.483H22.979V11.5663H18.0389V13.483ZM19.8139 13.404C19.8369 12.4133 19.0533 11.5912 18.0626 11.5666L18.0152 13.4827C17.9488 13.4811 17.8963 13.426 17.8979 13.3597L19.8139 13.404ZM19.8142 18.5252V13.3818H17.8976V18.5252H19.8142ZM19.5253 20.488C19.728 19.8627 19.83 19.1942 19.8139 18.5029L17.8979 18.5475C17.9089 19.0202 17.8391 19.4741 17.702 19.8971L19.5253 20.488Z"
                fill="black"
              />
            </g>
            <mask
              id="mask1_3109_29711"
              // style="mask-type:luminance"
              maskUnits="userSpaceOnUse"
              x="12"
              y="5"
              width="7"
              height="7"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.0728 8.7273C17.0728 9.79816 16.2047 10.6663 15.1339 10.6663C14.8955 10.6663 14.6671 10.6232 14.4561 10.5445C14.4621 10.5846 14.4653 10.6256 14.4653 10.6673V11.5471C14.6799 11.5978 14.9038 11.6246 15.1339 11.6246C16.734 11.6246 18.0311 10.3274 18.0311 8.7273C18.0311 7.12718 16.734 5.83002 15.1339 5.83002C13.5338 5.83002 12.2366 7.12718 12.2366 8.7273C12.2366 9.1255 12.317 9.50494 12.4623 9.85028H13.553C13.3275 9.53342 13.1949 9.14584 13.1949 8.7273C13.1949 7.65645 14.0631 6.78835 15.1339 6.78835C16.2047 6.78835 17.0728 7.65645 17.0728 8.7273Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask1_3109_29711)">
              <path
                d="M14.4561 10.5445L14.7911 9.64665C14.4731 9.52797 14.116 9.58643 13.8524 9.80034C13.5887 10.0142 13.4579 10.3517 13.5085 10.6874L14.4561 10.5445ZM14.4653 11.5471H13.507C13.507 11.9915 13.8125 12.3776 14.245 12.4797L14.4653 11.5471ZM12.4623 9.8503L11.579 10.222C11.7286 10.5775 12.0767 10.8086 12.4623 10.8086V9.8503ZM13.5531 9.8503V10.8086C13.9118 10.8086 14.2404 10.6083 14.4048 10.2896C14.5692 9.97078 14.5419 9.58688 14.3339 9.29464L13.5531 9.8503ZM15.1339 11.6246C16.7341 11.6246 18.0312 10.3274 18.0312 8.72732H16.1145C16.1145 9.2689 15.6755 9.70794 15.1339 9.70794V11.6246ZM14.1212 11.4424C14.4376 11.5605 14.7794 11.6246 15.1339 11.6246V9.70794C15.0117 9.70794 14.8966 9.68599 14.7911 9.64665L14.1212 11.4424ZM13.5085 10.6874C13.5075 10.6803 13.507 10.6736 13.507 10.6673H15.4236C15.4236 10.5776 15.4169 10.4888 15.4038 10.4017L13.5085 10.6874ZM13.507 10.6673V11.5471H15.4236V10.6673H13.507ZM15.1339 10.6663C14.9785 10.6663 14.8286 10.6482 14.6856 10.6144L14.245 12.4797C14.5313 12.5474 14.8291 12.5829 15.1339 12.5829V10.6663ZM17.0728 8.72732C17.0728 9.79818 16.2048 10.6663 15.1339 10.6663V12.5829C17.2634 12.5829 18.9895 10.8567 18.9895 8.72732H17.0728ZM15.1339 6.78837C16.2048 6.78837 17.0728 7.65647 17.0728 8.72732H18.9895C18.9895 6.59792 17.2634 4.8717 15.1339 4.8717V6.78837ZM13.1949 8.72732C13.1949 7.65647 14.0631 6.78837 15.1339 6.78837V4.8717C13.0045 4.8717 11.2783 6.59792 11.2783 8.72732H13.1949ZM13.3456 9.47858C13.2489 9.24879 13.1949 8.99558 13.1949 8.72732H11.2783C11.2783 9.25547 11.385 9.76112 11.579 10.222L13.3456 9.47858ZM12.4623 10.8086H13.5531V8.89197H12.4623V10.8086ZM12.2366 8.72732C12.2366 9.3515 12.4351 9.93217 12.7723 10.406L14.3339 9.29464C14.2201 9.1347 14.1533 8.94023 14.1533 8.72732H12.2366ZM15.1339 5.83004C13.5338 5.83004 12.2366 7.1272 12.2366 8.72732H14.1533C14.1533 8.18575 14.5924 7.7467 15.1339 7.7467V5.83004ZM18.0312 8.72732C18.0312 7.1272 16.7341 5.83004 15.1339 5.83004V7.7467C15.6755 7.7467 16.1145 8.18575 16.1145 8.72732H18.0312Z"
                fill="black"
              />
            </g>
            <mask
              id="mask2_3109_29711"
              // style="mask-type:luminance"
              maskUnits="userSpaceOnUse"
              x="10"
              y="12"
              width="10"
              height="12"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.109 19.6565C10.5687 21.8988 12.5257 23.6097 14.9112 23.668C17.6846 23.6002 19.8788 21.2987 19.8143 18.5251V13.3818C19.825 12.9197 19.4595 12.5361 18.9973 12.5247H14.4654V18.8395C14.4654 19.2818 14.1138 19.6422 13.6747 19.6561C13.6659 19.6564 13.6572 19.6565 13.6484 19.6565C13.6483 19.6565 13.6485 19.6565 13.6484 19.6565H10.109Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask2_3109_29711)">
              <path
                d="M10.109 19.6565V18.6981C9.82105 18.6981 9.5484 18.8276 9.36639 19.0507C9.18439 19.2738 9.11234 19.5669 9.17017 19.849L10.109 19.6565ZM14.9112 23.6681L14.8877 24.6261C14.9033 24.6265 14.919 24.6265 14.9347 24.6261L14.9112 23.6681ZM19.8143 18.5252H18.856C18.856 18.5326 18.8561 18.54 18.8561 18.5475L19.8143 18.5252ZM19.8143 13.3818L18.8561 13.3597C18.8561 13.367 18.856 13.3744 18.856 13.3818H19.8143ZM18.9972 12.5247L19.021 11.5666C19.013 11.5664 19.0052 11.5663 18.9972 11.5663V12.5247ZM14.4654 12.5247V11.5663C13.9361 11.5663 13.507 11.9954 13.507 12.5247H14.4654ZM13.6484 19.6565V18.6981H13.6445L13.6484 19.6565ZM13.6484 19.6565L13.6482 20.6148H13.652L13.6484 19.6565ZM9.17017 19.849C9.71756 22.5188 12.0463 24.5566 14.8877 24.6261L14.9347 22.71C13.005 22.6628 11.4199 21.2787 11.0478 19.464L9.17017 19.849ZM14.9347 24.6261C18.2367 24.5453 20.8492 21.8051 20.7723 18.5029L18.8561 18.5475C18.9084 20.7923 17.1325 22.6551 14.8877 22.71L14.9347 24.6261ZM20.7726 18.5252V13.3818H18.856V18.5252H20.7726ZM20.7723 13.404C20.7952 12.4133 20.0116 11.5912 19.021 11.5666L18.9735 13.4827C18.9071 13.4811 18.8546 13.426 18.8561 13.3597L20.7723 13.404ZM18.9972 11.5663H14.4654V13.483H18.9972V11.5663ZM13.507 12.5247V18.8395H15.4237V12.5247H13.507ZM13.507 18.8395C13.507 18.7614 13.5703 18.6981 13.6484 18.6981L13.6482 20.6148C14.6287 20.6148 15.4237 19.82 15.4237 18.8395H13.507ZM13.6484 18.6981H10.109V20.6148H13.6482L13.6484 18.6981Z"
                fill="black"
              />
            </g>
            <path
              d="M13.6484 9.37115H5.47626C4.76039 9.37115 4.18005 9.95148 4.18005 10.6673V18.8394C4.18005 19.5553 4.76038 20.1357 5.47626 20.1357H13.6484C14.3643 20.1357 14.9445 19.5553 14.9445 18.8394V10.6673C14.9445 9.95149 14.3643 9.37115 13.6484 9.37115Z"
              stroke="black"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.34668 12.7069H9.50292M9.50292 12.7069V17.4986M9.50292 12.7069H11.6592"
              stroke="black"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_3109_29711">
              <rect
                width="28"
                height="28"
                fill="white"
                transform="translate(0 0.75)"
              />
            </clipPath>
          </defs>
        </svg>
      );
    case 'zoom':
      return (
        <svg
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask0_3405_45100"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="25"
          >
            <rect y="0.539062" width="24" height="24" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_3405_45100)">
            <path
              d="M4 20.7553V15.6872H5V19.0243L8.6 15.3752L9.30775 16.0926L5.70775 19.7417H9V20.7553H4ZM15 20.7553V19.7417H18.2923L14.6923 16.0926L15.4 15.3752L19 19.0243V15.6872H20V20.7553H15ZM8.6 9.91736L5 6.26831V9.60541H4V4.53729H9V5.55092H5.70775L9.30775 9.19996L8.6 9.91736ZM15.4 9.91736L14.6923 9.19996L18.2923 5.55092H15V4.53729H20V9.60541H19V6.26831L15.4 9.91736Z"
              fill="#1C1B1F"
            />
          </g>
        </svg>
      );
    case 'comboBox_checked':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.9751 6.22296L8.5787 13.6103L4.9751 10.0067"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'comboBox_check':
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.9751 6.22296L8.5787 13.6103L4.9751 10.0067"
            stroke="#D1D8E2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'comboBox_open':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M5.83325 12.0834L9.99992 7.91671L14.1666 12.0834"
            stroke={color ? color : 'var(--dk-text, black)'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'comboBox_close':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M5.83337 8.33337L10 12.5L14.1667 8.33337"
            stroke={color ? color : 'var(--dk-text, black)'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'dialogClose':
      return (
        <svg
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.9999 7L6.99988 21"
            stroke="black"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.00012 7L21.0001 21"
            stroke="black"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'settings':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="26"
          height="26"
          viewBox="0 0 26 26"
          fill="none"
        >
          <ellipse
            cx="13.0001"
            cy="12.9999"
            rx="2.50403"
            ry="2.53459"
            stroke="black"
            strokeWidth="1.2"
          />
          <path
            d="M5.12313 7.98937C4.9985 8.19047 4.8817 8.39589 4.77287 8.60512C4.30016 9.51382 4.73924 10.5884 5.61543 11.1005C7.05556 11.9421 7.0625 14.054 5.6158 14.8995C4.73587 15.4137 4.3006 16.4876 4.77226 17.3915C4.82756 17.4975 4.88506 17.6028 4.94476 17.7075C5.00446 17.8122 5.06583 17.9152 5.12884 18.0167C5.6664 18.8821 6.80284 19.0375 7.68279 18.5232C9.1295 17.6778 10.933 18.7399 10.933 20.4231C10.933 21.4472 11.6329 22.3694 12.6467 22.4094C12.8801 22.4186 13.1143 22.4189 13.3486 22.4102C14.3619 22.3726 15.067 21.4548 15.067 20.4317C15.067 18.7445 16.8813 17.6842 18.3249 18.5278C19.2002 19.0393 20.3381 18.8802 20.8769 18.0108C21.0015 17.8097 21.1183 17.6043 21.2271 17.395C21.6998 16.4863 21.2607 15.4117 20.3845 14.8996C18.9444 14.058 18.9374 11.9461 20.3842 11.1006C21.2641 10.5864 21.6994 9.51249 21.2277 8.60855C21.1724 8.5026 21.1149 8.39727 21.0552 8.29262C20.9955 8.18795 20.9341 8.08487 20.8711 7.98341C20.3336 7.11799 19.1971 6.96259 18.3172 7.47683C16.8705 8.32227 15.067 7.26022 15.067 5.57701C15.067 4.55293 14.3671 3.63072 13.3533 3.59074C13.1199 3.58154 12.8857 3.58121 12.6513 3.58991C11.638 3.62749 10.933 4.54538 10.933 5.56843C10.933 7.25563 9.11865 8.31591 7.67511 7.47231C6.79981 6.96079 5.66194 7.11991 5.12313 7.98937Z"
            stroke="black"
            strokeWidth="1.2"
          />
        </svg>
      );
    case 'write':
      return (
        <svg
          width={width || 20}
          height={height || 21}
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.86133 15.9877L15.083 15.9877"
            stroke="black"
            strokeLinecap="round"
          />
          <path
            d="M15.1775 7.55914L7.74266 14.994L4.55749 15.4006L4.97343 12.2248L12.4083 4.7899L15.1775 7.55914Z"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'calendar_arrow_right':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <g clipPath="url(#clip0_4274_90624)">
            <path
              d="M10 7L15 12L10 17"
              stroke={color ? color : 'var(--dk-text, black)'}
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_4274_90624">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'calendar_arrow_left':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <g clipPath="url(#clip0_4274_90623)">
            <path
              d="M15 17L10 12L15 7"
              stroke="black"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_4274_90623">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

    case 'right_arrow':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width || 25}
          height={height || 24}
          viewBox="0 0 25 24"
          fill="none"
        >
          <g clipPath="url(#clip0_2414_26543)">
            <path
              d="M10.5 7L15.5 12L10.5 17"
              stroke="black"
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_2414_26543">
              <rect
                width="24"
                height="24"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      );
    case 'right_arrow_gray':
      return (
        <svg
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.33301 6.37244L12.4997 10.5391L8.33301 14.7058"
            stroke="#888D96"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'start':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="18"
          viewBox="0 0 20 18"
          fill="none"
        >
          <path
            d="M16.875 0.25C17.2188 0.25 17.5 0.53125 17.5 0.875V2.75H19.375C19.7188 2.75 20 3.03125 20 3.375C20 3.71875 19.7188 4 19.375 4H17.5V5.875C17.5 6.21875 17.2188 6.5 16.875 6.5C16.5312 6.5 16.25 6.21875 16.25 5.875V4H14.375C14.0312 4 13.75 3.71875 13.75 3.375C13.75 3.03125 14.0312 2.75 14.375 2.75H16.25V0.875C16.25 0.53125 16.5312 0.25 16.875 0.25ZM16.875 11.5C17.2188 11.5 17.5 11.7812 17.5 12.125V14H19.375C19.7188 14 20 14.2812 20 14.625C20 14.9688 19.7188 15.25 19.375 15.25H17.5V17.125C17.5 17.4688 17.2188 17.75 16.875 17.75C16.5312 17.75 16.25 17.4688 16.25 17.125V15.25H14.375C14.0312 15.25 13.75 14.9688 13.75 14.625C13.75 14.2812 14.0312 14 14.375 14H16.25V12.125C16.25 11.7812 16.5312 11.5 16.875 11.5ZM5.34375 7.45312L2.11719 8.94531L5.34375 10.4336C5.61328 10.5586 5.82812 10.7734 5.95312 11.043L7.44141 14.2695L8.92969 11.043C9.05469 10.7734 9.26953 10.5586 9.53906 10.4336L12.7656 8.94531L9.53906 7.45703C9.26953 7.33203 9.05469 7.11719 8.92969 6.84766L7.44141 3.62109L5.95312 6.84766C5.82812 7.11719 5.61328 7.33203 5.34375 7.45703V7.45312ZM4.82031 11.5703L0.363281 9.51172C0.140625 9.41016 0 9.1875 0 8.94531C0 8.70312 0.140625 8.48047 0.363281 8.37891L4.82031 6.32031L6.875 1.86328C6.97656 1.64063 7.19922 1.5 7.44141 1.5C7.68359 1.5 7.90625 1.64063 8.00781 1.86328L10.0664 6.32031L14.5234 8.375C14.7461 8.47656 14.8867 8.69922 14.8867 8.94141C14.8867 9.18359 14.7461 9.40625 14.5234 9.50781L10.0703 11.5703L8.01172 16.0234C7.91016 16.2461 7.6875 16.3867 7.44531 16.3867C7.20313 16.3867 6.98047 16.2461 6.87891 16.0234L4.82031 11.5703Z"
            fill="black"
          />
        </svg>
      );
    case 'home':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M14.8077 9.05037V15.4798C14.7954 15.6063 14.7286 15.7233 14.6218 15.8051C14.515 15.887 14.3769 15.9271 14.2376 15.9168H11.5797V12.2965H8.42037V15.9168H5.76243C5.62318 15.9271 5.48506 15.887 5.37825 15.8051C5.27144 15.7233 5.20462 15.6063 5.19238 15.4798V9.05037"
            stroke="#888d96"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.1562 10.2378L10 4.08162L3.84375 10.2378"
            stroke="#888d96"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'arrowDown':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
          style={style}
        >
          <path
            d="M6.3335 8.83334L10.5002 13L14.6668 8.83334"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'arrowDown_grey':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
        >
          <path
            d="M8 13L16 21L24 13"
            stroke="#B7BBC2"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'drawer':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="16"
          viewBox="0 0 20 16"
          fill="none"
        >
          <line
            x1="0.597314"
            y1="0.939062"
            x2="19.3973"
            y2="0.939062"
            stroke="black"
            strokeWidth="1.2"
            strokeLinecap="round"
          />
          <line
            x1="0.597314"
            y1="8.47031"
            x2="14.3973"
            y2="8.47031"
            stroke="black"
            strokeWidth="1.2"
            strokeLinecap="round"
          />
          <line
            x1="0.597314"
            y1="15.3375"
            x2="19.3973"
            y2="15.3375"
            stroke="black"
            strokeWidth="1.2"
            strokeLinecap="round"
          />
        </svg>
      );
    case 'daily_sales':
      return (
        <svg
          width="40"
          height="41"
          viewBox="0 0 40 41"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect y="0.539062" width="40" height="40" rx="20" fill="#F9FAFB" />
          <mask
            id="mask0_3405_42001"
            maskUnits="userSpaceOnUse"
            x="8"
            y="8"
            width="24"
            height="25"
          >
            <rect x="8" y="8.53906" width="24" height="24" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_3405_42001)">
            <path
              d="M15.0463 29.4928C14.9398 29.3865 14.8865 29.2686 14.8865 29.1391C14.8865 29.0096 14.9398 28.8916 15.0463 28.7853L19.7635 24.0621C20.0698 23.7557 20.4487 23.6026 20.9 23.6026C21.3513 23.6026 21.7302 23.7557 22.0365 24.0621L23.9578 25.9833C24.0731 26.0986 24.2205 26.1563 24.4 26.1563C24.5795 26.1563 24.7269 26.0986 24.8423 25.9833L29.2213 21.6046C29.3186 21.5071 29.4333 21.4551 29.5655 21.4486C29.6975 21.4422 29.8186 21.4942 29.9288 21.6046C30.0391 21.7147 30.0943 21.8336 30.0943 21.9611C30.0943 22.0887 30.0391 22.2076 29.9288 22.3178L25.5365 26.7161C25.2302 27.0224 24.8523 27.1756 24.403 27.1756C23.9535 27.1756 23.5756 27.0224 23.2693 26.7161L21.3423 24.7891C21.2269 24.6737 21.0795 24.6161 20.9 24.6161C20.7205 24.6161 20.5731 24.6737 20.4578 24.7891L15.7538 29.4928C15.6603 29.5865 15.5465 29.6375 15.4125 29.6458C15.2785 29.6541 15.1564 29.6031 15.0463 29.4928ZM12.6155 28.5391C12.1552 28.5391 11.7708 28.3849 11.4625 28.0766C11.1542 27.7682 11 27.3839 11 26.9236V14.1546C11 13.6942 11.1542 13.3099 11.4625 13.0016C11.7708 12.6932 12.1552 12.5391 12.6155 12.5391H25.3845C25.8448 12.5391 26.2292 12.6932 26.5375 13.0016C26.8458 13.3099 27 13.6942 27 14.1546V17.7313C27 17.9635 26.9234 18.1561 26.7703 18.3093C26.6171 18.4625 26.4244 18.5391 26.1923 18.5391H12V26.9236C12 27.0776 12.0641 27.2186 12.1923 27.3468C12.3204 27.475 12.4615 27.5391 12.6155 27.5391V28.5391ZM12 17.5391H26V14.1546C26 14.0006 25.9359 13.8595 25.8078 13.7313C25.6796 13.6031 25.5385 13.5391 25.3845 13.5391H12.6155C12.4615 13.5391 12.3204 13.6031 12.1923 13.7313C12.0641 13.8595 12 14.0006 12 14.1546V17.5391Z"
              fill="#1C1B1F"
            />
          </g>
        </svg>
      );
    case 'daily_rival_rank':
      return (
        <svg
          width="40"
          height="41"
          viewBox="0 0 40 41"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect y="0.539062" width="40" height="40" rx="20" fill="#F9FAFB" />
          <mask
            id="mask0_3405_42010"
            maskUnits="userSpaceOnUse"
            x="8"
            y="8"
            width="24"
            height="25"
          >
            <rect x="8" y="8.53906" width="24" height="24" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_3405_42010)">
            <path
              d="M12 27.5391H16.673V19.5391H12V27.5391ZM17.673 27.5391H22.327V13.5391H17.673V27.5391ZM23.327 27.5391H28V21.5391H23.327V27.5391ZM11 26.9236V20.1546C11 19.7102 11.1582 19.3299 11.4745 19.0136C11.7908 18.6972 12.1712 18.5391 12.6155 18.5391H16.673V14.1546C16.673 13.7102 16.8312 13.3299 17.1475 13.0136C17.4638 12.6972 17.8442 12.5391 18.2885 12.5391H21.7115C22.1558 12.5391 22.5362 12.6972 22.8525 13.0136C23.1688 13.3299 23.327 13.7102 23.327 14.1546V20.5391H27.3845C27.8288 20.5391 28.2092 20.6972 28.5255 21.0136C28.8418 21.3299 29 21.7102 29 22.1546V26.9236C29 27.3679 28.8418 27.7482 28.5255 28.0646C28.2092 28.3809 27.8288 28.5391 27.3845 28.5391H12.6155C12.1712 28.5391 11.7908 28.3809 11.4745 28.0646C11.1582 27.7482 11 27.3679 11 26.9236Z"
              fill="#1C1B1F"
            />
          </g>
        </svg>
      );
    case 'sales_analysis':
      return (
        <svg
          width="40"
          height="41"
          viewBox="0 0 40 41"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect y="0.539062" width="40" height="40" rx="20" fill="#F9FAFB" />
          <mask
            id="mask0_3405_42020"
            maskUnits="userSpaceOnUse"
            x="8"
            y="8"
            width="24"
            height="25"
          >
            <rect x="8" y="8.53906" width="24" height="24" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_3405_42020)">
            <path
              d="M11.9993 29.0409C11.8574 29.0409 11.7387 28.993 11.6432 28.8971C11.5477 28.8013 11.5 28.6826 11.5 28.5409V27.7524C11.5 27.6107 11.548 27.492 11.644 27.3961C11.74 27.3003 11.8589 27.2524 12.0008 27.2524C12.1426 27.2524 12.2613 27.3003 12.3568 27.3961C12.4523 27.492 12.5 27.6107 12.5 27.7524V28.5409C12.5 28.6826 12.452 28.8013 12.356 28.8971C12.26 28.993 12.1411 29.0409 11.9993 29.0409ZM15.9992 29.0409C15.8574 29.0409 15.7388 28.993 15.6433 28.8971C15.5478 28.8013 15.5 28.6826 15.5 28.5409V23.2524C15.5 23.1107 15.548 22.992 15.644 22.8961C15.74 22.8003 15.8589 22.7524 16.0008 22.7524C16.1426 22.7524 16.2613 22.8003 16.3568 22.8961C16.4523 22.992 16.5 23.1107 16.5 23.2524V28.5409C16.5 28.6826 16.452 28.8013 16.356 28.8971C16.26 28.993 16.1411 29.0409 15.9992 29.0409ZM19.9993 29.0409C19.8574 29.0409 19.7388 28.993 19.6433 28.8971C19.5478 28.8013 19.5 28.6826 19.5 28.5409V25.2524C19.5 25.1107 19.548 24.992 19.644 24.8961C19.74 24.8003 19.8589 24.7524 20.0008 24.7524C20.1426 24.7524 20.2612 24.8003 20.3567 24.8961C20.4522 24.992 20.5 25.1107 20.5 25.2524V28.5409C20.5 28.6826 20.452 28.8013 20.356 28.8971C20.26 28.993 20.1411 29.0409 19.9993 29.0409ZM23.9992 29.0409C23.8574 29.0409 23.7387 28.993 23.6432 28.8971C23.5477 28.8013 23.5 28.6826 23.5 28.5409V23.7524C23.5 23.6107 23.548 23.492 23.644 23.3961C23.74 23.3003 23.8589 23.2524 24.0008 23.2524C24.1426 23.2524 24.2613 23.3003 24.3568 23.3961C24.4523 23.492 24.5 23.6107 24.5 23.7524V28.5409C24.5 28.6826 24.452 28.8013 24.356 28.8971C24.26 28.993 24.1411 29.0409 23.9992 29.0409ZM27.9993 29.0409C27.8574 29.0409 27.7388 28.993 27.6432 28.8971C27.5477 28.8013 27.5 28.6826 27.5 28.5409V19.7524C27.5 19.6107 27.548 19.492 27.644 19.3961C27.74 19.3003 27.8589 19.2524 28.0008 19.2524C28.1426 19.2524 28.2612 19.3003 28.3568 19.3961C28.4523 19.492 28.5 19.6107 28.5 19.7524V28.5409C28.5 28.6826 28.452 28.8013 28.356 28.8971C28.26 28.993 28.1411 29.0409 27.9993 29.0409ZM22 19.9774C21.7975 19.9774 21.5981 19.9375 21.4018 19.8576C21.2054 19.7776 21.026 19.6644 20.8635 19.5179L18.4423 17.0966C18.3269 16.9813 18.1795 16.9236 18 16.9236C17.8205 16.9236 17.6731 16.9813 17.5578 17.0966L12.3537 22.3004C12.2564 22.3979 12.1375 22.4489 11.997 22.4534C11.8567 22.4579 11.7378 22.405 11.6405 22.2946C11.5468 22.1973 11.502 22.0808 11.506 21.9451C11.5102 21.8096 11.5569 21.6967 11.6463 21.6064L16.8635 16.3889C17.026 16.2291 17.2054 16.1125 17.4018 16.0391C17.5981 15.966 17.7975 15.9294 18 15.9294C18.2025 15.9294 18.4053 15.966 18.6085 16.0391C18.8117 16.1125 18.9877 16.2291 19.1365 16.3889L21.5577 18.8101C21.6731 18.9255 21.8205 18.9831 22 18.9831C22.1795 18.9831 22.3269 18.9255 22.4423 18.8101L27.6462 13.6064C27.7436 13.5089 27.8625 13.4579 28.003 13.4534C28.1433 13.4489 28.2622 13.5018 28.3595 13.6121C28.4532 13.7095 28.498 13.826 28.494 13.9616C28.4898 14.0971 28.4431 14.2101 28.3538 14.3004L23.1365 19.5179C22.9877 19.6644 22.8117 19.7776 22.6085 19.8576C22.4053 19.9375 22.2025 19.9774 22 19.9774Z"
              fill="#1C1B1F"
            />
          </g>
        </svg>
      );
    case 'expand':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width ? width : 14}
          height={height ? height : 14}
          viewBox="0 0 14 14"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.34872 0.949219C6.34872 1.22536 6.12486 1.44922 5.84872 1.44922L2.15641 1.44922L4.59566 3.88847L5.88857 5.18138C6.08383 5.37664 6.08383 5.69322 5.88857 5.88849C5.69331 6.08375 5.37673 6.08375 5.18146 5.88849L3.88856 4.59558L1.44922 2.15624L1.44922 5.84871C1.44922 6.12486 1.22536 6.34871 0.949219 6.34871C0.673076 6.34871 0.449219 6.12486 0.449219 5.84871L0.449221 0.949218C0.449221 0.673076 0.673079 0.449219 0.949221 0.449219H5.84872C6.12486 0.449219 6.34872 0.673077 6.34872 0.949219ZM7.76728 7.76719C7.96254 7.57193 8.27912 7.57193 8.47439 7.76719L9.76729 9.0601L12.4498 11.7426L12.4498 8.15072C12.4498 7.87457 12.6737 7.65072 12.9498 7.65072C13.2259 7.65072 13.4498 7.87457 13.4498 8.15072L13.4498 13.0502C13.4498 13.3264 13.2259 13.5502 12.9498 13.5502H8.05029C7.77415 13.5502 7.55029 13.3264 7.5503 13.0502C7.5503 12.7741 7.77415 12.5502 8.0503 12.5502H11.8432L9.06019 9.76721L7.76728 8.4743C7.57202 8.27904 7.57202 7.96246 7.76728 7.76719Z"
            fill="black"
          />
        </svg>
      );
    case 'expand2':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M8.92285 8.92188C9.15717 8.68756 9.53619 8.68756 9.77051 8.92188L14.541 13.6924V9.38086C14.5413 9.04979 14.8105 8.7813 15.1416 8.78125C15.4726 8.78146 15.7409 9.04989 15.7412 9.38086V15.2598C15.7412 15.591 15.4728 15.8601 15.1416 15.8604H9.26172C8.93048 15.8602 8.66211 15.591 8.66211 15.2598C8.66269 14.9291 8.93098 14.6615 9.26172 14.6611H13.8145L8.92285 9.76953C8.68855 9.53523 8.68859 9.15619 8.92285 8.92188ZM6.62012 0.140625C6.9514 0.140727 7.21972 0.408932 7.21973 0.740234C7.2194 1.07097 6.95177 1.33927 6.62109 1.33984L2.1875 1.33887L6.66699 5.81836C6.90131 6.05267 6.90228 6.43268 6.66797 6.66699C6.43365 6.90126 6.05363 6.90031 5.81934 6.66602L1.33984 2.18652L1.34082 6.61914C1.3406 6.95029 1.07142 7.21967 0.740234 7.21973C0.409223 7.21946 0.140846 6.95016 0.140625 6.61914V0.740234C0.140631 0.409031 0.409091 0.140889 0.740234 0.140625H6.62012Z"
            fill="white"
          />
        </svg>
      );
    case 'reduce':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width ? width : 14}
          height={height ? height : 14}
          viewBox="0 0 14 14"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.583984 5.89819C0.583984 5.66807 0.770532 5.48153 1.00065 5.48153H4.89187L3.94765 4.5373L1.36183 1.95149C1.19911 1.78877 1.19911 1.52495 1.36183 1.36223C1.52455 1.19951 1.78837 1.19951 1.95109 1.36223L4.5369 3.94805L5.48348 4.89463L5.48348 0.998698C5.48348 0.768579 5.67003 0.582031 5.90015 0.582031C6.13027 0.582031 6.31681 0.768579 6.31681 0.998698L6.31681 5.89819C6.31681 6.12831 6.13027 6.31486 5.90015 6.31486L1.00065 6.31486C0.770533 6.31486 0.583984 6.12831 0.583984 5.89819ZM9.10729 8.51843H12.8999C13.13 8.51843 13.3165 8.33189 13.3165 8.10177C13.3165 7.87165 13.13 7.6851 12.8999 7.6851H8.00037C7.77025 7.6851 7.5837 7.87165 7.5837 8.10177L7.5837 13.0013C7.5837 13.2314 7.77025 13.4179 8.00037 13.4179C8.23049 13.4179 8.41703 13.2314 8.41703 13.0013L8.41704 9.00669L9.11928 9.70893L12.2051 12.7947C12.3678 12.9575 12.6316 12.9575 12.7943 12.7947C12.9571 12.632 12.9571 12.3682 12.7943 12.2055L9.70853 9.11968L9.10729 8.51843Z"
            fill="black"
          />
        </svg>
      );
    case 'reduce2':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width ? width : 18}
          height={height ? height : 18}
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.0195312 7.45825C0.0195312 7.13608 0.280699 6.87492 0.602865 6.87492H6.05057L4.72866 5.55301L1.10852 1.93286C0.880712 1.70506 0.880712 1.33571 1.10852 1.10791C1.33632 0.880101 1.70567 0.880101 1.93348 1.10791L5.55362 4.72805L6.87883 6.05326L6.87883 0.598958C6.87883 0.276792 7.14 0.015625 7.46216 0.015625C7.78433 0.015625 8.04549 0.276792 8.04549 0.598958L8.04549 7.45825C8.04549 7.78042 7.78433 8.04158 7.46216 8.04158L0.602865 8.04158C0.280699 8.04158 0.0195312 7.78042 0.0195312 7.45825ZM11.9522 11.1266H17.2618C17.5839 11.1266 17.8451 10.8654 17.8451 10.5433C17.8451 10.2211 17.5839 9.95992 17.2618 9.95992H10.4025C10.0803 9.95992 9.81914 10.2211 9.81914 10.5433L9.81914 17.4025C9.81914 17.7247 10.0803 17.9859 10.4025 17.9859C10.7246 17.9859 10.9858 17.7247 10.9858 17.4025L10.9858 11.8102L11.9689 12.7933L16.2891 17.1134C16.5169 17.3412 16.8862 17.3412 17.114 17.1134C17.3418 16.8856 17.3418 16.5163 17.114 16.2885L12.7939 11.9683L11.9522 11.1266Z"
            fill="black"
          />
        </svg>
      );
    case 'arrow-switch-horizontal':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M6.875 8.75L5 6.875M5 6.875L6.875 5M5 6.875H15M13.125 11.25L15 13.125M15 13.125L13.125 15M15 13.125H5"
            stroke="#C77AC4"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'empty-box':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="26"
          viewBox="0 0 30 26"
          fill="none"
        >
          <path
            d="M15.293 1V3.58486"
            stroke={color || '#D4D7DB'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9 1.5L10.2924 3.73855"
            stroke={color || '#D4D7DB'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.5859 1.5L20.2935 3.73855"
            stroke={color || '#D4D7DB'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M1.80078 15.5701H9.84908C9.86867 16.5688 10.4953 18.5662 12.8452 18.5662C15.195 18.5662 17.3491 18.5662 18.1324 18.5662C18.8765 18.2725 20.3647 17.262 20.3647 15.5701H28.2956M1.80078 15.5701V24.4996H28.2956V15.5701M1.80078 15.5701L7.49921 10.4004H22.4209L28.2956 15.5701"
            stroke={color || '#D4D7DB'}
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'modify':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width || 28}
          height={height || 28}
          viewBox="0 0 28 28"
          fill="none"
        >
          <path
            d="M13.8711 22.2031L21.7037 22.2031"
            stroke={color || 'black'}
            strokeWidth="1.28571"
            strokeLinecap="round"
          />
          <path
            d="M21.8471 9.56008L10.6948 20.7124L5.91704 21.3223L6.54096 16.5586L17.6933 5.40623L21.8471 9.56008Z"
            stroke={color || 'black'}
            strokeWidth="1.28571"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'send':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="13"
          height="13"
          viewBox="0 0 13 13"
          fill="none"
        >
          <path
            d="M12.5 0.5L5.9 7.1M12.5 0.5L8.3 12.5L5.9 7.1M12.5 0.5L0.5 4.7L5.9 7.1"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case '통합':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width || 180}
          height={width || 180}
          viewBox="0 0 180 180"
          fill="none"
        >
          <rect width="180" height="180" fill="#06C" />
          <g transform="translate(30,45)">
            <path
              d="M86.3628 67V22.457H95.5913V59.3711H114.787V67H86.3628Z"
              fill="white"
            />
            <path
              d="M51.9712 67V22.457H61.1997V59.3711H80.395V67H51.9712Z"
              fill="white"
            />
            <path
              d="M14.1958 67H4.229L19.6714 22.457H31.5454L46.9263 67H37.021L33.668 56.7256H17.5488L14.1958 67ZM19.8867 49.5273H31.3301L25.7622 32.4854H25.4546L19.8867 49.5273Z"
              fill="white"
            />
          </g>
        </svg>
      );
    case 'MLB':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width || 180}
          height={width || 180}
          viewBox="0 0 180 180"
          fill="none"
        >
          <rect width="180" height="180" fill="black" />
          <path
            d="M67.7818 71.0703L52.3088 87.7347L46.6296 71.0703H35.2632V71.0782L32.8565 71.0703L34.3021 74.7936L26.1287 102.4L24.3257 108.855H35.7318L41.0457 90.7575L44.9775 100.093H52.3803L61.8007 90.7575L56.4869 108.855H68.0518L79.1482 71.0703H67.7818Z"
            fill="white"
          />
          <path
            d="M143.773 82.4843C143.336 83.9721 141.882 85.5622 138.705 85.5622H131.501L133.312 79.4065H140.516C143.685 79.4065 144.21 80.9966 143.773 82.4843ZM140.119 97.1808C139.658 98.7709 138.086 100.526 134.908 100.526H127.116L129.062 93.8904H136.862C140.032 93.8904 140.596 95.5907 140.127 97.1808H140.119ZM155.187 82.1537C157.093 75.628 153.471 71.0703 143.693 71.0703H121.715L123.177 74.5339L114.352 105.202L110.555 108.855H133.598C141.986 108.855 149.539 108.067 151.66 100.849C153.217 95.5435 151.668 91.0487 150.032 90.0884C151.716 89.2933 153.924 86.4517 155.187 82.1537Z"
            fill="white"
          />
          <path
            d="M105.201 100.574H89.1721L97.8379 71.0703H83.8185L85.3356 74.7228L76.2727 105.218L72.6348 108.847H106.504L109.744 98.1884C103.231 101.636 105.606 100.361 105.209 100.574H105.201Z"
            fill="white"
          />
        </svg>
      );
    case 'MLB Kids':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width || 180}
          height={width || 180}
          viewBox="0 0 180 180"
          fill="none"
        >
          <rect width="180" height="180" fill="black" />
          <path
            d="M73.482 82.0896H64.7705C66.088 77.5725 67.3954 73.0823 68.7028 68.592C68.6793 68.5752 68.6557 68.5618 68.6322 68.545C68.5314 68.6424 68.4272 68.7366 68.3263 68.8374C66.2056 70.9581 64.0848 73.0755 61.9708 75.1997C61.7759 75.3946 61.5809 75.482 61.302 75.4786C59.7021 75.4652 58.1023 75.4618 56.5025 75.4786C56.1933 75.482 56.0589 75.3744 55.948 75.1022C55.0943 73.0285 54.2272 70.9649 53.3634 68.8979C53.3063 68.7634 53.2458 68.6324 53.1449 68.4038C51.8005 73.015 50.4831 77.5389 49.1622 82.0795H40.5615C40.7565 81.367 40.938 80.6713 41.1396 79.9789C43.3948 72.2555 45.65 64.5253 47.9153 56.7985C48.0228 56.4321 48.0329 56.1128 47.8783 55.7566C47.5624 55.0171 47.2935 54.2643 46.9843 53.4677C47.1591 53.4577 47.2868 53.4476 47.4145 53.4476C50.5872 53.4442 53.76 53.4509 56.9327 53.4375C57.2587 53.4375 57.3932 53.535 57.4974 53.8442C58.8216 57.7866 60.1592 61.7256 61.4969 65.6646C61.5339 65.7756 61.5776 65.8831 61.675 66.152C61.796 65.9604 61.8498 65.8327 61.9405 65.7352C65.6241 61.7323 69.3111 57.7294 73.0048 53.7366C73.1359 53.5955 73.3543 53.461 73.5358 53.461C76.2111 53.4442 78.8865 53.4476 81.5618 53.4509C81.629 53.4509 81.6929 53.461 81.8273 53.4711C79.0444 63.0196 76.2683 72.5412 73.4854 82.093L73.482 82.0896Z"
            fill="white"
          />
          <path
            d="M105.719 82.0952C106.482 81.2717 107.299 80.3979 108.102 79.5173C108.223 79.3862 108.337 79.2216 108.384 79.0535C110.559 71.4846 112.723 63.9158 114.881 56.3436C114.932 56.1721 114.898 55.947 114.831 55.7756C114.585 55.137 114.31 54.5118 114.048 53.88C113.997 53.759 113.957 53.6346 113.886 53.4397C114.085 53.4397 114.226 53.4397 114.367 53.4397C119.835 53.4397 125.307 53.433 130.775 53.4431C132.449 53.4464 134.099 53.6514 135.675 54.2598C138.509 55.3554 139.826 57.5602 139.339 60.5515C138.949 62.9411 138.011 65.1089 136.374 66.9272C136.055 67.2835 135.655 67.5624 135.282 67.8851C136.247 68.7387 136.59 69.9285 136.774 71.1754C137.08 73.229 136.818 75.2254 135.995 77.1277C135.128 79.1241 133.541 80.3408 131.535 81.0566C129.693 81.7154 127.777 81.9943 125.841 82.0145C119.795 82.0716 113.749 82.075 107.702 82.0952C106.993 82.0952 106.281 82.0952 105.719 82.0952ZM117.963 75.7194C120.212 75.7194 122.416 75.8102 124.611 75.6892C126.238 75.5985 127.404 74.5028 127.76 73.1013C128.012 72.1098 127.636 71.3233 126.729 70.9771C126.493 70.8864 126.238 70.8057 125.989 70.799C123.865 70.7654 121.744 70.7486 119.62 70.7419C119.529 70.7419 119.378 70.8629 119.351 70.957C118.881 72.5366 118.424 74.1196 117.963 75.7161V75.7194ZM121.25 64.43C122.094 64.43 122.874 64.4367 123.653 64.43C124.944 64.4132 126.234 64.4435 127.518 64.3493C129.048 64.2351 130.19 63.2604 130.516 61.9429C130.708 61.1665 130.483 60.5111 129.854 60.1616C129.579 60.007 129.256 59.8558 128.954 59.849C126.9 59.7953 124.846 59.7818 122.79 59.765C122.716 59.765 122.591 59.8591 122.568 59.9331C122.127 61.4085 121.701 62.8907 121.25 64.4334V64.43Z"
            fill="white"
          />
          <path
            d="M80.9793 128.672C82.0683 127.583 83.0614 126.615 84.0243 125.622C84.2361 125.4 84.4226 125.107 84.5083 124.815C87.1702 115.821 89.817 106.827 92.4486 97.8232C92.5343 97.5308 92.494 97.1527 92.3881 96.8603C92.0806 96.0133 91.7125 95.1915 91.3294 94.269C91.5865 94.2538 91.773 94.2286 91.9596 94.2286C98.6747 94.2286 105.39 94.1984 112.1 94.2438C114.318 94.2589 116.451 94.7983 118.407 95.8923C120.731 97.193 122.022 99.1743 122.188 101.836C122.611 108.561 121.089 114.772 117.021 120.222C113.658 124.729 109.03 127.265 103.56 128.289C102.184 128.546 100.762 128.641 99.3553 128.651C93.5073 128.692 87.6592 128.667 81.8162 128.667C81.5944 128.667 81.3726 128.667 80.9692 128.667L80.9793 128.672ZM102.985 100.329C100.858 107.659 98.71 115.045 96.5422 122.501C97.495 122.501 98.337 122.501 99.1839 122.501C102.547 122.516 105.098 121.069 106.726 118.14C108.944 114.147 110.27 109.862 110.573 105.29C110.744 102.693 109.337 100.798 106.771 100.359C105.561 100.152 104.286 100.324 102.985 100.324V100.329Z"
            fill="white"
          />
          <path
            d="M43.5192 111.934C43.015 113.648 42.5159 115.362 42.0118 117.071C40.9581 120.666 39.9095 124.255 38.8609 127.85C38.7701 128.157 38.6794 128.369 38.2711 128.369C34.0564 128.354 29.8418 128.359 25.6322 128.354C25.5566 128.354 25.4759 128.334 25.2642 128.304C25.7128 127.85 26.0657 127.421 26.4943 127.079C27.8353 126 28.5058 124.593 28.9797 122.945C31.3744 114.606 33.8598 106.298 36.32 97.9794C36.4461 97.5509 36.4461 97.1778 36.2545 96.7644C35.8965 95.983 35.594 95.1764 35.2512 94.3294H48.6614C47.0532 99.8397 45.45 105.315 43.8469 110.79C43.8771 110.805 43.9074 110.825 43.9376 110.84C44.2653 110.417 44.598 109.998 44.9207 109.575C48.7018 104.649 52.4828 99.7288 56.2488 94.7982C56.5361 94.4201 56.8336 94.2891 57.3024 94.2891C60.7911 94.3092 64.2798 94.2991 67.7684 94.2991H68.5095C68.323 94.5311 68.2121 94.6773 68.0911 94.8184C63.9269 99.6632 59.7627 104.508 55.5783 109.333C55.1447 109.832 55.0439 110.245 55.2304 110.885C56.8638 116.552 58.462 122.229 60.0702 127.9C60.1004 128.016 60.1307 128.132 60.1861 128.354C59.9038 128.354 59.677 128.354 59.4451 128.354C55.6942 128.354 51.9434 128.354 48.1976 128.354C47.1036 128.354 47.3406 128.435 47.1288 127.487C45.9895 122.4 44.8652 117.308 43.736 112.216C43.7158 112.126 43.6855 112.035 43.6603 111.939C43.615 111.934 43.5696 111.929 43.5242 111.924L43.5192 111.934Z"
            fill="white"
          />
          <path
            d="M85.3511 53.4375H95.8944C93.7199 60.8988 91.5588 68.3198 89.3776 75.7946H89.8145C93.5653 75.7946 97.3161 75.7979 101.064 75.7878C101.306 75.7878 101.568 75.7139 101.783 75.603C102.784 75.0921 103.776 74.5544 104.848 73.9864C104.74 74.3527 104.66 74.6451 104.572 74.9342C103.887 77.2062 103.194 79.4815 102.519 81.7569C102.445 82.009 102.334 82.0829 102.072 82.0829C93.8073 82.0762 85.5394 82.0762 77.2748 82.0762H76.9219C77.5134 81.4712 78.0108 80.8898 78.5855 80.3957C79.3821 79.7134 79.8056 78.8765 80.0946 77.8716C82.1616 70.7464 84.279 63.6346 86.3661 56.5161C86.4233 56.3178 86.4065 56.0624 86.3325 55.8675C86.0301 55.0676 85.694 54.2811 85.3478 53.4375H85.3511Z"
            fill="white"
          />
          <path
            d="M123.008 119.172H133.519C133.625 121.411 134.366 122.454 136.171 122.807C136.715 122.913 137.3 122.918 137.855 122.853C139.66 122.636 141.096 121.794 142.014 120.186C143.128 118.23 142.468 116.465 140.345 115.704C139.075 115.25 137.799 114.816 136.529 114.373C134.82 113.778 133.101 113.198 131.402 112.573C127.958 111.308 126.874 109.336 127.671 105.752C128.725 101.003 131.477 97.6051 135.999 95.8153C140.844 93.8946 145.871 93.6425 150.957 94.6861C151.794 94.8575 152.611 95.2104 153.382 95.5885C155.757 96.7531 156.77 98.694 156.458 101.331C156.34 102.322 155.785 102.818 154.794 102.818C152.313 102.818 149.833 102.818 147.353 102.818H146.596C146.506 101.583 146.052 100.579 144.852 100.206C142.891 99.5964 141.011 99.8283 139.372 101.129C138.384 101.915 137.986 103.025 138.253 104.265C138.515 105.485 139.337 106.236 140.512 106.644C143.244 107.597 145.981 108.55 148.699 109.553C149.389 109.81 150.03 110.214 150.675 110.587C152.651 111.741 153.322 113.526 152.913 115.694C151.779 121.688 148.457 125.842 142.503 127.591C137.92 128.938 133.262 129.109 128.583 128.045C127.863 127.884 127.162 127.602 126.486 127.294C123.522 125.948 122.282 123.614 122.781 120.387C122.841 119.989 122.932 119.596 123.013 119.172H123.008Z"
            fill="white"
          />
          <path
            d="M86.7667 94.2941C86.2777 95.9779 85.8038 97.6164 85.3249 99.2549C82.5521 108.718 79.7742 118.18 77.0216 127.648C76.8704 128.173 76.6586 128.329 76.1192 128.324C72.0457 128.299 67.9773 128.309 63.9038 128.309C63.6921 128.309 63.4753 128.309 63.2636 128.309C63.2182 128.238 63.1728 128.173 63.1274 128.102C63.7425 127.537 64.3374 126.952 64.9726 126.408C65.8145 125.692 66.2683 124.79 66.5808 123.731C69.0965 115.095 71.6575 106.474 74.1833 97.8433C74.2791 97.5156 74.2236 97.0971 74.1127 96.7644C73.8254 95.9326 73.4674 95.131 73.1246 94.2891H86.7667V94.2941Z"
            fill="white"
          />
        </svg>
      );
    case 'Discovery':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width || 180}
          height={width || 180}
          viewBox="0 0 180 180"
          fill="none"
        >
          <rect width="180" height="180" fill="white" />
          <path
            d="M129.915 101.152C126.355 103.87 122.679 106.664 121.263 110.378C120.612 112.081 120.191 113.842 119.713 115.967L119.674 116.159C119.253 117.977 118.813 119.872 118.143 121.767C117.703 123.03 117.148 124.294 116.612 125.48C115.616 127.72 114.678 129.845 114.506 131.912C114.353 133.75 116.554 136.582 119.98 139.013L120.153 139.147C132.824 131.108 142.414 118.226 145.86 102.396C146.74 98.2996 147.142 94.2224 147.161 90.1836C141.783 92.6337 136.71 95.7346 132.48 99.1418C131.638 99.8117 130.738 100.501 129.896 101.152"
            fill="#1B365D"
          />
          <path
            d="M60.6611 95.7152C63.494 93.5713 66.9778 91.1021 71.3803 89.0731C72.9499 88.3457 74.5004 87.5226 75.9934 86.6996L76.2039 86.5847C77.5247 85.8765 78.9029 85.13 80.3002 84.4791C84.1859 82.6224 87.4783 80.7848 88.5502 77.3011L88.8947 76.1717C90.0049 72.5157 91.0577 69.0511 93.393 65.5291C95.422 62.4665 95.3454 61.9496 92.589 59.4612C89.9667 57.0877 88.5119 56.322 85.5641 55.7478C81.8507 55.0204 77.1802 55.9009 73.0647 56.6857L72.7393 56.7432C63.1686 58.5807 51.0329 57.2408 42.5341 55.7861L42.0173 55.6904C41.3856 56.5517 40.7731 57.4323 40.1797 58.351C44.3526 59.8058 49.9801 61.7391 53.885 62.0453L55.3972 62.1411C60.8908 62.4856 67.1118 62.8684 68.7388 73.0517C69.983 80.8231 64.5085 86.2593 58.1535 92.576H58.1344C51.7029 98.9692 43.7017 106.913 39.6438 120.082L39.5098 120.503C40.5434 122.188 41.6536 123.796 42.8404 125.365C45.5585 115.795 50.8224 103.238 60.6994 95.7152"
            fill="#1B365D"
          />
          <path
            d="M70.3658 109.172C71.9737 108.502 73.6581 107.851 75.3234 107.22L75.802 107.047C83.7648 104.042 91.9765 100.941 95.9579 93.9354C96.4747 92.9975 96.915 92.0978 97.3361 91.1982L97.451 90.9685C98.5612 88.6332 99.6714 86.2597 102.007 84.0584C104.706 81.5126 107.806 79.6941 110.812 77.914C112.477 76.9378 113.932 76.0764 115.31 75.1193L115.98 74.6599C117.99 73.3009 121.359 71.0422 121.473 69.0898C121.473 68.9558 121.416 68.4964 120.65 67.4436C118.947 65.0701 116.784 62.9454 114.678 60.8972L114.315 60.5335C112.879 59.1171 111.405 57.6432 110.046 56.0544C106.773 52.2453 100.188 45.6032 92.857 43.8422C89.9092 43.134 84.8176 43.8422 80.3193 44.4739C77.2376 44.9141 74.4621 45.2969 72.1651 45.3161C70.5572 45.3352 67.9922 45.5075 65.5038 45.6798C60.8142 45.986 55.4929 46.3306 51.8943 46.1009L50.8415 46.0435C49.3676 47.3068 47.9703 48.6467 46.6304 50.0632C53.8276 51.1351 63.8003 52.0539 71.5334 50.5608L71.7822 50.5226C76.491 49.6229 81.8315 48.6084 86.77 49.5846C91.3831 50.5034 93.7566 52.073 96.8001 54.8102C101.892 59.4042 102.389 63.2133 98.6377 68.8984C96.8001 71.6739 95.9196 74.5642 94.886 77.914C94.7329 78.4117 94.618 78.7945 94.5223 79.0625H94.5415C92.5699 85.4557 86.8274 88.2121 83.0183 90.0305C81.6784 90.6813 80.3193 91.4087 78.9986 92.117C77.4673 92.94 75.7445 93.878 74.0027 94.6819C70.9209 96.0984 68.1454 97.8211 64.4894 100.616C54.019 108.579 49.3676 124.37 47.8554 130.783L47.798 131.051C48.7551 132.008 49.7504 132.946 50.7841 133.826C54.3635 121.825 61.4841 112.847 70.3849 109.134"
            fill="#1B365D"
          />
          <path
            d="M53.6359 88.1921C59.2252 82.6411 63.2449 78.6596 62.4984 74.0083C61.6562 68.7635 60.1057 68.6678 54.9567 68.3424L53.3871 68.2467C48.6017 67.883 42.6296 65.8157 37.8442 64.1504L37.0211 63.8633C34.8773 68.151 33.1928 72.7449 32.1209 77.626C29.4411 89.934 30.8767 102.184 35.4898 112.923C40.256 101.476 47.6446 94.1259 53.6359 88.1921Z"
            fill="#1B365D"
          />
          <path
            d="M95.154 135.241H86.6935L95.9771 124.942L87.0572 114.97H95.69L103.978 124.828L95.154 135.26V135.241ZM108.266 131.393C108.534 128.273 109.721 125.593 110.869 122.971C111.348 121.899 111.845 120.789 112.209 119.698C112.783 118.109 113.166 116.425 113.568 114.644C114.066 112.424 114.563 110.28 115.387 108.136C117.435 102.815 122.01 99.3121 126.048 96.2303L126.508 95.8857C127.216 95.3498 127.886 94.833 128.537 94.297C133.399 90.373 139.218 86.851 145.381 84.1329L146.798 83.3289C144.022 59.2681 126.355 38.5379 101.375 33.1209C86.483 29.886 71.7058 32.6806 59.5318 39.8396C61.4077 39.7438 63.3218 39.629 65.0828 39.5141L65.5613 39.4759C68.1837 39.3036 70.4616 39.1505 72.0886 39.1505C73.9262 39.1313 76.3763 38.7868 78.9604 38.4231L79.4198 38.3657C84.7219 37.6191 90.1964 36.8535 94.331 37.8297C102.906 39.8778 110.199 46.6922 114.812 52.0518C116.152 53.6023 117.664 55.0762 119.1 56.5118C121.263 58.6365 123.713 61.0483 125.742 63.8621C126.718 65.2403 127.829 67.1161 127.714 69.4514C127.446 74.5047 122.66 77.7205 119.502 79.8452C119.502 79.8452 119.234 80.0366 119.043 80.1515L118.851 80.2855C117.224 81.3957 115.521 82.4102 113.989 83.2907C111.156 84.9751 108.476 86.5447 106.314 88.5928C104.82 90.0093 104.074 91.5981 103.117 93.627L103.021 93.8185C102.543 94.833 102.045 95.8666 101.394 96.9959C96.2834 105.973 86.5787 109.648 78.0033 112.883C76.1657 113.572 74.443 114.223 72.7585 114.931C65.0828 118.128 58.8618 126.742 56.1055 137.978V138.054C62.1159 142.189 69.0068 145.252 76.5868 146.898C89.7944 149.769 102.906 147.912 114.219 142.457C111.175 139.873 107.826 135.987 108.228 131.412"
            fill="#1B365D"
          />
        </svg>
      );
    case 'SUPRA':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width || 180}
          height={width || 180}
          viewBox="0 0 180 180"
          fill="none"
        >
          <rect width="180" height="180" fill="white" />
          <path
            d="M136.346 74.2962L122.396 105.218C114.167 109.975 100.989 112.096 89.9959 112.096C79.0031 112.096 65.8245 109.975 57.5959 105.218L43.6459 74.2962C43.2602 73.3962 43.5174 71.7891 45.7031 72.4962L65.1174 77.3819L60.7459 81.1748C60.7459 81.1748 62.0959 90.8176 69.8745 94.4819C75.7888 97.3748 80.4174 95.1891 80.6745 89.7891C81.2531 79.5676 72.7031 71.2105 71.6745 70.1819L88.5174 47.2962C89.4174 46.2033 90.5102 46.2033 91.4102 47.2962L108.253 70.1819C107.225 71.2105 98.7388 79.5676 99.2531 89.7891C99.5745 95.1891 104.203 97.3748 110.053 94.4819C117.832 90.8176 119.246 81.1748 119.246 81.1748L114.875 77.3819L134.289 72.4962C136.41 71.7891 136.732 73.3962 136.346 74.2962Z"
            fill="#D01830"
          />
          <path
            d="M125.741 121.623C115.133 126.508 100.541 128.308 89.9977 128.308C79.4549 128.308 64.7977 126.508 54.2549 121.623L57.4049 112.43C65.1835 116.223 77.6549 118.665 89.9977 118.665C102.341 118.665 114.748 116.223 122.526 112.43L125.741 121.623Z"
            fill="#D01830"
          />
        </svg>
      );
    case 'SERGIO TACCHINI':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width || 180}
          height={width || 180}
          viewBox="0 0 180 180"
          fill="none"
        >
          <rect width="180" height="180" fill="white" />
          <path
            d="M52.0947 51.2229C65.192 38.1068 85.3289 32.8088 103.236 37.4331C118.214 41.0511 131.153 51.5723 138.326 65.1375C133.583 65.1957 128.856 65.1375 124.113 65.1375C121.867 58.3008 118.338 51.6222 112.564 47.1559C104.467 40.6934 93.4253 39.1132 83.44 40.5021C75.119 41.5917 67.1308 45.8085 62.1215 52.6036C57.961 57.9681 55.8225 64.5387 54.4163 71.0926C83.2653 71.0926 112.106 71.0926 140.955 71.0926C145.207 82.8863 145.332 95.7612 141.329 107.638C131.552 136 100.615 151.07 72.2399 141.289C52.4775 134.478 38.3733 116.945 35.9685 96.1937C41.7267 96.1937 47.4848 96.1937 53.2347 96.1937C53.6258 107.422 55.5396 119.357 62.8787 128.306C69.3192 136.449 80.0201 140.108 90.1717 139.842C100.498 140.042 111.34 136.091 117.673 127.633C125.827 117.07 126.976 103.072 126.634 90.2054H99.6494C99.7076 103.08 99.5329 115.989 99.7492 128.805C93.342 129.013 86.9598 128.872 80.5526 128.888C80.5526 115.997 80.5526 103.105 80.5526 90.2054C65.6164 90.2054 50.6884 90.2054 35.7605 90.2054C35.6274 75.5256 41.527 61.4281 52.0947 51.2229ZM53.659 76.8896C53.5758 79.3848 53.4427 81.9548 53.2596 84.4832C64.2767 84.5497 75.2771 84.4832 86.2775 84.4832C86.2775 97.2916 86.2775 110.1 86.2775 122.908H93.8995C93.8995 110.1 93.8995 97.2916 93.8995 84.4832C104.808 84.4832 115.717 84.4832 126.634 84.4832C126.535 81.988 126.393 79.3931 126.26 76.8564L53.659 76.8896Z"
            fill="black"
          />
        </svg>
      );
    case 'DUVETICA':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width || 180}
          height={width || 180}
          viewBox="0 0 180 180"
          fill="none"
        >
          <rect width="180" height="180" fill="black" />
          <path
            d="M63 129.597L75.8008 129.596H88.6015C108.548 129.808 117.493 120.492 116.979 100.06V83.5445C117.493 63.1123 108.445 53.6902 88.6015 54.0078H63V129.597ZM78.8339 116.681V66.9235H85.7226C97.6494 66.8176 100.94 70.5229 101.145 84.8149V98.7893C100.94 113.081 97.6494 116.787 85.7226 116.681H78.8339Z"
            fill="white"
          />
        </svg>
      );
    case 'close_small':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width || 9}
          height={height || 9}
          viewBox="0 0 9 9"
          fill="none"
          style={style}
        >
          <path
            d="M7.92871 0.428589L0.42882 7.92859"
            stroke={color || '#888D96'}
            strokeWidth="0.857143"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M0.428711 0.428589L7.9286 7.92859"
            stroke={color || '#888D96'}
            strokeWidth="0.857143"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'filter_settings':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width || 24}
          height={height || 24}
          viewBox="0 0 24 24"
          fill="none"
          style={style}
        >
          <g clipPath="url(#clip0_filter_settings)">
            <path
              d="M4 8H13"
              stroke={color || 'black'}
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M17 8L20 8"
              stroke={color || 'black'}
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11 16L20 16"
              stroke={color || 'black'}
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4 16H7"
              stroke={color || 'black'}
              strokeWidth="1.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <circle
              cx="9"
              cy="16"
              r="2"
              stroke={color || 'black'}
              strokeWidth="1.2"
            />
            <circle
              cx="15"
              cy="8"
              r="2"
              stroke={color || 'black'}
              strokeWidth="1.2"
            />
          </g>
          <defs>
            <clipPath id="clip0_filter_settings">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );
    case 'reset':
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M7.59961 0.600006C11.4656 0.600006 14.5996 3.73401 14.5996 7.60001C14.5996 11.466 11.4656 14.6 7.59961 14.6C3.73362 14.6 0.599609 11.466 0.599609 7.60001C0.599609 5.40102 1.61357 3.43886 3.19946 2.15556"
            stroke="black"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M0.599609 1.7666H3.71072V4.87771"
            stroke="black"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'menuOpen':
    default:
      return (
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17 23L23 16L17 9"
            stroke="#5F636B"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9 23L15 16L9 9"
            stroke="#5F636B"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
  }
};

export default SvgImage;
